import { r as x, h as r, c as L, d, H, g as $, K as we, L as pe, M as sn, O as xn, P as da, Q as xe, R as ca } from "./index-f8317a8e.js";
import { R as M } from "./register-component-b2a51b20-8a262dcf.js";
import { T as ln, F as dn, b as fa, P as ht, C as pa, E as cn, R as fn, c as ma, d as ua } from "./constants-67de2eec-b17f5b96.js";
import { s as qe } from "./index-6d9eeb53-c70fc8a7.js";
import "./index-53420959-9b1699ec.js";
import "react";
import "react-dom";
const ha = ".sc-calendar-agenda-fill-icon-h{display:flex}", ya = ha, ba = class {
  constructor(e) {
    x(this, e), this.width = "20", this.height = "20";
  }
  render() {
    return r("svg", { key: "1b157c16f504c8914c81d71a9c40c91f9c96632d", width: this.width, height: this.height, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, r("path", { key: "4c5bdf4bd6ff70e09c6677510d8e29a3433846ee", d: "M14 11.5C14 12.8807 12.8807 14 11.5 14H2.5C1.11929 14 0 12.8807 0 11.5V2.5C0 1.11929 1.11929 0 2.5 0H11.5C12.8807 0 14 1.11929 14 2.5V11.5ZM11 3.5C11 3.25454 10.8231 3.05039 10.5899 3.00806L10.5 3H3.5L3.41012 3.00806C3.17688 3.05039 3 3.25454 3 3.5C3 3.74546 3.17688 3.94961 3.41012 3.99194L3.5 4H10.5L10.5899 3.99194C10.8231 3.94961 11 3.74546 11 3.5ZM11 7C11 6.75454 10.8231 6.55039 10.5899 6.50806L10.5 6.5H3.5L3.41012 6.50806C3.17688 6.55039 3 6.75454 3 7C3 7.24546 3.17688 7.44961 3.41012 7.49194L3.5 7.5H10.5L10.5899 7.49194C10.8231 7.44961 11 7.24546 11 7ZM11 10.5C11 10.2545 10.8231 10.0504 10.5899 10.0081L10.5 10H3.5L3.41012 10.0081C3.17688 10.0504 3 10.2545 3 10.5C3 10.7455 3.17688 10.9496 3.41012 10.9919L3.5 11H10.5L10.5899 10.9919C10.8231 10.9496 11 10.7455 11 10.5Z", fill: "currentColor" }));
  }
};
ba.style = ya;
const ga = ".sc-calendar-agenda-icon-h{display:flex}", va = ga, _a = class {
  constructor(e) {
    x(this, e), this.width = "20", this.height = "20";
  }
  render() {
    return r("svg", { key: "eb527c787e9dc29d22cb8904ac8e19a2ed337ba1", width: this.width, height: this.height, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, r("path", { key: "26b06beae8f75f506cd5cf16351af85d814f7727", d: "M14 11.5C14 12.8807 12.8807 14 11.5 14H2.5C1.11929 14 0 12.8807 0 11.5V2.5C0 1.11929 1.11929 0 2.5 0H11.5C12.8807 0 14 1.11929 14 2.5V11.5ZM13 11.5V2.5C13 1.67157 12.3284 1 11.5 1H2.5C1.67157 1 1 1.67157 1 2.5V11.5C1 12.3284 1.67157 13 2.5 13H11.5C12.3284 13 13 12.3284 13 11.5ZM11 3.5C11 3.74546 10.8231 3.94961 10.5899 3.99194L10.5 4H3.5C3.22386 4 3 3.77614 3 3.5C3 3.25454 3.17688 3.05039 3.41012 3.00806L3.5 3H10.5C10.7761 3 11 3.22386 11 3.5ZM11 7C11 7.24546 10.8231 7.44961 10.5899 7.49194L10.5 7.5H3.5C3.22386 7.5 3 7.27614 3 7C3 6.75454 3.17688 6.55039 3.41012 6.50806L3.5 6.5H10.5C10.7761 6.5 11 6.72386 11 7ZM11 10.5C11 10.7455 10.8231 10.9496 10.5899 10.9919L10.5 11H3.5C3.22386 11 3 10.7761 3 10.5C3 10.2545 3.17688 10.0504 3.41012 10.0081L3.5 10H10.5C10.7761 10 11 10.2239 11 10.5Z", fill: "currentColor" }));
  }
};
_a.style = va;
const Ca = ".sc-calendar-info-icon-h{display:flex}", wa = Ca, xa = class {
  constructor(e) {
    x(this, e), this.width = "20", this.height = "20";
  }
  render() {
    return r("svg", { key: "9012ae7b873d35927c299ed62d247b77757bb679", width: this.width, height: this.height, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, r("path", { key: "0a3a11d84c99d05ad964d3b5606c072dd31872a7", d: "M12 0C13.3807 0 14.5 1.11929 14.5 2.5V6.59971C14.1832 6.43777 13.8486 6.30564 13.5 6.20703V4H1.5V11.5C1.5 12.3284 2.17157 13 3 13H6.70703C6.80564 13.3486 6.93777 13.6832 7.09971 14H3C1.61929 14 0.5 12.8807 0.5 11.5V2.5C0.5 1.11929 1.61929 0 3 0H12ZM12 1H3C2.17157 1 1.5 1.67157 1.5 2.5V3H13.5V2.5C13.5 1.67157 12.8284 1 12 1ZM11.375 9.5C11.375 9.15482 11.6548 8.875 12 8.875C12.3452 8.875 12.625 9.15482 12.625 9.5C12.625 9.84518 12.3452 10.125 12 10.125C11.6548 10.125 11.375 9.84518 11.375 9.5ZM12.5 13.5C12.5 13.7761 12.2761 14 12 14C11.7239 14 11.5 13.7761 11.5 13.5V11.5C11.5 11.2239 11.7239 11 12 11C12.2761 11 12.5 11.2239 12.5 11.5V13.5ZM7.5 11.5C7.5 9.01472 9.51472 7 12 7C14.4853 7 16.5 9.01472 16.5 11.5C16.5 13.9853 14.4853 16 12 16C9.51472 16 7.5 13.9853 7.5 11.5ZM8.5 11.5C8.5 13.433 10.067 15 12 15C13.933 15 15.5 13.433 15.5 11.5C15.5 9.567 13.933 8 12 8C10.067 8 8.5 9.567 8.5 11.5Z", fill: "currentColor" }));
  }
};
xa.style = wa;
const ka = ".sc-calendar-patterns-icon-h{display:flex}", Ea = ka, Da = class {
  constructor(e) {
    x(this, e), this.width = "20", this.height = "20";
  }
  render() {
    return r("svg", { key: "ca6df3db90bbbffc29dfdc6ee5a440266eaa153d", width: this.width, height: this.height, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, r("path", { key: "ab45118ff407127ca1673159e1b78c93c7c97bed", d: "M3.25 0H11.75C13.2688 0 14.5 1.23122 14.5 2.75V11.25C14.5 12.7688 13.2688 14 11.75 14H3.25C1.73122 14 0.5 12.7688 0.5 11.25V2.75C0.5 1.23122 1.73122 0 3.25 0ZM2 2.75V4H13V2.75C13 2.05964 12.4404 1.5 11.75 1.5H3.25C2.55964 1.5 2 2.05964 2 2.75ZM12.2071 5L8.20711 9H10.7929L13 6.79289V5H12.2071ZM10.7929 5H8.20711L4.20711 9H6.79289L10.7929 5ZM2.79289 9L6.79289 5H4.20711L2 7.20711V9H2.79289ZM2 5.79289L2.79289 5H2V5.79289ZM12.2071 9H13V8.20711L12.2071 9Z", fill: "currentColor" }));
  }
};
Da.style = Ea;
const Sa = ".sc-dragable-icon-h{display:flex}", Oa = Sa, Ta = class {
  constructor(e) {
    x(this, e), this.width = "20", this.height = "20";
  }
  render() {
    return r("svg", { key: "53baa6340f5b9f21176622eb19caf974ab214f7b", width: this.width, height: this.height, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, r("path", { key: "a7e0a0fe1bd2159dc62e91db3cd147fa1086a8ba", d: "M15.5 18C16.3284 18 17 18.6716 17 19.5C17 20.3284 16.3284 21 15.5 21C14.6716 21 14 20.3284 14 19.5C14 18.6716 14.6716 18 15.5 18ZM8.5 18C9.32843 18 10 18.6716 10 19.5C10 20.3284 9.32843 21 8.5 21C7.67157 21 7 20.3284 7 19.5C7 18.6716 7.67157 18 8.5 18ZM15.5 11C16.3284 11 17 11.6716 17 12.5C17 13.3284 16.3284 14 15.5 14C14.6716 14 14 13.3284 14 12.5C14 11.6716 14.6716 11 15.5 11ZM8.5 11C9.32843 11 10 11.6716 10 12.5C10 13.3284 9.32843 14 8.5 14C7.67157 14 7 13.3284 7 12.5C7 11.6716 7.67157 11 8.5 11ZM15.5 4C16.3284 4 17 4.67157 17 5.5C17 6.32843 16.3284 7 15.5 7C14.6716 7 14 6.32843 14 5.5C14 4.67157 14.6716 4 15.5 4ZM8.5 4C9.32843 4 10 4.67157 10 5.5C10 6.32843 9.32843 7 8.5 7C7.67157 7 7 6.32843 7 5.5C7 4.67157 7.67157 4 8.5 4Z", fill: "currentColor" }));
  }
};
Ta.style = Oa;
const Ia = ".sc-envelope-fill-icon-h{display:flex}", Ha = Ia, $a = class {
  constructor(e) {
    x(this, e), this.width = "16", this.height = "13";
  }
  render() {
    return r("svg", { key: "4e7a2014cbac9968311230fcf5a3e4fc16e091a3", width: "16", height: "13", viewBox: "0 0 16 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, r("path", { key: "db183f6e591aa85a8c40f07da4ceb6c863e44d75", d: "M16.0001 3.373V10.5C16.0001 11.8807 14.8808 13 13.5001 13H2.50008C1.11937 13 0 11.8807 0 10.5V3.373L7.74657 7.93097C7.90304 8.02301 8.09711 8.02301 8.25359 7.93097L16.0001 3.373ZM13.5001 0C14.7871 0 15.847 0.972604 15.9849 2.22293L8.00008 6.91991L0.0152595 2.22293C0.153116 0.972604 1.21302 0 2.50008 0H13.5001Z", fill: "currentColor" }));
  }
};
$a.style = Ha;
const Ma = ".sc-envelope-icon-h{display:flex}", Pa = Ma, Na = class {
  constructor(e) {
    x(this, e), this.width = "16", this.height = "13";
  }
  render() {
    return r("svg", { key: "ae86025b07c08ee063d4559e7be04c567876a78a", width: "16", height: "13", viewBox: "0 0 16 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, r("path", { key: "6987fa65165dd0289ef1a91f74c293ca8c4ab1c0", d: "M13.5 0C14.8807 0 16 1.11929 16 2.5V10.5C16 11.8807 14.8807 13 13.5 13H2.5C1.11929 13 0 11.8807 0 10.5V2.5C0 1.11929 1.11929 0 2.5 0H13.5ZM15 3.961L8.25351 7.93097C8.12311 8.00767 7.96661 8.02045 7.82751 7.96932L7.74649 7.93097L1 3.963V10.5C1 11.3284 1.67157 12 2.5 12H13.5C14.3284 12 15 11.3284 15 10.5V3.961ZM13.5 1H2.5C1.67157 1 1 1.67157 1 2.5V2.802L8 6.91991L15 2.801V2.5C15 1.67157 14.3284 1 13.5 1Z", fill: "currentColor" }));
  }
};
Na.style = Pa;
const La = ".sc-flow-icon-h{display:flex}", Fa = La, Ra = class {
  constructor(e) {
    x(this, e), this.width = "16", this.height = "12";
  }
  render() {
    return r("svg", { key: "e3ed271c0263b8684e328edfe7bb88227172bdeb", width: this.width, height: this.height, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, r("path", { key: "76bf122906d6f364912c9b028929bbbbd70b9370", d: "M13 1.66211C11.8954 1.66211 11 2.55754 11 3.66211C11 4.76668 11.8954 5.66211 13 5.66211C14.1046 5.66211 15 4.76668 15 3.66211C15 2.55754 14.1046 1.66211 13 1.66211ZM10.0407 3.16678C10.2768 1.74563 11.5119 0.662109 13 0.662109C14.6569 0.662109 16 2.00526 16 3.66211C16 5.31896 14.6569 6.66211 13 6.66211C11.5162 6.66211 10.2839 5.58482 10.0428 4.16971C9.37629 4.23688 8.82682 4.7426 8.71466 5.41551L8.27173 8.07311C8.07929 9.22776 7.11428 10.087 5.9593 10.1574C5.72319 11.5786 4.48813 12.6621 3 12.6621C1.34315 12.6621 0 11.319 0 9.66211C0 8.00526 1.34315 6.66211 3 6.66211C4.48384 6.66211 5.71607 7.73939 5.95724 9.15451C6.62371 9.08734 7.17318 8.58162 7.28534 7.90871L7.72827 5.25111C7.92071 4.09646 8.88571 3.23718 10.0407 3.16678ZM3 7.66211C1.89543 7.66211 1 8.55754 1 9.66211C1 10.7667 1.89543 11.6621 3 11.6621C4.10457 11.6621 5 10.7667 5 9.66211C5 8.55754 4.10457 7.66211 3 7.66211Z", fill: "currentColor" }));
  }
};
Ra.style = Fa;
const Aa = ".sc-google-meet-icon-h{display:flex}", za = Aa, ja = class {
  constructor(e) {
    x(this, e), this.width = "20", this.height = "20";
  }
  render() {
    return r("svg", { key: "f46658df728c54f4e6fad98889bd9817b4cc9cf2", width: this.width, height: this.height, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, r("g", { key: "a0a4b3529e31e31975fb63a224ce7906cff5c555", "clip-path": "url(#clip0_22_6251)" }, r("path", { key: "ce0c0b99418930ac45f10351bf8d229d7e0b82fd", d: "M11.3145 10.1036L13.2642 12.3321L15.8859 14.0076L16.343 10.1173L15.8859 6.31384L13.2139 7.78584L11.3145 10.1036Z", fill: "#00832D" }), r("path", { key: "e295056233a2f840e2e1c313ec8ac0a8bcab8c53", d: "M0 13.6464V16.9607C0 17.7184 0.613714 18.3321 1.37143 18.3321H4.68571L5.37143 15.827L4.68571 13.6464L2.41143 12.9607L0 13.6464Z", fill: "#0066DA" }), r("path", { key: "383e8f67b190fa9263added2021dfb64989f402a", d: "M4.68571 1.875L0 6.56071L2.41143 7.24643L4.68571 6.56071L5.36 4.40986L4.68571 1.875Z", fill: "#E94235" }), r("path", { key: "5f7b539ac4d5c9e038ee6ec543277147b382ff7f", d: "M4.68571 6.56067H0V13.6464H4.68571V6.56067Z", fill: "#2684FC" }), r("path", { key: "8fa4b92e953f58a1631b213f737e54f0024ad930", d: "M18.8798 3.85895L15.8855 6.31381V14.0075L18.8935 16.4738C19.3438 16.8258 20.0021 16.5047 20.0021 15.9321V4.38923C20.0021 3.80981 19.329 3.49209 18.8798 3.85895ZM11.3141 10.1035V13.6464H4.68555V18.3321H14.5141C15.2718 18.3321 15.8855 17.7184 15.8855 16.9607V14.0075L11.3141 10.1035Z", fill: "#00AC47" }), r("path", { key: "670cf97198c3b3c70dcfaa969e4e0505f693c4f1", d: "M14.5141 1.875H4.68555V6.56071H11.3141V10.1036L15.8855 6.31614V3.24643C15.8855 2.48871 15.2718 1.875 14.5141 1.875Z", fill: "#FFBA00" })), r("defs", { key: "f8440aa8445976b8e29de3fb0c19527a5d01cdad" }, r("clipPath", { key: "e29ba8a0946f8a49cef9824e44842dfeacaacfc7", id: "clip0_22_6251" }, r("rect", { key: "8b72e22faf115d1b56fc421da1c1f7a510005f31", width: "20", height: "20", fill: "white" }))));
  }
};
ja.style = za;
const Ba = ".sc-location-icon-h{display:flex}", Wa = Ba, Za = class {
  constructor(e) {
    x(this, e), this.width = "16", this.height = "18";
  }
  render() {
    return r("svg", { key: "420070485c2ee644a8ffb71cfce0c9787545b5ea", width: this.width, height: this.height, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, r("path", { key: "0d98ed4e7058582c7351664d3e3dc6e2ac0a386c", d: "M10 7.66211C10 9.31896 8.65685 10.6621 7 10.6621C5.34315 10.6621 4 9.31896 4 7.66211C4 6.00526 5.34315 4.66211 7 4.66211C8.65685 4.66211 10 6.00526 10 7.66211ZM9 7.66211C9 6.55754 8.10457 5.66211 7 5.66211C5.89543 5.66211 5 6.55754 5 7.66211C5 8.76668 5.89543 9.66211 7 9.66211C8.10457 9.66211 9 8.76668 9 7.66211ZM11.9497 12.6171C14.6834 9.88221 14.6834 5.44812 11.9497 2.71326C9.21608 -0.0216067 4.78392 -0.0216067 2.05025 2.71326C-0.683418 5.44812 -0.683418 9.88221 2.05025 12.6171L3.57128 14.1159L5.61408 16.101L5.74691 16.2188C6.52168 16.8468 7.65623 16.8076 8.38611 16.1012L10.8223 13.7312L11.9497 12.6171ZM2.75499 3.4183C5.09944 1.07282 8.90055 1.07282 11.245 3.4183C13.5294 5.70364 13.5879 9.3725 11.4207 11.7288L11.245 11.912L9.92371 13.216L7.69315 15.3846L7.60016 15.4642C7.24594 15.732 6.7543 15.732 6.40012 15.4642L6.30713 15.3845L3.3263 12.4791L2.75499 11.912L2.57927 11.7288C0.412077 9.3725 0.47065 5.70364 2.75499 3.4183Z", fill: "currentColor" }));
  }
};
Za.style = Wa;
const Ua = ".sc-location-off-icon-h{display:flex}", Va = Ua, qa = class {
  constructor(e) {
    x(this, e), this.width = "16", this.height = "18";
  }
  render() {
    return r("svg", { key: "d112ae6fcab775b22db431471e6527b6170a15e2", width: this.width, height: this.height, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, r("path", { key: "bc07686ee41027dbfe93a4fac5d367237abac475", d: "M0.146447 0.808556C0.341709 0.613294 0.658291 0.613294 0.853553 0.808556L15.8536 15.8086C16.0488 16.0038 16.0488 16.3204 15.8536 16.5157C15.6583 16.7109 15.3417 16.7109 15.1464 16.5157L12.0938 13.463L11.8223 13.7312L9.38611 16.1012C8.65623 16.8076 7.52168 16.8468 6.74691 16.2188L6.61408 16.101L4.57128 14.1159L3.05025 12.6171C0.607421 10.1732 0.347525 6.37239 2.27056 3.63976L0.146447 1.51566C-0.0488155 1.3204 -0.0488155 1.00382 0.146447 0.808556ZM9.07768 10.4469C8.74346 10.576 8.38024 10.6468 8.0005 10.6468C6.34839 10.6468 5.00909 9.30689 5.00909 7.65406C5.00909 7.27461 5.07967 6.91166 5.20843 6.57763L2.98793 4.35713C1.49206 6.62038 1.68917 9.67377 3.57927 11.7288L3.75499 11.912L4.3263 12.4791L7.30713 15.3845L7.40012 15.4642C7.7543 15.732 8.24594 15.732 8.60016 15.4642L8.69315 15.3846L10.9237 13.216L11.3883 12.7575L9.07768 10.4469ZM9.85409 8.39486L10.5983 9.13904C10.8487 8.70143 10.9919 8.19447 10.9919 7.65406C10.9919 6.00122 9.65261 4.66134 8.0005 4.66134C7.45986 4.66134 6.95271 4.80482 6.51504 5.05581L7.25921 5.79998C7.48839 5.70819 7.73855 5.6577 8.0005 5.6577C9.10258 5.6577 9.99599 6.5515 9.99599 7.65406C9.99599 7.91581 9.94564 8.16581 9.85409 8.39486ZM4.35291 2.89368C6.70671 1.08827 10.0908 1.26314 12.245 3.4183C14.3986 5.57283 14.5739 8.95702 12.771 11.3118L13.4812 12.022C15.6702 9.27273 15.493 5.25762 12.9497 2.71326C10.4058 0.168159 6.39081 -0.00843871 3.64269 2.18347L4.35291 2.89368Z", fill: "currentColor" }));
  }
};
qa.style = Va;
const Ga = ".sc-microsoft-teams-icon-h{display:flex}", Ya = Ga, Ja = class {
  constructor(e) {
    x(this, e), this.width = "20", this.height = "20";
  }
  render() {
    return r("svg", { key: "69523ba993f618ec6e2eb721357e9361046c7d03", width: this.width, height: this.height, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, r("g", { key: "e9bce0581a02c12074c7e9c0ef7fc8e56a4d65d0", "clip-path": "url(#clip0_22_6280)" }, r("path", { key: "49910ab6ce1becf96ba9abed6835bc80d9877d20", d: "M13.7109 7.60168H18.8769C19.365 7.60168 19.7607 7.99734 19.7607 8.4854V13.191C19.7607 14.9848 18.3065 16.4389 16.5127 16.4389H16.4974C14.7036 16.4391 13.2493 14.9852 13.249 13.1914C13.249 13.1913 13.249 13.1911 13.249 13.191V8.06355C13.249 7.80847 13.4558 7.60168 13.7109 7.60168Z", fill: "#5059C9" }), r("path", { key: "a9f99a3fb852e52e789ca3ded4e82f193fca0cc4", d: "M17.2024 6.67152C18.3583 6.67152 19.2954 5.73444 19.2954 4.5785C19.2954 3.42255 18.3583 2.48547 17.2024 2.48547C16.0465 2.48547 15.1094 3.42255 15.1094 4.5785C15.1094 5.73444 16.0465 6.67152 17.2024 6.67152Z", fill: "#5059C9" }), r("path", { key: "8796ab21c754b4b1f1ef31a27acf764085624c2a", d: "M10.6912 6.67152C12.3609 6.67152 13.7145 5.31796 13.7145 3.64826C13.7145 1.97856 12.3609 0.625 10.6912 0.625C9.02153 0.625 7.66797 1.97856 7.66797 3.64826C7.66797 5.31796 9.02153 6.67152 10.6912 6.67152Z", fill: "#7B83EB" }), r("path", { key: "c97eeaa8011f9d12c2ac60aa24cc915a28c2c639", d: "M14.7223 7.60168H6.19482C5.71257 7.61362 5.33108 8.01384 5.34227 8.49611V13.8631C5.27492 16.7571 7.56457 19.1588 10.4586 19.2296C13.3525 19.1588 15.6422 16.7571 15.5748 13.8631V8.49611C15.586 8.01384 15.2045 7.61362 14.7223 7.60168Z", fill: "#7B83EB" }), r("path", { key: "8c4f1dce9ae504080def1608f5bef793925313ac", opacity: "0.1", d: "M10.9234 7.60168V15.1226C10.9211 15.4675 10.7121 15.7773 10.3932 15.9087C10.2917 15.9516 10.1825 15.9738 10.0723 15.9738H5.75134C5.69088 15.8203 5.63507 15.6668 5.58855 15.5087C5.42574 14.975 5.34267 14.4201 5.34204 13.8622V8.49471C5.33086 8.01321 5.71172 7.61362 6.1932 7.60168H10.9234Z", fill: "black" }), r("path", { key: "09f2ac22823060680ad6b00143c7ed44f8bfdf2d", opacity: "0.2", d: "M10.4583 7.60168V15.5877C10.4583 15.698 10.4362 15.8071 10.3932 15.9087C10.2619 16.2276 9.95205 16.4366 9.60717 16.4389H5.96995C5.89088 16.2854 5.81646 16.1319 5.75134 15.9738C5.68623 15.8156 5.63507 15.6668 5.58855 15.5087C5.42574 14.975 5.34267 14.4201 5.34204 13.8622V8.49471C5.33086 8.01321 5.71172 7.61362 6.1932 7.60168H10.4583Z", fill: "black" }), r("path", { key: "12b208fc1f34d24bc6ca7acafade515e67b89277", opacity: "0.2", d: "M10.4583 7.60168V14.6575C10.4548 15.1261 10.0758 15.5051 9.60716 15.5087H5.58855C5.42574 14.975 5.34267 14.4201 5.34204 13.8622V8.49471C5.33086 8.01321 5.71172 7.61362 6.1932 7.60168H10.4583Z", fill: "black" }), r("path", { key: "b4ea917286bbed9e6847c7511527dd1c78012e99", opacity: "0.2", d: "M9.9932 7.60168V14.6575C9.98965 15.1261 9.61065 15.5051 9.14203 15.5087H5.58855C5.42574 14.975 5.34267 14.4201 5.34204 13.8622V8.49471C5.33086 8.01321 5.71172 7.61362 6.1932 7.60168H9.9932Z", fill: "black" }), r("path", { key: "2765f6abbd7df07ab84aef1d6182276fce0129c2", opacity: "0.1", d: "M10.9241 5.1971V6.66222C10.845 6.66687 10.7706 6.67152 10.6915 6.67152C10.6124 6.67152 10.538 6.66687 10.4589 6.66222C10.3019 6.6518 10.1462 6.62689 9.99382 6.5878C9.05195 6.36475 8.27382 5.70421 7.90079 4.81106C7.83661 4.66107 7.78678 4.50533 7.75195 4.34595H10.0729C10.5422 4.34772 10.9223 4.72775 10.9241 5.1971Z", fill: "black" }), r("path", { key: "fe9e83a0fe60a9abd03535450b4ce2612039caa7", opacity: "0.2", d: "M10.4585 5.66219V6.66219C10.3015 6.65177 10.1458 6.62686 9.99341 6.58778C9.05155 6.36473 8.27342 5.70418 7.90039 4.81104H9.60736C10.0767 4.81281 10.4567 5.19285 10.4585 5.66219Z", fill: "black" }), r("path", { key: "85020f2b48d1588f41e8d85d134526eb12d75a58", opacity: "0.2", d: "M10.4585 5.66219V6.66219C10.3015 6.65177 10.1458 6.62686 9.99341 6.58778C9.05155 6.36473 8.27342 5.70418 7.90039 4.81104H9.60736C10.0767 4.81281 10.4567 5.19285 10.4585 5.66219Z", fill: "black" }), r("path", { key: "9eb9e9f89a41524207aafa642927b4b561ff27b0", opacity: "0.2", d: "M9.99341 5.6622V6.58778C9.05155 6.36473 8.27342 5.70418 7.90039 4.81104H9.14225C9.6116 4.81282 9.99163 5.19286 9.99341 5.6622Z", fill: "black" }), r("path", { key: "6f7a8069ada101aa3222cc6d7ddbb184da5428ba", d: "M0.613296 4.81104H9.14074C9.61159 4.81104 9.99329 5.19274 9.99329 5.66359V14.191C9.99329 14.6619 9.61158 15.0436 9.14074 15.0436H0.613296C0.14244 15.0436 -0.239258 14.6619 -0.239258 14.191V5.66359C-0.239258 5.19274 0.142449 4.81104 0.613296 4.81104Z", fill: "url(#paint0_linear_22_6280)" }), r("path", { key: "e12dea284257b92587339229fd46430aba7c574b", d: "M7.12025 8.05659H5.4156V12.6985H4.32956V8.05659H2.63281V7.15613H7.12025V8.05659Z", fill: "white" })), r("defs", { key: "11e86da96dddc05b71a8d41885457fbda07fddc7" }, r("linearGradient", { key: "c8f5d43e188b1b852b8b3510def8b93fa33ebd61", id: "paint0_linear_22_6280", x1: "1.53835", y1: "4.14486", x2: "8.2157", y2: "15.7098", gradientUnits: "userSpaceOnUse" }, r("stop", { key: "422c30344487fdca1a59c4560508303225c3cdd3", "stop-color": "#5A62C3" }), r("stop", { key: "e2a65b6092a9033e54fff76ccee016d4d4dc3768", offset: "0.5", "stop-color": "#4D55BD" }), r("stop", { key: "c4ddcae999b815fd38cc90df9f504a8ec7412a0c", offset: "1", "stop-color": "#3940AB" })), r("clipPath", { key: "b9ef76b6fff59aa6eb6cc0804acc6f5cc6a9f371", id: "clip0_22_6280" }, r("rect", { key: "42931886765c99e0edc80f863fa88c992fe56db8", width: "20", height: "20", fill: "white" }))));
  }
};
Ja.style = Ya;
const Xa = ':host{display:block;margin:1rem;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif}.nylas-additional-participants__title{color:var(--nylas-base-nylas-base-900-aaa, #101323);font-size:16px;font-style:normal;font-weight:600;line-height:20px;margin:0;text-align:left}.nylas-additional-participants__subtitle{color:var(--nylas-base-600);font-size:14px;font-style:normal;font-weight:400;line-height:20px;margin:0.25rem 0px 0px;text-align:left}.nylas-additional-participants__content{padding:1rem;display:flex;flex-direction:column;gap:1rem}.nylas-additional-participants__input_group{padding-top:8px;display:flex;flex-direction:column;gap:4px}.nylas-additional-participants__input_group label{display:flex;align-items:center;color:var(--nylas-base-800);font-size:14px;font-style:normal;font-weight:400;line-height:150%}.nylas-additional-participants__error{color:var(--nylas-error);font-size:14px;font-family:var(--nylas-font-family);font-weight:400;line-height:16px;margin:0;text-align:left}.nylas-additional-participants__input_wrapper{display:flex;border-width:1;border-radius:8px;border:1px solid var(--nylas-base-300)}.nylas-additional-participants__input_wrapper.error{border-color:var(--nylas-error)}.nylas-additional-participants__input_wrapper button{padding:12px;border:none;border-left:1px solid var(--nylas-base-300);background:none;cursor:pointer}.nylas-additional-participants__input_wrapper button:hover,.nylas-additional-participants__input_wrapper button:active{color:var(--nylas-primary)}.nylas-additional-participants__input_wrapper_organizer{border:none}.nylas-additional-participants__input{flex:1;display:flex;justify-content:space-between}.nylas-additional-participants__input input{border:none;outline:none;background:none;width:100%}.nylas-additional-participants__input input-dropdown{width:100%}.nylas-additional-participants__input input-dropdown::part(id_dropdown){width:100%;height:100%}.nylas-additional-participants__input input-dropdown::part(id_dropdown-input){height:100%;border-radius:var(--nylas-border-radius-2x);border:none;border-top-right-radius:initial;border-bottom-right-radius:initial;padding-left:16px}.nylas-additional-participants__input input-component::part(ic__input){background:var(--nylas-base-50)}.nylas-additional-participants__input input-component::part(ic__label){font-size:14px}.nylas-additional-participants__input input-component div.required-input{display:flex;gap:4px}.nylas-additional-participants__input input-component div.required-input label{display:flex;gap:4px;align-items:center}.nylas-additional-participants__input input-component div.required-input label tooltip-component#organizer_participant_tooltip::part(tc__content){left:-84px}.nylas-additional-participants__add{padding:12px;display:flex;align-items:center;border:none;background:none;cursor:pointer}.nylas-additional-participants__add span{padding:0 8px;font-size:16px;font-style:normal;font-weight:500}.nylas-additional-participants__add:hover,.nylas-additional-participants__add:active{color:var(--nylas-primary)}', Ka = Xa;
var Qa = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, yt = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const kn = class {
  constructor(e) {
    var t, n, a;
    x(this, e), this.valueChanged = L(this, "valueChanged", 7), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals), this.selectedConfiguration = void 0, this.currentUser = void 0, this.name = "participants", this.eventParticipants = void 0, this.participantOptions = void 0, this.participants = this.eventParticipants ?? [], this.participantErrors = {}, this.includeOrganizerAsParticipant = !0, this.isRoundRobinConfig = ((a = (n = (t = this.selectedConfiguration) == null ? void 0 : t.availability) == null ? void 0 : n.availability_rules) == null ? void 0 : a.availability_method) !== "collective", this.error = "";
  }
  elementNameChangedHandler(e) {
    d("nylas-additional-participants", "elementNameChangedHandler", e), this.host.setAttribute("name", e);
  }
  connectedCallback() {
    d("nylas-additional-participants", "connectedCallback");
  }
  componentWillLoad() {
    d("nylas-additional-participants", "componentWillLoad"), this.host.setAttribute("name", this.name);
  }
  componentDidLoad() {
    var t, n, a, o, i, s;
    d("nylas-additional-participants", "componentDidLoad"), this.isRoundRobinConfig = ((a = (n = (t = this.selectedConfiguration) == null ? void 0 : t.availability) == null ? void 0 : n.availability_rules) == null ? void 0 : a.availability_method) !== "collective", this.includeOrganizerAsParticipant = !!(this.isRoundRobinConfig && this.participants.find((l) => {
      var c;
      return l.email === ((c = this.currentUser) == null ? void 0 : c.email);
    }));
    const e = this.participants.find((l) => {
      var c;
      return l.email === ((c = this.currentUser) == null ? void 0 : c.email);
    });
    this.isRoundRobinConfig && !e && ((o = this.currentUser) != null && o.email) && (this.participants = [
      {
        name: (i = this.currentUser) == null ? void 0 : i.name,
        email: (s = this.currentUser) == null ? void 0 : s.email,
        is_organizer: !0,
        availability: {
          calendar_ids: ["primary"]
        },
        booking: {
          calendar_id: "primary"
        }
      },
      ...this.participants
    ]), this.updateFormValue();
  }
  disconnectedCallback() {
    d("nylas-additional-participants", "disconnectedCallback");
  }
  onInputOptionChanged(e) {
    var o;
    d("nylas-additional-participants", "onInputOptionChanged");
    const t = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, n = e.detail.name, a = (o = this.participantOptions) == null ? void 0 : o.find((i) => i.email === e.detail.value);
    if (!a && !t.test(e.detail.value)) {
      this.internals.setValidity({ customError: !0 }, "Please enter a valid email address"), this.participantErrors[n] = "Please enter a valid email address", this.participants[n].is_valid = !1, this.participants = [...this.participants];
      return;
    } else
      this.participantErrors[n] = "", this.participants[n].is_valid = !0, this.internals.setValidity({});
    this.participants[n].email = e.detail.value, this.participants[n].availability = a ? { calendar_ids: ["primary"] } : void 0, this.participants[n].booking = a && this.isRoundRobinConfig ? { calendar_id: "primary" } : void 0, this.participants[n].name = (a == null ? void 0 : a.name) || e.detail.value, this.participants = [...this.participants], this.updateFormValue();
  }
  addParticipant() {
    d("nylas-additional-participants", "addParticipant"), this.participants = [...this.participants, { name: "", email: "", is_organizer: !1 }], this.updateFormValue();
  }
  removeParticipant(e) {
    d("nylas-additional-participants", "removeParticipant"), this.participants = this.participants.filter((t, n) => n !== e), this.updateFormValue();
  }
  validate(e, t) {
    d("nylas-additional-participants", "validate");
    const a = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(e).toLowerCase());
    this.participants[t].is_valid = a, this.updateFormValue();
  }
  updateFormValue() {
    d("nylas-additional-participants", "updateFormValue");
    const e = this.isRoundRobinConfig ? this.includeOrganizerAsParticipant ? this.participants : this.participants.filter((t) => !t.is_organizer) : this.participants;
    e.length === 0 ? (this.internals.setValidity({ customError: !0 }, "Please add at least one participant"), this.error = "Please add at least one participant") : (this.internals.setValidity({}), this.error = "", this.internals.setFormValue(JSON.stringify(e), this.name), this.valueChanged.emit({ value: JSON.stringify(e), name: this.name }));
  }
  getArrayDifference(e, t) {
    return e.filter((a) => !t.some((o) => a.email === o.email)).map((a) => ({ value: a.email, label: a.email }));
  }
  render() {
    return r(H, { key: "2b2f17240b40e9d6195b3e12f84f6ac8f7c8fb2c" }, r("nylas-form-card", { key: "15132c328abfaa5d3d58fe7df7113e62129c0bf0" }, r("h3", { key: "5fc5d18469930d97b9a6e014a9a4c894afb00321", slot: "header-title", class: "nylas-additional-participants__title", part: "nap__title" }, "Participants"), r("p", { key: "3ea8ebacb9d8bd5ad3bd0cbea0c3cbc527fcb7e0", slot: "header-subtitle", class: "nylas-additional-participants__subtitle", part: "nap__subtitle" }, "Add people in your team or organization to join the event."), r("div", { key: "1980662b83cd2b3fd17b94bb6c4ec754b4214834", slot: "content", class: "nylas-additional-participants__content" }, r("div", { key: "ffeb607b0c5be80bf75a82d3fd0608a4ba86f07d" }, this.participants.map((e, t) => r("div", { class: "nylas-additional-participants__input_group", part: "nap__input_group" }, !e.is_organizer && r("label", null, `Participant ${t}`), r("div", { part: "nap__input_wrapper", class: {
      "nylas-additional-participants__input_wrapper": !0,
      "nylas-additional-participants__input_wrapper_organizer": e.is_organizer,
      "nylas-additional-participants__input_wrapper_invalid": e.is_valid === !1,
      error: e.is_valid === !1
    } }, r("div", { class: { "nylas-additional-participants__input": !0, organizer: e.is_organizer }, part: "nap__input" }, e.is_organizer ? r("input-component", { class: "label-input", name: `${t}`, key: t, label: "Organizer", required: !1, readOnly: e.is_organizer, defaultValue: e.email }, this.isRoundRobinConfig && r("div", { class: "required-input", slot: "additional-input" }, r("input", { type: "checkbox", name: "organizer_participant", id: "organizer_participant", onClick: () => {
      this.includeOrganizerAsParticipant = !this.includeOrganizerAsParticipant, this.updateFormValue();
    }, checked: this.includeOrganizerAsParticipant }), r("label", { htmlFor: "organizer_participant", "aria-label": "Include as participant" }, "Participant", r("tooltip-component", { id: "organizer_participant_tooltip" }, r("info-icon", { slot: "tooltip-icon" }), r("span", { slot: "tooltip-content" }, r("strong", null, "Include Organizer:"), " The organizer (you) will be included in the round-robin rotation. ", r("br", null), r("strong", null, "Exclude Organizer:"), " The organizer (you) will not be included in the round-robin rotation."))))) : r("input-dropdown", { name: `${t}`, filterable: !0, inputValue: e.email, options: this.getArrayDifference(this.participantOptions || [], this.participants) }), !e.is_organizer && r("button", { onClick: () => this.removeParticipant(t), part: "nap__remove-participant" }, r("close-icon", null)))), !e.is_valid && r("p", { class: "nylas-additional-participants__error", part: "nap__error" }, this.participantErrors[t]))), r("p", { key: "a524ed922e4725c06349f1cef10a8b3bab8aa057", class: "nylas-additional-participants__error", part: "nap__error" }, this.error)), r("button", { key: "30e19e8850b22920ac52ad0918f95c1a8ed96b12", class: "nylas-additional-participants__add", part: "nap__add-participant", onClick: () => this.addParticipant() }, r("add-circle-icon", { key: "b3ff2fa4becb2217f0c4535d55ce0038355cbb2e" }), " ", r("span", { key: "00869f58c554782cd3b1c84aab49b6d212c0a4a3" }, "Add ", this.participants.length > 1 ? "another" : "a", " participant")))));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return $(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"]
    };
  }
};
Qa([
  M({
    name: "nylas-additional-participants",
    stateToProps: /* @__PURE__ */ new Map([
      ["schedulerConfig.additionalParticipants", "participantOptions"],
      ["schedulerConfig.selectedConfiguration", "selectedConfiguration"],
      ["schedulerConfig.currentUser", "currentUser"]
    ]),
    eventToProps: {},
    fireRegisterEvent: !0
  }),
  yt("design:type", Function),
  yt("design:paramtypes", []),
  yt("design:returntype", void 0)
], kn.prototype, "render", null);
kn.style = Ka;
const ei = ':host{display:block;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif;width:inherit}.nylas-availability-picker{width:inherit;display:flex;flex-direction:column;margin:1rem;border-radius:var(--nylas-border-radius-2x);border:1px solid var(--nylas-base-200)}.nylas-availability-picker .header{padding:1rem}.nylas-availability-picker .header h3{margin:0;font-size:16px;font-weight:600;line-height:20px;color:var(--nylas-base-900);text-align:left}.nylas-availability-picker .header p{margin:0.25rem 0 0 0;font-size:0.875rem;font-weight:400;line-height:20px;color:var(--nylas-base-600);text-align:left;display:flex;align-items:center;gap:4px}.nylas-availability-picker .content{padding:1rem;color:var(--nylas-base-900);font-size:16px;font-family:var(--nylas-font-family);border-top:1px solid var(--nylas-base-200)}@media screen and (max-width: 504px){.nylas-availability-picker .content{font-size:15px}}.nylas-availability-picker .content .select-timezone{display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid var(--nylas-base-200);padding-bottom:1rem;gap:1rem}.nylas-availability-picker .content .select-timezone h4{display:flex;gap:0.5rem;align-items:center;margin:0;font-size:16px;font-weight:500;line-height:20px}@media screen and (max-width: 504px){.nylas-availability-picker .content .select-timezone h4{font-size:15px}}.nylas-availability-picker .content .availability{display:flex;flex-direction:column;gap:1rem;padding:0 0.5rem;margin:1rem 0}@media screen and (max-width: 504px){.nylas-availability-picker .content .availability{gap:0.5rem;padding:0}}.nylas-availability-picker .content .availability .availability-day{display:grid;grid-template-columns:minmax(auto, 65px) 1fr minmax(auto, 40px);gap:1rem;align-items:baseline}@media screen and (max-width: 768px){.nylas-availability-picker .content .availability .availability-day{grid-template-columns:78px 1fr auto}}@media screen and (max-width: 504px){.nylas-availability-picker .content .availability .availability-day{display:inline-grid;gap:8px;grid-template-columns:60px 1fr auto}}.nylas-availability-picker .content .availability .availability-day .day{display:flex;gap:0.5rem;align-items:center}@media screen and (max-width: 504px){.nylas-availability-picker .content .availability .availability-day .day{gap:0.25rem}}.nylas-availability-picker .content .availability .availability-day .day input[type=checkbox]{transform:scale(1.3)}.nylas-availability-picker .content .availability .availability-day .time-ranges span.unavailable{height:48px;display:flex;align-items:center;justify-content:center}.nylas-availability-picker .content .availability .availability-day .time-ranges .time-range{display:flex;gap:1.5rem;justify-content:space-between;align-items:baseline}@media screen and (max-width: 504px){.nylas-availability-picker .content .availability .availability-day .time-ranges .time-range{justify-content:unset;gap:0.5rem}}.nylas-availability-picker .content .availability .availability-day .time-ranges .time-range .pickers{display:flex;gap:1rem}@media screen and (max-width: 504px){.nylas-availability-picker .content .availability .availability-day .time-ranges .time-range .pickers{gap:0.5rem}}.nylas-availability-picker .content .availability .availability-day .time-ranges .time-range .pickers span{margin-top:0.75rem}.nylas-availability-picker .content .availability .availability-day .time-ranges .time-range:not(:last-of-type){margin-bottom:1rem}.nylas-availability-picker .content .availability .availability-day .time-ranges p.error{color:var(--nylas-error)}.nylas-availability-picker .content .availability .availability-day button{border:none;background:transparent;height:40px;cursor:pointer;color:var(--nylas-base-800)}.nylas-availability-picker .content .availability .availability-day button:hover,.nylas-availability-picker .content .availability .availability-day button:active{color:var(--nylas-primary)}select-dropdown{width:auto}select-dropdown::part(sd_dropdown-button){justify-content:initial}', ti = ei;
var ni = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, bt = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const En = class {
  constructor(e) {
    x(this, e), this.valueChanged = L(this, "valueChanged", 7), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals), this.selectedConfiguration = void 0, this.openHours = void 0, this.name = "availability", this.defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone, this.hideHeader = !1, this.schedule = {
      SUN: [],
      MON: [{ start: "09:00am", end: "05:00pm" }],
      TUE: [{ start: "09:00am", end: "05:00pm" }],
      WED: [{ start: "09:00am", end: "05:00pm" }],
      THU: [{ start: "09:00am", end: "05:00pm" }],
      FRI: [{ start: "09:00am", end: "05:00pm" }],
      SAT: []
    }, this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone, this.overlapDays = {};
  }
  elementNameChangedHandler(e) {
    d("nylas-calendar-picker", "elementNameChangedHandler", e), this.host.setAttribute("name", e);
  }
  configChangedHandler(e) {
    var n, a;
    const t = (a = (n = e == null ? void 0 : e.availability) == null ? void 0 : n.availability_rules) == null ? void 0 : a.default_open_hours;
    t && this.openHoursToSchedule(t);
  }
  scheduleChanged(e, t) {
    var n;
    if (e !== t) {
      let a = {};
      if (Object.keys(e).forEach((o) => {
        const i = e[o];
        if (i.length > 0) {
          const s = this.getOverlaps(i);
          s.length > 0 && (a[o] = s);
        }
      }), this.overlapDays = a, typeof this.internals.setFormValue != "function")
        return;
      if (Object.keys(a).length > 0) {
        const o = (n = this.host.shadowRoot) == null ? void 0 : n.getElementById(Object.keys(a)[0]);
        o && (d("nylas-availability-picker", "The time ranges are overlapping. Overlap: ", a), this.internals.setValidity({ customError: !0 }, "Overlapping time ranges found", o));
      } else
        this.internals.setValidity({ customError: !1 }), this.internals.setFormValue(JSON.stringify({
          openHours: this.scheduleToOpenHours(this.schedule),
          timezone: this.timezone
        }));
      this.valueChanged.emit({
        value: JSON.stringify({
          openHours: this.scheduleToOpenHours(e),
          timezone: this.timezone
        }),
        name: this.name
      });
    }
  }
  nylasFormDropdownChangedHandler(e) {
    const { name: t, value: n } = e.detail;
    if (t === "timezone") {
      if (this.timezone = n, typeof this.internals.setFormValue != "function")
        return;
      const a = {
        openHours: this.scheduleToOpenHours(this.schedule),
        timezone: this.timezone
      };
      this.internals.setFormValue(JSON.stringify(a)), this.valueChanged.emit({
        value: JSON.stringify(a),
        name: this.name
      });
    }
  }
  connectedCallback() {
    d("nylas-availability-picker", "connectedCallback");
  }
  disconnectedCallback() {
    d("nylas-availability-picker", "disconnectedCallback");
  }
  componentWillLoad() {
    d("nylas-availability-picker", "componentWillLoad"), this.host.setAttribute("name", this.name);
  }
  componentDidLoad() {
    if (d("nylas-availability-picker", "componentDidLoad"), this.openHours && this.openHours.length > 0 && this.openHoursToSchedule(this.openHours), typeof this.internals.setFormValue != "function")
      return;
    const e = {
      openHours: this.scheduleToOpenHours(this.schedule),
      timezone: this.timezone
    };
    this.internals.setFormValue(JSON.stringify(e)), this.valueChanged.emit({
      value: JSON.stringify(e),
      name: this.name
    });
  }
  getOverlaps(e) {
    let t = e.map((a, o) => ({
      start: we(a.start),
      end: we(a.end),
      originalIndex: o
    }));
    t.sort((a, o) => a.start - o.start);
    let n = [];
    for (let a = 1; a < t.length; a++)
      t[a].start < t[a - 1].end && (n.includes(t[a].originalIndex) || n.push(t[a].originalIndex), n.includes(t[a - 1].originalIndex) || n.push(t[a - 1].originalIndex));
    return n.sort((a, o) => a - o);
  }
  addTimeRange(e) {
    const t = this.schedule[e], n = 0, a = 1425;
    if (t.length === 0)
      this.schedule[e] = [{ start: "09:00am", end: "05:00pm" }];
    else {
      const o = t.map((s) => ({
        start: we(s.start),
        end: we(s.end)
      })).sort((s, l) => s.start - l.start), i = o[o.length - 1].end;
      if (i + 60 <= a)
        this.schedule[e].push({
          start: pe(xe(i)),
          end: pe(xe(i + 60))
        });
      else {
        let s = !1;
        if (o[0].start > n + 60 && (this.schedule[e].push({
          start: pe(xe(n)),
          end: pe(xe(n + 60))
        }), s = !0), !s)
          for (let l = 0; l < o.length - 1; l++) {
            const c = o[l].end;
            if (o[l + 1].start - c >= 60) {
              this.schedule[e].push({
                start: pe(xe(c)),
                end: pe(xe(c + 60))
              });
              break;
            }
          }
      }
    }
    this.schedule[e].sort((o, i) => we(o.start) - we(i.start)), this.schedule = { ...this.schedule };
  }
  removeTimeRange(e, t) {
    this.schedule[e].splice(t, 1), this.schedule = { ...this.schedule };
  }
  setTime(e) {
    const { key: t, value: n } = e.detail, [a, o] = t.split("_"), [i, s] = a.split(":");
    o === "start" ? this.schedule[i][s].start = n : o === "end" && (this.schedule[i][s].end = n), this.internals.setValidity({ customError: !1 }), this.schedule = { ...this.schedule };
  }
  setFormError(e) {
    var i;
    const { key: t } = e.detail, [n, a] = t.split("_"), o = (i = this.host.shadowRoot) == null ? void 0 : i.getElementById(t);
    o && this.internals.setValidity({ customError: !0 }, `Invalid ${a} time`, o);
  }
  openHoursToSchedule(e) {
    const t = {
      SUN: [],
      MON: [],
      TUE: [],
      WED: [],
      THU: [],
      FRI: [],
      SAT: []
    };
    e.forEach((n) => {
      n.days.forEach((a) => {
        const o = this.getDayKey(a), i = pe(n.start), s = pe(n.end), l = { start: i, end: s };
        let c = !1;
        t[o] && (c = t[o].some((f) => f.start === l.start && f.end === l.end)), c || (t[o] ? t[o].push(l) : t[o] = [l]);
      });
    }), this.timezone = this.defaultTimezone, this.schedule = t;
  }
  getDayKey(e) {
    return ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"][e];
  }
  scheduleToOpenHours(e) {
    const t = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
    let n = /* @__PURE__ */ new Map();
    t.forEach((o, i) => {
      e[o] && e[o].forEach((s) => {
        const l = sn(s.start), c = sn(s.end), f = `${l}-${c}`;
        if (!n.has(f))
          n.set(f, { days: [i], start: l, end: c });
        else {
          let p = n.get(f);
          p && (p.days.push(i), n.set(f, p));
        }
      });
    });
    let a = [];
    return n.forEach((o, i) => {
      a.push({
        days: o.days,
        start: o.start,
        end: o.end,
        timezone: this.timezone
      });
    }), a;
  }
  render() {
    const e = Object.keys(ln).map((t) => ({
      label: ln[t],
      value: t
    }));
    return r(H, { key: "d6ebb0ac834c059d38d5c3062315d0a6ff7e7606" }, r("div", { key: "0e8ec0786d293d3a1295021cdcc1a0966084cd74", class: "nylas-availability-picker", part: "nap" }, !this.hideHeader && r("div", { class: "header", part: "nap__header" }, r("h3", null, "General availability"), r("p", null, "Set when you're regularly available for event bookings.", r("tooltip-component", null, r("info-icon", { slot: "tooltip-icon" }), r("span", { slot: "tooltip-content" }, "This is the default availability for participants who don’t have availability set on the Participants tab.")))), r("div", { key: "20167bda51a9dc039bcef3a491a0433038af94f3", class: "content" }, r("div", { key: "d33de054ff0b04614e34ad4b8bb0f15110f722f1", class: "select-timezone", part: "nap__select-timezone" }, r("h4", { key: "35bad46d4e78e08c75acf41b95ab2809e59d3c5c", class: "sub-header" }, "Select timezone"), r("select-dropdown", { key: "63193f9d7c3479affe9a5c99b199b32678d4c8c7", name: "timezone", exportparts: "sd_dropdown: nap__timezone-container, sd_dropdown-button: nap__timezone-button, sd_dropdown-content: nap__timezone-dropdown-content", options: e, defaultSelectedOption: e.find((t) => t.value === this.defaultTimezone) }, r("span", { key: "ed8101d5acc86458413f771edbd3cc4c016d3d5f", slot: "select-icon" }, r("globe-icon", { key: "637d5652a53679bfd0052ec8348fb9c2ab9b4c89", width: "20", height: "20" })))), r("div", { key: "0023ea0d976234b85cf88a3c057dd2d3982d2f3d", class: "availability", part: "nap__availability" }, Object.keys(this.schedule).map((t) => {
      const n = t, a = this.schedule[t];
      return r("div", { class: "availability-day" }, r("div", { class: "day", part: "nap__day" }, r("input", { type: "checkbox", name: n, id: n, checked: a.length > 0, onClick: () => {
        a.length > 0 ? this.schedule[n] = [] : this.schedule[n] = [{ start: "09:00am", end: "05:00pm" }], this.schedule = { ...this.schedule };
      } }), r("label", { htmlFor: n, "aria-label": "Select day" }, n)), r("div", { class: "time-ranges", part: "nap__time-ranges" }, a.length ? null : r("span", { class: "unavailable" }, "Unavailable"), a.length > 0 && a.map((o, i) => {
        var c, f;
        const s = `${t}:${i}_start`, l = `${t}:${i}_end`;
        return r("div", { class: "time-range", part: "nap__time-range" }, r("div", { class: "pickers" }, r("nylas-time-window-picker", { id: s, hasError: (c = this.overlapDays[n]) == null ? void 0 : c.includes(i), time: o.start, name: s, key: s, exportparts: "time-picker: nap__time-picker-container, time-input: nap__time-picker-input, times: nap__time-picker-times" }), r("span", null, " - "), r("nylas-time-window-picker", { id: l, hasError: (f = this.overlapDays[n]) == null ? void 0 : f.includes(i), time: o.end, name: l, key: l, minimumStartTime: o.start, exportparts: "time-picker: nap__time-picker-container, time-input: nap__time-picker-input, times: nap__time-picker-times" })), r("button", { onClick: () => this.removeTimeRange(n, i) }, r("close-icon", null)));
      }), r("p", { class: "error" }, this.overlapDays[n] ? "Overlapping time ranges" : "")), r("div", null, a.length > 0 ? r("button", { onClick: () => this.addTimeRange(n), part: "nap__add-time-range" }, r("add-circle-icon", null)) : null));
    })))));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return $(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"],
      selectedConfiguration: ["configChangedHandler"],
      schedule: ["scheduleChanged"]
    };
  }
};
ni([
  M({
    name: "nylas-availability-picker",
    stateToProps: /* @__PURE__ */ new Map([["schedulerConfig.selectedConfiguration", "selectedConfiguration"]]),
    fireRegisterEvent: !0
  }),
  bt("design:type", Function),
  bt("design:paramtypes", []),
  bt("design:returntype", void 0)
], En.prototype, "render", null);
En.style = ti;
const ai = ':host{display:block;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif;width:inherit}.nylas-booking-calendar-picker{width:inherit;display:flex;flex-direction:column;margin:1rem;border-radius:var(--nylas-border-radius-2x);border:1px solid var(--nylas-base-200)}.nylas-booking-calendar-picker .header{padding:1rem;border-bottom:1px solid var(--nylas-base-200)}.nylas-booking-calendar-picker .header h3{margin:0;font-size:1rem;font-weight:600;line-height:20px;color:var(--nylas-base-900);text-align:left}.nylas-booking-calendar-picker .header p{margin:0.25rem 0 0 0;font-size:0.875rem;font-weight:400;line-height:20px;color:var(--nylas-base-600);text-align:left;display:flex;align-items:center;gap:4px}.nylas-booking-calendar-picker .nylas-booking-calendar-picker__loading{padding-bottom:1rem;display:flex;flex-direction:column;gap:4px}.nylas-booking-calendar-picker .nylas-booking-calendar-picker__loading .label{display:flex;align-items:center;gap:0.5rem;margin:1rem 1rem 0;color:var(--nylas-base-800)}.nylas-booking-calendar-picker .nylas-booking-calendar-picker__loading .loading-button{margin:0 1rem;padding:0;width:inherit;height:48px;color:black;font-size:1rem;cursor:not-allowed;display:flex;gap:0.5rem;justify-content:space-between;align-items:center;background:transparent;border:1px solid var(--nylas-base-200);border-radius:var(--nylas-border-radius-2x)}.nylas-booking-calendar-picker .nylas-booking-calendar-picker__loading .loading-button span{padding:0 1rem}.nylas-booking-calendar-picker .nylas-booking-calendar-picker__dropdown{padding:1rem;display:flex;flex-direction:column;gap:4px}.nylas-booking-calendar-picker .nylas-booking-calendar-picker__dropdown span.label{display:flex;align-items:center;gap:4px;color:var(--nylas-base-800)}.nylas-booking-calendar-picker .nylas-booking-calendar-picker__dropdown span.label tooltip-component{display:flex}.nylas-booking-calendar-picker .nylas-booking-calendar-picker__dropdown select-dropdown::part(sd_dropdown){width:100%}.nylas-booking-calendar-picker .nylas-booking-calendar-picker__dropdown select-dropdown::part(sd_dropdown-content){width:100%;max-width:unset}.nylas-booking-calendar-picker .nylas-booking-calendar-picker__dropdown select-dropdown::part(sd_dropdown-button){width:100%;display:flex;justify-content:space-between;align-items:center;border:1px solid var(--nylas-base-200);border-radius:var(--nylas-border-radius-2x)}.nylas-booking-calendar-picker .nylas-booking-calendar-picker__dropdown select-dropdown::part(sd_dropdown-button-selected-label){max-width:calc(100% - 2rem);font-family:var(--nylas-font-family);font-size:16px;line-height:24px}', ii = ai;
var oi = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, gt = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const Dn = class {
  constructor(e) {
    x(this, e), this.valueChanged = L(this, "valueChanged", 7), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals), this.calendars = void 0, this.currentUser = void 0, this.currentUserCalendars = void 0, this.name = "booking-calendar", this.defaultBookingCalendar = "", this.hideHeader = !1, this.selectedCalendar = "";
  }
  connectedCallback() {
    d("nylas-booking-calendar-picker", "connectedCallback");
  }
  disconnectedCallback() {
    d("nylas-booking-calendar-picker", "disconnectedCallback");
  }
  componentWillLoad() {
    d("nylas-booking-calendar-picker", "componentWillLoad"), this.host.setAttribute("name", this.name);
  }
  componentDidLoad() {
    var e, t;
    d("nylas-booking-calendar-picker", "componentDidLoad"), this.defaultBookingCalendar = this.defaultBookingCalendar || ((e = this.currentUser) == null ? void 0 : e.email) || "", typeof this.internals.setFormValue == "function" && this.internals.setFormValue(this.defaultBookingCalendar.toString(), "booking-calendar"), this.selectedCalendar = this.defaultBookingCalendar || ((t = this.currentUser) == null ? void 0 : t.email) || "", this.valueChanged.emit({ value: this.selectedCalendar, name: this.name });
  }
  componentWillUpdate() {
    d("nylas-booking-calendar-picker", "componentWillUpdate");
  }
  componentDidUpdate() {
    d("nylas-booking-calendar-picker", "componentDidUpdate");
  }
  componentWillRender() {
    d("nylas-booking-calendar-picker", "componentWillRender");
  }
  componentDidRender() {
    d("nylas-booking-calendar-picker", "componentDidRender");
  }
  elementNameChangedHandler(e) {
    d("nylas-booking-calendar-picker", "elementNameChangedHandler", e), this.host.setAttribute("name", e);
  }
  currentUserCalendarsChangedHandler(e) {
    d("nylas-booking-calendar-picker", "currentUserCalendarsChangedHandler", e), this.currentUserCalendars = e;
  }
  nylasFormDropdownChangedHandler(e) {
    d("nylas-booking-calendar-picker", "nylasFormDropdownChangedHandler", e.detail);
    const t = (n) => {
      const { value: a } = n.detail;
      this.selectedCalendar = a, this.internals.setFormValue(a.toString(), this.name);
    };
    this.valueChanged.emit({ value: e.detail.value, name: this.name, valueChanged: t });
  }
  render() {
    var a, o;
    const e = ((a = this.currentUserCalendars) == null ? void 0 : a.map((i) => ({
      value: i.id,
      label: i.name
    }))) ?? [], t = ((o = this.calendars) == null ? void 0 : o.map((i) => ({
      value: i.id,
      label: i.name
    }))) ?? [], n = (t == null ? void 0 : t.length) > 0 ? t : e || [];
    return r(H, null, r("div", { class: "nylas-booking-calendar-picker", part: "nbcp" }, !this.hideHeader && r("div", { class: "header", part: "nbcp__header" }, r("h3", null, "Calendar booking"), r("p", null, "Select the calendar where you want to add event bookings.", r("tooltip-component", null, r("info-icon", { slot: "tooltip-icon" }), r("span", { slot: "tooltip-content" }, "The calendar will be used to create events.")))), n.length > 0 ? r("div", { class: "nylas-booking-calendar-picker__dropdown" }, r("select-dropdown", { name: "booking-calendar", options: n, withSearch: !1, exportparts: "sd_dropdown: nbcp__dropdown, sd_dropdown-button: nbcp__dropdown-button, sd_dropdown-content: nbcp__dropdown-content", defaultSelectedOption: n.find((i) => i.value == this.defaultBookingCalendar) ?? n[0] })) : r("div", { class: "nylas-booking-calendar-picker__loading" }, r("span", { class: "label" }, "Select a calendar to book meetings on ", r("info-icon", null)), r("div", { class: "loading-button" }, r("span", null, "Loading...")))));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return $(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"],
      currentUserCalendars: ["currentUserCalendarsChangedHandler"]
    };
  }
};
oi([
  M({
    name: "nylas-booking-calendar-picker",
    stateToProps: /* @__PURE__ */ new Map([
      ["schedulerConfig.calendars", "currentUserCalendars"],
      ["schedulerConfig.currentUser", "currentUser"]
    ]),
    eventToProps: {
      valueChanged: async (e, t) => {
        const { valueChanged: n } = e.detail;
        n && n(e);
      }
    },
    fireRegisterEvent: !0
  }),
  gt("design:type", Function),
  gt("design:paramtypes", []),
  gt("design:returntype", void 0)
], Dn.prototype, "render", null);
Dn.style = ii;
/**!
 * Sortable 1.15.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function pn(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function re(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pn(Object(n), !0).forEach(function(a) {
      ri(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : pn(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function it(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? it = function(t) {
    return typeof t;
  } : it = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, it(e);
}
function ri(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function ee() {
  return ee = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  }, ee.apply(this, arguments);
}
function si(e, t) {
  if (e == null)
    return {};
  var n = {}, a = Object.keys(e), o, i;
  for (i = 0; i < a.length; i++)
    o = a[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function li(e, t) {
  if (e == null)
    return {};
  var n = si(e, t), a, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      a = i[o], !(t.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(e, a) && (n[a] = e[a]);
  }
  return n;
}
function di(e) {
  return ci(e) || fi(e) || pi(e) || mi();
}
function ci(e) {
  if (Array.isArray(e))
    return Jt(e);
}
function fi(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function pi(e, t) {
  if (e) {
    if (typeof e == "string")
      return Jt(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Jt(e, t);
  }
}
function Jt(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, a = new Array(t); n < t; n++)
    a[n] = e[n];
  return a;
}
function mi() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var ui = "1.15.2";
function le(e) {
  if (typeof window < "u" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(e);
}
var de = le(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), Ge = le(/Edge/i), mn = le(/firefox/i), Be = le(/safari/i) && !le(/chrome/i) && !le(/android/i), Sn = le(/iP(ad|od|hone)/i), On = le(/chrome/i) && le(/android/i), Tn = {
  capture: !1,
  passive: !1
};
function E(e, t, n) {
  e.addEventListener(t, n, !de && Tn);
}
function k(e, t, n) {
  e.removeEventListener(t, n, !de && Tn);
}
function dt(e, t) {
  if (t) {
    if (t[0] === ">" && (t = t.substring(1)), e)
      try {
        if (e.matches)
          return e.matches(t);
        if (e.msMatchesSelector)
          return e.msMatchesSelector(t);
        if (e.webkitMatchesSelector)
          return e.webkitMatchesSelector(t);
      } catch {
        return !1;
      }
    return !1;
  }
}
function hi(e) {
  return e.host && e !== document && e.host.nodeType ? e.host : e.parentNode;
}
function Q(e, t, n, a) {
  if (e) {
    n = n || document;
    do {
      if (t != null && (t[0] === ">" ? e.parentNode === n && dt(e, t) : dt(e, t)) || a && e === n)
        return e;
      if (e === n)
        break;
    } while (e = hi(e));
  }
  return null;
}
var un = /\s+/g;
function N(e, t, n) {
  if (e && t)
    if (e.classList)
      e.classList[n ? "add" : "remove"](t);
    else {
      var a = (" " + e.className + " ").replace(un, " ").replace(" " + t + " ", " ");
      e.className = (a + (n ? " " + t : "")).replace(un, " ");
    }
}
function y(e, t, n) {
  var a = e && e.style;
  if (a) {
    if (n === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? n = document.defaultView.getComputedStyle(e, "") : e.currentStyle && (n = e.currentStyle), t === void 0 ? n : n[t];
    !(t in a) && t.indexOf("webkit") === -1 && (t = "-webkit-" + t), a[t] = n + (typeof n == "string" ? "" : "px");
  }
}
function Ce(e, t) {
  var n = "";
  if (typeof e == "string")
    n = e;
  else
    do {
      var a = y(e, "transform");
      a && a !== "none" && (n = a + " " + n);
    } while (!t && (e = e.parentNode));
  var o = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return o && new o(n);
}
function In(e, t, n) {
  if (e) {
    var a = e.getElementsByTagName(t), o = 0, i = a.length;
    if (n)
      for (; o < i; o++)
        n(a[o], o);
    return a;
  }
  return [];
}
function oe() {
  var e = document.scrollingElement;
  return e || document.documentElement;
}
function T(e, t, n, a, o) {
  if (!(!e.getBoundingClientRect && e !== window)) {
    var i, s, l, c, f, p, m;
    if (e !== window && e.parentNode && e !== oe() ? (i = e.getBoundingClientRect(), s = i.top, l = i.left, c = i.bottom, f = i.right, p = i.height, m = i.width) : (s = 0, l = 0, c = window.innerHeight, f = window.innerWidth, p = window.innerHeight, m = window.innerWidth), (t || n) && e !== window && (o = o || e.parentNode, !de))
      do
        if (o && o.getBoundingClientRect && (y(o, "transform") !== "none" || n && y(o, "position") !== "static")) {
          var h = o.getBoundingClientRect();
          s -= h.top + parseInt(y(o, "border-top-width")), l -= h.left + parseInt(y(o, "border-left-width")), c = s + i.height, f = l + i.width;
          break;
        }
      while (o = o.parentNode);
    if (a && e !== window) {
      var v = Ce(o || e), b = v && v.a, w = v && v.d;
      v && (s /= w, l /= b, m /= b, p /= w, c = s + p, f = l + m);
    }
    return {
      top: s,
      left: l,
      bottom: c,
      right: f,
      width: m,
      height: p
    };
  }
}
function hn(e, t, n) {
  for (var a = he(e, !0), o = T(e)[t]; a; ) {
    var i = T(a)[n], s = void 0;
    if (n === "top" || n === "left" ? s = o >= i : s = o <= i, !s)
      return a;
    if (a === oe())
      break;
    a = he(a, !1);
  }
  return !1;
}
function Te(e, t, n, a) {
  for (var o = 0, i = 0, s = e.children; i < s.length; ) {
    if (s[i].style.display !== "none" && s[i] !== g.ghost && (a || s[i] !== g.dragged) && Q(s[i], n.draggable, e, !1)) {
      if (o === t)
        return s[i];
      o++;
    }
    i++;
  }
  return null;
}
function tn(e, t) {
  for (var n = e.lastElementChild; n && (n === g.ghost || y(n, "display") === "none" || t && !dt(n, t)); )
    n = n.previousElementSibling;
  return n || null;
}
function R(e, t) {
  var n = 0;
  if (!e || !e.parentNode)
    return -1;
  for (; e = e.previousElementSibling; )
    e.nodeName.toUpperCase() !== "TEMPLATE" && e !== g.clone && (!t || dt(e, t)) && n++;
  return n;
}
function yn(e) {
  var t = 0, n = 0, a = oe();
  if (e)
    do {
      var o = Ce(e), i = o.a, s = o.d;
      t += e.scrollLeft * i, n += e.scrollTop * s;
    } while (e !== a && (e = e.parentNode));
  return [t, n];
}
function yi(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n)) {
      for (var a in t)
        if (t.hasOwnProperty(a) && t[a] === e[n][a])
          return Number(n);
    }
  return -1;
}
function he(e, t) {
  if (!e || !e.getBoundingClientRect)
    return oe();
  var n = e, a = !1;
  do
    if (n.clientWidth < n.scrollWidth || n.clientHeight < n.scrollHeight) {
      var o = y(n);
      if (n.clientWidth < n.scrollWidth && (o.overflowX == "auto" || o.overflowX == "scroll") || n.clientHeight < n.scrollHeight && (o.overflowY == "auto" || o.overflowY == "scroll")) {
        if (!n.getBoundingClientRect || n === document.body)
          return oe();
        if (a || t)
          return n;
        a = !0;
      }
    }
  while (n = n.parentNode);
  return oe();
}
function bi(e, t) {
  if (e && t)
    for (var n in t)
      t.hasOwnProperty(n) && (e[n] = t[n]);
  return e;
}
function vt(e, t) {
  return Math.round(e.top) === Math.round(t.top) && Math.round(e.left) === Math.round(t.left) && Math.round(e.height) === Math.round(t.height) && Math.round(e.width) === Math.round(t.width);
}
var We;
function Hn(e, t) {
  return function() {
    if (!We) {
      var n = arguments, a = this;
      n.length === 1 ? e.call(a, n[0]) : e.apply(a, n), We = setTimeout(function() {
        We = void 0;
      }, t);
    }
  };
}
function gi() {
  clearTimeout(We), We = void 0;
}
function $n(e, t, n) {
  e.scrollLeft += t, e.scrollTop += n;
}
function nn(e) {
  var t = window.Polymer, n = window.jQuery || window.Zepto;
  return t && t.dom ? t.dom(e).cloneNode(!0) : n ? n(e).clone(!0)[0] : e.cloneNode(!0);
}
function bn(e, t) {
  y(e, "position", "absolute"), y(e, "top", t.top), y(e, "left", t.left), y(e, "width", t.width), y(e, "height", t.height);
}
function _t(e) {
  y(e, "position", ""), y(e, "top", ""), y(e, "left", ""), y(e, "width", ""), y(e, "height", "");
}
function Mn(e, t, n) {
  var a = {};
  return Array.from(e.children).forEach(function(o) {
    var i, s, l, c;
    if (!(!Q(o, t.draggable, e, !1) || o.animated || o === n)) {
      var f = T(o);
      a.left = Math.min((i = a.left) !== null && i !== void 0 ? i : 1 / 0, f.left), a.top = Math.min((s = a.top) !== null && s !== void 0 ? s : 1 / 0, f.top), a.right = Math.max((l = a.right) !== null && l !== void 0 ? l : -1 / 0, f.right), a.bottom = Math.max((c = a.bottom) !== null && c !== void 0 ? c : -1 / 0, f.bottom);
    }
  }), a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
var W = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function vi() {
  var e = [], t;
  return {
    captureAnimationState: function() {
      if (e = [], !!this.options.animation) {
        var a = [].slice.call(this.el.children);
        a.forEach(function(o) {
          if (!(y(o, "display") === "none" || o === g.ghost)) {
            e.push({
              target: o,
              rect: T(o)
            });
            var i = re({}, e[e.length - 1].rect);
            if (o.thisAnimationDuration) {
              var s = Ce(o, !0);
              s && (i.top -= s.f, i.left -= s.e);
            }
            o.fromRect = i;
          }
        });
      }
    },
    addAnimationState: function(a) {
      e.push(a);
    },
    removeAnimationState: function(a) {
      e.splice(yi(e, {
        target: a
      }), 1);
    },
    animateAll: function(a) {
      var o = this;
      if (!this.options.animation) {
        clearTimeout(t), typeof a == "function" && a();
        return;
      }
      var i = !1, s = 0;
      e.forEach(function(l) {
        var c = 0, f = l.target, p = f.fromRect, m = T(f), h = f.prevFromRect, v = f.prevToRect, b = l.rect, w = Ce(f, !0);
        w && (m.top -= w.f, m.left -= w.e), f.toRect = m, f.thisAnimationDuration && vt(h, m) && !vt(p, m) && // Make sure animatingRect is on line between toRect & fromRect
        (b.top - m.top) / (b.left - m.left) === (p.top - m.top) / (p.left - m.left) && (c = Ci(b, h, v, o.options)), vt(m, p) || (f.prevFromRect = p, f.prevToRect = m, c || (c = o.options.animation), o.animate(f, b, m, c)), c && (i = !0, s = Math.max(s, c), clearTimeout(f.animationResetTimer), f.animationResetTimer = setTimeout(function() {
          f.animationTime = 0, f.prevFromRect = null, f.fromRect = null, f.prevToRect = null, f.thisAnimationDuration = null;
        }, c), f.thisAnimationDuration = c);
      }), clearTimeout(t), i ? t = setTimeout(function() {
        typeof a == "function" && a();
      }, s) : typeof a == "function" && a(), e = [];
    },
    animate: function(a, o, i, s) {
      if (s) {
        y(a, "transition", ""), y(a, "transform", "");
        var l = Ce(this.el), c = l && l.a, f = l && l.d, p = (o.left - i.left) / (c || 1), m = (o.top - i.top) / (f || 1);
        a.animatingX = !!p, a.animatingY = !!m, y(a, "transform", "translate3d(" + p + "px," + m + "px,0)"), this.forRepaintDummy = _i(a), y(a, "transition", "transform " + s + "ms" + (this.options.easing ? " " + this.options.easing : "")), y(a, "transform", "translate3d(0,0,0)"), typeof a.animated == "number" && clearTimeout(a.animated), a.animated = setTimeout(function() {
          y(a, "transition", ""), y(a, "transform", ""), a.animated = !1, a.animatingX = !1, a.animatingY = !1;
        }, s);
      }
    }
  };
}
function _i(e) {
  return e.offsetWidth;
}
function Ci(e, t, n, a) {
  return Math.sqrt(Math.pow(t.top - e.top, 2) + Math.pow(t.left - e.left, 2)) / Math.sqrt(Math.pow(t.top - n.top, 2) + Math.pow(t.left - n.left, 2)) * a.animation;
}
var ke = [], Ct = {
  initializeByDefault: !0
}, Ye = {
  mount: function(t) {
    for (var n in Ct)
      Ct.hasOwnProperty(n) && !(n in t) && (t[n] = Ct[n]);
    ke.forEach(function(a) {
      if (a.pluginName === t.pluginName)
        throw "Sortable: Cannot mount plugin ".concat(t.pluginName, " more than once");
    }), ke.push(t);
  },
  pluginEvent: function(t, n, a) {
    var o = this;
    this.eventCanceled = !1, a.cancel = function() {
      o.eventCanceled = !0;
    };
    var i = t + "Global";
    ke.forEach(function(s) {
      n[s.pluginName] && (n[s.pluginName][i] && n[s.pluginName][i](re({
        sortable: n
      }, a)), n.options[s.pluginName] && n[s.pluginName][t] && n[s.pluginName][t](re({
        sortable: n
      }, a)));
    });
  },
  initializePlugins: function(t, n, a, o) {
    ke.forEach(function(l) {
      var c = l.pluginName;
      if (!(!t.options[c] && !l.initializeByDefault)) {
        var f = new l(t, n, t.options);
        f.sortable = t, f.options = t.options, t[c] = f, ee(a, f.defaults);
      }
    });
    for (var i in t.options)
      if (t.options.hasOwnProperty(i)) {
        var s = this.modifyOption(t, i, t.options[i]);
        typeof s < "u" && (t.options[i] = s);
      }
  },
  getEventProperties: function(t, n) {
    var a = {};
    return ke.forEach(function(o) {
      typeof o.eventProperties == "function" && ee(a, o.eventProperties.call(n[o.pluginName], t));
    }), a;
  },
  modifyOption: function(t, n, a) {
    var o;
    return ke.forEach(function(i) {
      t[i.pluginName] && i.optionListeners && typeof i.optionListeners[n] == "function" && (o = i.optionListeners[n].call(t[i.pluginName], a));
    }), o;
  }
};
function Re(e) {
  var t = e.sortable, n = e.rootEl, a = e.name, o = e.targetEl, i = e.cloneEl, s = e.toEl, l = e.fromEl, c = e.oldIndex, f = e.newIndex, p = e.oldDraggableIndex, m = e.newDraggableIndex, h = e.originalEvent, v = e.putSortable, b = e.extraEventProperties;
  if (t = t || n && n[W], !!t) {
    var w, S = t.options, U = "on" + a.charAt(0).toUpperCase() + a.substr(1);
    window.CustomEvent && !de && !Ge ? w = new CustomEvent(a, {
      bubbles: !0,
      cancelable: !0
    }) : (w = document.createEvent("Event"), w.initEvent(a, !0, !0)), w.to = s || n, w.from = l || n, w.item = o || n, w.clone = i, w.oldIndex = c, w.newIndex = f, w.oldDraggableIndex = p, w.newDraggableIndex = m, w.originalEvent = h, w.pullMode = v ? v.lastPutMode : void 0;
    var z = re(re({}, b), Ye.getEventProperties(a, t));
    for (var V in z)
      w[V] = z[V];
    n && n.dispatchEvent(w), S[U] && S[U].call(t, w);
  }
}
var wi = ["evt"], q = function(t, n) {
  var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = a.evt, i = li(a, wi);
  Ye.pluginEvent.bind(g)(t, n, re({
    dragEl: u,
    parentEl: F,
    ghostEl: C,
    rootEl: I,
    nextEl: _e,
    lastDownEl: ot,
    cloneEl: P,
    cloneHidden: ue,
    dragStarted: Ae,
    putSortable: j,
    activeSortable: g.active,
    originalEvent: o,
    oldIndex: Oe,
    oldDraggableIndex: Ze,
    newIndex: X,
    newDraggableIndex: me,
    hideGhostForTarget: Fn,
    unhideGhostForTarget: Rn,
    cloneNowHidden: function() {
      ue = !0;
    },
    cloneNowShown: function() {
      ue = !1;
    },
    dispatchSortableEvent: function(l) {
      Z({
        sortable: n,
        name: l,
        originalEvent: o
      });
    }
  }, i));
};
function Z(e) {
  Re(re({
    putSortable: j,
    cloneEl: P,
    targetEl: u,
    rootEl: I,
    oldIndex: Oe,
    oldDraggableIndex: Ze,
    newIndex: X,
    newDraggableIndex: me
  }, e));
}
var u, F, C, I, _e, ot, P, ue, Oe, X, Ze, me, Xe, j, Se = !1, ct = !1, ft = [], ge, te, wt, xt, gn, vn, Ae, Ee, Ue, Ve = !1, Ke = !1, rt, B, kt = [], Xt = !1, pt = [], ut = typeof document < "u", Qe = Sn, _n = Ge || de ? "cssFloat" : "float", xi = ut && !On && !Sn && "draggable" in document.createElement("div"), Pn = function() {
  if (ut) {
    if (de)
      return !1;
    var e = document.createElement("x");
    return e.style.cssText = "pointer-events:auto", e.style.pointerEvents === "auto";
  }
}(), Nn = function(t, n) {
  var a = y(t), o = parseInt(a.width) - parseInt(a.paddingLeft) - parseInt(a.paddingRight) - parseInt(a.borderLeftWidth) - parseInt(a.borderRightWidth), i = Te(t, 0, n), s = Te(t, 1, n), l = i && y(i), c = s && y(s), f = l && parseInt(l.marginLeft) + parseInt(l.marginRight) + T(i).width, p = c && parseInt(c.marginLeft) + parseInt(c.marginRight) + T(s).width;
  if (a.display === "flex")
    return a.flexDirection === "column" || a.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (a.display === "grid")
    return a.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (i && l.float && l.float !== "none") {
    var m = l.float === "left" ? "left" : "right";
    return s && (c.clear === "both" || c.clear === m) ? "vertical" : "horizontal";
  }
  return i && (l.display === "block" || l.display === "flex" || l.display === "table" || l.display === "grid" || f >= o && a[_n] === "none" || s && a[_n] === "none" && f + p > o) ? "vertical" : "horizontal";
}, ki = function(t, n, a) {
  var o = a ? t.left : t.top, i = a ? t.right : t.bottom, s = a ? t.width : t.height, l = a ? n.left : n.top, c = a ? n.right : n.bottom, f = a ? n.width : n.height;
  return o === l || i === c || o + s / 2 === l + f / 2;
}, Ei = function(t, n) {
  var a;
  return ft.some(function(o) {
    var i = o[W].options.emptyInsertThreshold;
    if (!(!i || tn(o))) {
      var s = T(o), l = t >= s.left - i && t <= s.right + i, c = n >= s.top - i && n <= s.bottom + i;
      if (l && c)
        return a = o;
    }
  }), a;
}, Ln = function(t) {
  function n(i, s) {
    return function(l, c, f, p) {
      var m = l.options.group.name && c.options.group.name && l.options.group.name === c.options.group.name;
      if (i == null && (s || m))
        return !0;
      if (i == null || i === !1)
        return !1;
      if (s && i === "clone")
        return i;
      if (typeof i == "function")
        return n(i(l, c, f, p), s)(l, c, f, p);
      var h = (s ? l : c).options.group.name;
      return i === !0 || typeof i == "string" && i === h || i.join && i.indexOf(h) > -1;
    };
  }
  var a = {}, o = t.group;
  (!o || it(o) != "object") && (o = {
    name: o
  }), a.name = o.name, a.checkPull = n(o.pull, !0), a.checkPut = n(o.put), a.revertClone = o.revertClone, t.group = a;
}, Fn = function() {
  !Pn && C && y(C, "display", "none");
}, Rn = function() {
  !Pn && C && y(C, "display", "");
};
ut && !On && document.addEventListener("click", function(e) {
  if (ct)
    return e.preventDefault(), e.stopPropagation && e.stopPropagation(), e.stopImmediatePropagation && e.stopImmediatePropagation(), ct = !1, !1;
}, !0);
var ve = function(t) {
  if (u) {
    t = t.touches ? t.touches[0] : t;
    var n = Ei(t.clientX, t.clientY);
    if (n) {
      var a = {};
      for (var o in t)
        t.hasOwnProperty(o) && (a[o] = t[o]);
      a.target = a.rootEl = n, a.preventDefault = void 0, a.stopPropagation = void 0, n[W]._onDragOver(a);
    }
  }
}, Di = function(t) {
  u && u.parentNode[W]._isOutsideThisEl(t.target);
};
function g(e, t) {
  if (!(e && e.nodeType && e.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(e));
  this.el = e, this.options = t = ee({}, t), e[W] = this;
  var n = {
    group: null,
    sort: !0,
    disabled: !1,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(e.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: !1,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: !0,
    direction: function() {
      return Nn(e, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: !0,
    animation: 0,
    easing: null,
    setData: function(s, l) {
      s.setData("Text", l.textContent);
    },
    dropBubble: !1,
    dragoverBubble: !1,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: !1,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: !1,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: !1,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: g.supportPointer !== !1 && "PointerEvent" in window && !Be,
    emptyInsertThreshold: 5
  };
  Ye.initializePlugins(this, e, n);
  for (var a in n)
    !(a in t) && (t[a] = n[a]);
  Ln(t);
  for (var o in this)
    o.charAt(0) === "_" && typeof this[o] == "function" && (this[o] = this[o].bind(this));
  this.nativeDraggable = t.forceFallback ? !1 : xi, this.nativeDraggable && (this.options.touchStartThreshold = 1), t.supportPointer ? E(e, "pointerdown", this._onTapStart) : (E(e, "mousedown", this._onTapStart), E(e, "touchstart", this._onTapStart)), this.nativeDraggable && (E(e, "dragover", this), E(e, "dragenter", this)), ft.push(this.el), t.store && t.store.get && this.sort(t.store.get(this) || []), ee(this, vi());
}
g.prototype = /** @lends Sortable.prototype */
{
  constructor: g,
  _isOutsideThisEl: function(t) {
    !this.el.contains(t) && t !== this.el && (Ee = null);
  },
  _getDirection: function(t, n) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, t, n, u) : this.options.direction;
  },
  _onTapStart: function(t) {
    if (t.cancelable) {
      var n = this, a = this.el, o = this.options, i = o.preventOnFilter, s = t.type, l = t.touches && t.touches[0] || t.pointerType && t.pointerType === "touch" && t, c = (l || t).target, f = t.target.shadowRoot && (t.path && t.path[0] || t.composedPath && t.composedPath()[0]) || c, p = o.filter;
      if (Pi(a), !u && !(/mousedown|pointerdown/.test(s) && t.button !== 0 || o.disabled) && !f.isContentEditable && !(!this.nativeDraggable && Be && c && c.tagName.toUpperCase() === "SELECT") && (c = Q(c, o.draggable, a, !1), !(c && c.animated) && ot !== c)) {
        if (Oe = R(c), Ze = R(c, o.draggable), typeof p == "function") {
          if (p.call(this, t, c, this)) {
            Z({
              sortable: n,
              rootEl: f,
              name: "filter",
              targetEl: c,
              toEl: a,
              fromEl: a
            }), q("filter", n, {
              evt: t
            }), i && t.cancelable && t.preventDefault();
            return;
          }
        } else if (p && (p = p.split(",").some(function(m) {
          if (m = Q(f, m.trim(), a, !1), m)
            return Z({
              sortable: n,
              rootEl: m,
              name: "filter",
              targetEl: c,
              fromEl: a,
              toEl: a
            }), q("filter", n, {
              evt: t
            }), !0;
        }), p)) {
          i && t.cancelable && t.preventDefault();
          return;
        }
        o.handle && !Q(f, o.handle, a, !1) || this._prepareDragStart(t, l, c);
      }
    }
  },
  _prepareDragStart: function(t, n, a) {
    var o = this, i = o.el, s = o.options, l = i.ownerDocument, c;
    if (a && !u && a.parentNode === i) {
      var f = T(a);
      if (I = i, u = a, F = u.parentNode, _e = u.nextSibling, ot = a, Xe = s.group, g.dragged = u, ge = {
        target: u,
        clientX: (n || t).clientX,
        clientY: (n || t).clientY
      }, gn = ge.clientX - f.left, vn = ge.clientY - f.top, this._lastX = (n || t).clientX, this._lastY = (n || t).clientY, u.style["will-change"] = "all", c = function() {
        if (q("delayEnded", o, {
          evt: t
        }), g.eventCanceled) {
          o._onDrop();
          return;
        }
        o._disableDelayedDragEvents(), !mn && o.nativeDraggable && (u.draggable = !0), o._triggerDragStart(t, n), Z({
          sortable: o,
          name: "choose",
          originalEvent: t
        }), N(u, s.chosenClass, !0);
      }, s.ignore.split(",").forEach(function(p) {
        In(u, p.trim(), Et);
      }), E(l, "dragover", ve), E(l, "mousemove", ve), E(l, "touchmove", ve), E(l, "mouseup", o._onDrop), E(l, "touchend", o._onDrop), E(l, "touchcancel", o._onDrop), mn && this.nativeDraggable && (this.options.touchStartThreshold = 4, u.draggable = !0), q("delayStart", this, {
        evt: t
      }), s.delay && (!s.delayOnTouchOnly || n) && (!this.nativeDraggable || !(Ge || de))) {
        if (g.eventCanceled) {
          this._onDrop();
          return;
        }
        E(l, "mouseup", o._disableDelayedDrag), E(l, "touchend", o._disableDelayedDrag), E(l, "touchcancel", o._disableDelayedDrag), E(l, "mousemove", o._delayedDragTouchMoveHandler), E(l, "touchmove", o._delayedDragTouchMoveHandler), s.supportPointer && E(l, "pointermove", o._delayedDragTouchMoveHandler), o._dragStartTimer = setTimeout(c, s.delay);
      } else
        c();
    }
  },
  _delayedDragTouchMoveHandler: function(t) {
    var n = t.touches ? t.touches[0] : t;
    Math.max(Math.abs(n.clientX - this._lastX), Math.abs(n.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function() {
    u && Et(u), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function() {
    var t = this.el.ownerDocument;
    k(t, "mouseup", this._disableDelayedDrag), k(t, "touchend", this._disableDelayedDrag), k(t, "touchcancel", this._disableDelayedDrag), k(t, "mousemove", this._delayedDragTouchMoveHandler), k(t, "touchmove", this._delayedDragTouchMoveHandler), k(t, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function(t, n) {
    n = n || t.pointerType == "touch" && t, !this.nativeDraggable || n ? this.options.supportPointer ? E(document, "pointermove", this._onTouchMove) : n ? E(document, "touchmove", this._onTouchMove) : E(document, "mousemove", this._onTouchMove) : (E(u, "dragend", this), E(I, "dragstart", this._onDragStart));
    try {
      document.selection ? st(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch {
    }
  },
  _dragStarted: function(t, n) {
    if (Se = !1, I && u) {
      q("dragStarted", this, {
        evt: n
      }), this.nativeDraggable && E(document, "dragover", Di);
      var a = this.options;
      !t && N(u, a.dragClass, !1), N(u, a.ghostClass, !0), g.active = this, t && this._appendGhost(), Z({
        sortable: this,
        name: "start",
        originalEvent: n
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function() {
    if (te) {
      this._lastX = te.clientX, this._lastY = te.clientY, Fn();
      for (var t = document.elementFromPoint(te.clientX, te.clientY), n = t; t && t.shadowRoot && (t = t.shadowRoot.elementFromPoint(te.clientX, te.clientY), t !== n); )
        n = t;
      if (u.parentNode[W]._isOutsideThisEl(t), n)
        do {
          if (n[W]) {
            var a = void 0;
            if (a = n[W]._onDragOver({
              clientX: te.clientX,
              clientY: te.clientY,
              target: t,
              rootEl: n
            }), a && !this.options.dragoverBubble)
              break;
          }
          t = n;
        } while (n = n.parentNode);
      Rn();
    }
  },
  _onTouchMove: function(t) {
    if (ge) {
      var n = this.options, a = n.fallbackTolerance, o = n.fallbackOffset, i = t.touches ? t.touches[0] : t, s = C && Ce(C, !0), l = C && s && s.a, c = C && s && s.d, f = Qe && B && yn(B), p = (i.clientX - ge.clientX + o.x) / (l || 1) + (f ? f[0] - kt[0] : 0) / (l || 1), m = (i.clientY - ge.clientY + o.y) / (c || 1) + (f ? f[1] - kt[1] : 0) / (c || 1);
      if (!g.active && !Se) {
        if (a && Math.max(Math.abs(i.clientX - this._lastX), Math.abs(i.clientY - this._lastY)) < a)
          return;
        this._onDragStart(t, !0);
      }
      if (C) {
        s ? (s.e += p - (wt || 0), s.f += m - (xt || 0)) : s = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: p,
          f: m
        };
        var h = "matrix(".concat(s.a, ",").concat(s.b, ",").concat(s.c, ",").concat(s.d, ",").concat(s.e, ",").concat(s.f, ")");
        y(C, "webkitTransform", h), y(C, "mozTransform", h), y(C, "msTransform", h), y(C, "transform", h), wt = p, xt = m, te = i;
      }
      t.cancelable && t.preventDefault();
    }
  },
  _appendGhost: function() {
    if (!C) {
      var t = this.options.fallbackOnBody ? document.body : I, n = T(u, !0, Qe, !0, t), a = this.options;
      if (Qe) {
        for (B = t; y(B, "position") === "static" && y(B, "transform") === "none" && B !== document; )
          B = B.parentNode;
        B !== document.body && B !== document.documentElement ? (B === document && (B = oe()), n.top += B.scrollTop, n.left += B.scrollLeft) : B = oe(), kt = yn(B);
      }
      C = u.cloneNode(!0), N(C, a.ghostClass, !1), N(C, a.fallbackClass, !0), N(C, a.dragClass, !0), y(C, "transition", ""), y(C, "transform", ""), y(C, "box-sizing", "border-box"), y(C, "margin", 0), y(C, "top", n.top), y(C, "left", n.left), y(C, "width", n.width), y(C, "height", n.height), y(C, "opacity", "0.8"), y(C, "position", Qe ? "absolute" : "fixed"), y(C, "zIndex", "100000"), y(C, "pointerEvents", "none"), g.ghost = C, t.appendChild(C), y(C, "transform-origin", gn / parseInt(C.style.width) * 100 + "% " + vn / parseInt(C.style.height) * 100 + "%");
    }
  },
  _onDragStart: function(t, n) {
    var a = this, o = t.dataTransfer, i = a.options;
    if (q("dragStart", this, {
      evt: t
    }), g.eventCanceled) {
      this._onDrop();
      return;
    }
    q("setupClone", this), g.eventCanceled || (P = nn(u), P.removeAttribute("id"), P.draggable = !1, P.style["will-change"] = "", this._hideClone(), N(P, this.options.chosenClass, !1), g.clone = P), a.cloneId = st(function() {
      q("clone", a), !g.eventCanceled && (a.options.removeCloneOnHide || I.insertBefore(P, u), a._hideClone(), Z({
        sortable: a,
        name: "clone"
      }));
    }), !n && N(u, i.dragClass, !0), n ? (ct = !0, a._loopId = setInterval(a._emulateDragOver, 50)) : (k(document, "mouseup", a._onDrop), k(document, "touchend", a._onDrop), k(document, "touchcancel", a._onDrop), o && (o.effectAllowed = "move", i.setData && i.setData.call(a, o, u)), E(document, "drop", a), y(u, "transform", "translateZ(0)")), Se = !0, a._dragStartId = st(a._dragStarted.bind(a, n, t)), E(document, "selectstart", a), Ae = !0, Be && y(document.body, "user-select", "none");
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function(t) {
    var n = this.el, a = t.target, o, i, s, l = this.options, c = l.group, f = g.active, p = Xe === c, m = l.sort, h = j || f, v, b = this, w = !1;
    if (Xt)
      return;
    function S(Pe, sa) {
      q(Pe, b, re({
        evt: t,
        isOwner: p,
        axis: v ? "vertical" : "horizontal",
        revert: s,
        dragRect: o,
        targetRect: i,
        canSort: m,
        fromSortable: h,
        target: a,
        completed: z,
        onMove: function(rn, la) {
          return et(I, n, u, o, rn, T(rn), t, la);
        },
        changed: V
      }, sa));
    }
    function U() {
      S("dragOverAnimationCapture"), b.captureAnimationState(), b !== h && h.captureAnimationState();
    }
    function z(Pe) {
      return S("dragOverCompleted", {
        insertion: Pe
      }), Pe && (p ? f._hideClone() : f._showClone(b), b !== h && (N(u, j ? j.options.ghostClass : f.options.ghostClass, !1), N(u, l.ghostClass, !0)), j !== b && b !== g.active ? j = b : b === g.active && j && (j = null), h === b && (b._ignoreWhileAnimating = a), b.animateAll(function() {
        S("dragOverAnimationComplete"), b._ignoreWhileAnimating = null;
      }), b !== h && (h.animateAll(), h._ignoreWhileAnimating = null)), (a === u && !u.animated || a === n && !a.animated) && (Ee = null), !l.dragoverBubble && !t.rootEl && a !== document && (u.parentNode[W]._isOutsideThisEl(t.target), !Pe && ve(t)), !l.dragoverBubble && t.stopPropagation && t.stopPropagation(), w = !0;
    }
    function V() {
      X = R(u), me = R(u, l.draggable), Z({
        sortable: b,
        name: "change",
        toEl: n,
        newIndex: X,
        newDraggableIndex: me,
        originalEvent: t
      });
    }
    if (t.preventDefault !== void 0 && t.cancelable && t.preventDefault(), a = Q(a, l.draggable, n, !0), S("dragOver"), g.eventCanceled)
      return w;
    if (u.contains(t.target) || a.animated && a.animatingX && a.animatingY || b._ignoreWhileAnimating === a)
      return z(!1);
    if (ct = !1, f && !l.disabled && (p ? m || (s = F !== I) : j === this || (this.lastPutMode = Xe.checkPull(this, f, u, t)) && c.checkPut(this, f, u, t))) {
      if (v = this._getDirection(t, a) === "vertical", o = T(u), S("dragOverValid"), g.eventCanceled)
        return w;
      if (s)
        return F = I, U(), this._hideClone(), S("revert"), g.eventCanceled || (_e ? I.insertBefore(u, _e) : I.appendChild(u)), z(!0);
      var D = tn(n, l.draggable);
      if (!D || Ii(t, v, this) && !D.animated) {
        if (D === u)
          return z(!1);
        if (D && n === t.target && (a = D), a && (i = T(a)), et(I, n, u, o, a, i, t, !!a) !== !1)
          return U(), D && D.nextSibling ? n.insertBefore(u, D.nextSibling) : n.appendChild(u), F = n, V(), z(!0);
      } else if (D && Ti(t, v, this)) {
        var ae = Te(n, 0, l, !0);
        if (ae === u)
          return z(!1);
        if (a = ae, i = T(a), et(I, n, u, o, a, i, t, !1) !== !1)
          return U(), n.insertBefore(u, ae), F = n, V(), z(!0);
      } else if (a.parentNode === n) {
        i = T(a);
        var ie = 0, ye, Ie = u.parentNode !== n, Y = !ki(u.animated && u.toRect || o, a.animated && a.toRect || i, v), He = v ? "top" : "left", ce = hn(a, "top", "top") || hn(u, "top", "top"), $e = ce ? ce.scrollTop : void 0;
        Ee !== a && (ye = i[He], Ve = !1, Ke = !Y && l.invertSwap || Ie), ie = Hi(t, a, i, v, Y ? 1 : l.swapThreshold, l.invertedSwapThreshold == null ? l.swapThreshold : l.invertedSwapThreshold, Ke, Ee === a);
        var se;
        if (ie !== 0) {
          var be = R(u);
          do
            be -= ie, se = F.children[be];
          while (se && (y(se, "display") === "none" || se === C));
        }
        if (ie === 0 || se === a)
          return z(!1);
        Ee = a, Ue = ie;
        var Me = a.nextElementSibling, fe = !1;
        fe = ie === 1;
        var Je = et(I, n, u, o, a, i, t, fe);
        if (Je !== !1)
          return (Je === 1 || Je === -1) && (fe = Je === 1), Xt = !0, setTimeout(Oi, 30), U(), fe && !Me ? n.appendChild(u) : a.parentNode.insertBefore(u, fe ? Me : a), ce && $n(ce, 0, $e - ce.scrollTop), F = u.parentNode, ye !== void 0 && !Ke && (rt = Math.abs(ye - T(a)[He])), V(), z(!0);
      }
      if (n.contains(u))
        return z(!1);
    }
    return !1;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function() {
    k(document, "mousemove", this._onTouchMove), k(document, "touchmove", this._onTouchMove), k(document, "pointermove", this._onTouchMove), k(document, "dragover", ve), k(document, "mousemove", ve), k(document, "touchmove", ve);
  },
  _offUpEvents: function() {
    var t = this.el.ownerDocument;
    k(t, "mouseup", this._onDrop), k(t, "touchend", this._onDrop), k(t, "pointerup", this._onDrop), k(t, "touchcancel", this._onDrop), k(document, "selectstart", this);
  },
  _onDrop: function(t) {
    var n = this.el, a = this.options;
    if (X = R(u), me = R(u, a.draggable), q("drop", this, {
      evt: t
    }), F = u && u.parentNode, X = R(u), me = R(u, a.draggable), g.eventCanceled) {
      this._nulling();
      return;
    }
    Se = !1, Ke = !1, Ve = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), Kt(this.cloneId), Kt(this._dragStartId), this.nativeDraggable && (k(document, "drop", this), k(n, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), Be && y(document.body, "user-select", ""), y(u, "transform", ""), t && (Ae && (t.cancelable && t.preventDefault(), !a.dropBubble && t.stopPropagation()), C && C.parentNode && C.parentNode.removeChild(C), (I === F || j && j.lastPutMode !== "clone") && P && P.parentNode && P.parentNode.removeChild(P), u && (this.nativeDraggable && k(u, "dragend", this), Et(u), u.style["will-change"] = "", Ae && !Se && N(u, j ? j.options.ghostClass : this.options.ghostClass, !1), N(u, this.options.chosenClass, !1), Z({
      sortable: this,
      name: "unchoose",
      toEl: F,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: t
    }), I !== F ? (X >= 0 && (Z({
      rootEl: F,
      name: "add",
      toEl: F,
      fromEl: I,
      originalEvent: t
    }), Z({
      sortable: this,
      name: "remove",
      toEl: F,
      originalEvent: t
    }), Z({
      rootEl: F,
      name: "sort",
      toEl: F,
      fromEl: I,
      originalEvent: t
    }), Z({
      sortable: this,
      name: "sort",
      toEl: F,
      originalEvent: t
    })), j && j.save()) : X !== Oe && X >= 0 && (Z({
      sortable: this,
      name: "update",
      toEl: F,
      originalEvent: t
    }), Z({
      sortable: this,
      name: "sort",
      toEl: F,
      originalEvent: t
    })), g.active && ((X == null || X === -1) && (X = Oe, me = Ze), Z({
      sortable: this,
      name: "end",
      toEl: F,
      originalEvent: t
    }), this.save()))), this._nulling();
  },
  _nulling: function() {
    q("nulling", this), I = u = F = C = _e = P = ot = ue = ge = te = Ae = X = me = Oe = Ze = Ee = Ue = j = Xe = g.dragged = g.ghost = g.clone = g.active = null, pt.forEach(function(t) {
      t.checked = !0;
    }), pt.length = wt = xt = 0;
  },
  handleEvent: function(t) {
    switch (t.type) {
      case "drop":
      case "dragend":
        this._onDrop(t);
        break;
      case "dragenter":
      case "dragover":
        u && (this._onDragOver(t), Si(t));
        break;
      case "selectstart":
        t.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function() {
    for (var t = [], n, a = this.el.children, o = 0, i = a.length, s = this.options; o < i; o++)
      n = a[o], Q(n, s.draggable, this.el, !1) && t.push(n.getAttribute(s.dataIdAttr) || Mi(n));
    return t;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function(t, n) {
    var a = {}, o = this.el;
    this.toArray().forEach(function(i, s) {
      var l = o.children[s];
      Q(l, this.options.draggable, o, !1) && (a[i] = l);
    }, this), n && this.captureAnimationState(), t.forEach(function(i) {
      a[i] && (o.removeChild(a[i]), o.appendChild(a[i]));
    }), n && this.animateAll();
  },
  /**
   * Save the current sorting
   */
  save: function() {
    var t = this.options.store;
    t && t.set && t.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function(t, n) {
    return Q(t, n || this.options.draggable, this.el, !1);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function(t, n) {
    var a = this.options;
    if (n === void 0)
      return a[t];
    var o = Ye.modifyOption(this, t, n);
    typeof o < "u" ? a[t] = o : a[t] = n, t === "group" && Ln(a);
  },
  /**
   * Destroy
   */
  destroy: function() {
    q("destroy", this);
    var t = this.el;
    t[W] = null, k(t, "mousedown", this._onTapStart), k(t, "touchstart", this._onTapStart), k(t, "pointerdown", this._onTapStart), this.nativeDraggable && (k(t, "dragover", this), k(t, "dragenter", this)), Array.prototype.forEach.call(t.querySelectorAll("[draggable]"), function(n) {
      n.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), ft.splice(ft.indexOf(this.el), 1), this.el = t = null;
  },
  _hideClone: function() {
    if (!ue) {
      if (q("hideClone", this), g.eventCanceled)
        return;
      y(P, "display", "none"), this.options.removeCloneOnHide && P.parentNode && P.parentNode.removeChild(P), ue = !0;
    }
  },
  _showClone: function(t) {
    if (t.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (ue) {
      if (q("showClone", this), g.eventCanceled)
        return;
      u.parentNode == I && !this.options.group.revertClone ? I.insertBefore(P, u) : _e ? I.insertBefore(P, _e) : I.appendChild(P), this.options.group.revertClone && this.animate(u, P), y(P, "display", ""), ue = !1;
    }
  }
};
function Si(e) {
  e.dataTransfer && (e.dataTransfer.dropEffect = "move"), e.cancelable && e.preventDefault();
}
function et(e, t, n, a, o, i, s, l) {
  var c, f = e[W], p = f.options.onMove, m;
  return window.CustomEvent && !de && !Ge ? c = new CustomEvent("move", {
    bubbles: !0,
    cancelable: !0
  }) : (c = document.createEvent("Event"), c.initEvent("move", !0, !0)), c.to = t, c.from = e, c.dragged = n, c.draggedRect = a, c.related = o || t, c.relatedRect = i || T(t), c.willInsertAfter = l, c.originalEvent = s, e.dispatchEvent(c), p && (m = p.call(f, c, s)), m;
}
function Et(e) {
  e.draggable = !1;
}
function Oi() {
  Xt = !1;
}
function Ti(e, t, n) {
  var a = T(Te(n.el, 0, n.options, !0)), o = Mn(n.el, n.options, C), i = 10;
  return t ? e.clientX < o.left - i || e.clientY < a.top && e.clientX < a.right : e.clientY < o.top - i || e.clientY < a.bottom && e.clientX < a.left;
}
function Ii(e, t, n) {
  var a = T(tn(n.el, n.options.draggable)), o = Mn(n.el, n.options, C), i = 10;
  return t ? e.clientX > o.right + i || e.clientY > a.bottom && e.clientX > a.left : e.clientY > o.bottom + i || e.clientX > a.right && e.clientY > a.top;
}
function Hi(e, t, n, a, o, i, s, l) {
  var c = a ? e.clientY : e.clientX, f = a ? n.height : n.width, p = a ? n.top : n.left, m = a ? n.bottom : n.right, h = !1;
  if (!s) {
    if (l && rt < f * o) {
      if (!Ve && (Ue === 1 ? c > p + f * i / 2 : c < m - f * i / 2) && (Ve = !0), Ve)
        h = !0;
      else if (Ue === 1 ? c < p + rt : c > m - rt)
        return -Ue;
    } else if (c > p + f * (1 - o) / 2 && c < m - f * (1 - o) / 2)
      return $i(t);
  }
  return h = h || s, h && (c < p + f * i / 2 || c > m - f * i / 2) ? c > p + f / 2 ? 1 : -1 : 0;
}
function $i(e) {
  return R(u) < R(e) ? 1 : -1;
}
function Mi(e) {
  for (var t = e.tagName + e.className + e.src + e.href + e.textContent, n = t.length, a = 0; n--; )
    a += t.charCodeAt(n);
  return a.toString(36);
}
function Pi(e) {
  pt.length = 0;
  for (var t = e.getElementsByTagName("input"), n = t.length; n--; ) {
    var a = t[n];
    a.checked && pt.push(a);
  }
}
function st(e) {
  return setTimeout(e, 0);
}
function Kt(e) {
  return clearTimeout(e);
}
ut && E(document, "touchmove", function(e) {
  (g.active || Se) && e.cancelable && e.preventDefault();
});
g.utils = {
  on: E,
  off: k,
  css: y,
  find: In,
  is: function(t, n) {
    return !!Q(t, n, t, !1);
  },
  extend: bi,
  throttle: Hn,
  closest: Q,
  toggleClass: N,
  clone: nn,
  index: R,
  nextTick: st,
  cancelNextTick: Kt,
  detectDirection: Nn,
  getChild: Te
};
g.get = function(e) {
  return e[W];
};
g.mount = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  t[0].constructor === Array && (t = t[0]), t.forEach(function(a) {
    if (!a.prototype || !a.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(a));
    a.utils && (g.utils = re(re({}, g.utils), a.utils)), Ye.mount(a);
  });
};
g.create = function(e, t) {
  return new g(e, t);
};
g.version = ui;
var A = [], ze, Qt, en = !1, Dt, St, mt, je;
function Ni() {
  function e() {
    this.defaults = {
      scroll: !0,
      forceAutoScrollFallback: !1,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: !0
    };
    for (var t in this)
      t.charAt(0) === "_" && typeof this[t] == "function" && (this[t] = this[t].bind(this));
  }
  return e.prototype = {
    dragStarted: function(n) {
      var a = n.originalEvent;
      this.sortable.nativeDraggable ? E(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? E(document, "pointermove", this._handleFallbackAutoScroll) : a.touches ? E(document, "touchmove", this._handleFallbackAutoScroll) : E(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(n) {
      var a = n.originalEvent;
      !this.options.dragOverBubble && !a.rootEl && this._handleAutoScroll(a);
    },
    drop: function() {
      this.sortable.nativeDraggable ? k(document, "dragover", this._handleAutoScroll) : (k(document, "pointermove", this._handleFallbackAutoScroll), k(document, "touchmove", this._handleFallbackAutoScroll), k(document, "mousemove", this._handleFallbackAutoScroll)), Cn(), lt(), gi();
    },
    nulling: function() {
      mt = Qt = ze = en = je = Dt = St = null, A.length = 0;
    },
    _handleFallbackAutoScroll: function(n) {
      this._handleAutoScroll(n, !0);
    },
    _handleAutoScroll: function(n, a) {
      var o = this, i = (n.touches ? n.touches[0] : n).clientX, s = (n.touches ? n.touches[0] : n).clientY, l = document.elementFromPoint(i, s);
      if (mt = n, a || this.options.forceAutoScrollFallback || Ge || de || Be) {
        Ot(n, this.options, l, a);
        var c = he(l, !0);
        en && (!je || i !== Dt || s !== St) && (je && Cn(), je = setInterval(function() {
          var f = he(document.elementFromPoint(i, s), !0);
          f !== c && (c = f, lt()), Ot(n, o.options, f, a);
        }, 10), Dt = i, St = s);
      } else {
        if (!this.options.bubbleScroll || he(l, !0) === oe()) {
          lt();
          return;
        }
        Ot(n, this.options, he(l, !1), !1);
      }
    }
  }, ee(e, {
    pluginName: "scroll",
    initializeByDefault: !0
  });
}
function lt() {
  A.forEach(function(e) {
    clearInterval(e.pid);
  }), A = [];
}
function Cn() {
  clearInterval(je);
}
var Ot = Hn(function(e, t, n, a) {
  if (t.scroll) {
    var o = (e.touches ? e.touches[0] : e).clientX, i = (e.touches ? e.touches[0] : e).clientY, s = t.scrollSensitivity, l = t.scrollSpeed, c = oe(), f = !1, p;
    Qt !== n && (Qt = n, lt(), ze = t.scroll, p = t.scrollFn, ze === !0 && (ze = he(n, !0)));
    var m = 0, h = ze;
    do {
      var v = h, b = T(v), w = b.top, S = b.bottom, U = b.left, z = b.right, V = b.width, D = b.height, ae = void 0, ie = void 0, ye = v.scrollWidth, Ie = v.scrollHeight, Y = y(v), He = v.scrollLeft, ce = v.scrollTop;
      v === c ? (ae = V < ye && (Y.overflowX === "auto" || Y.overflowX === "scroll" || Y.overflowX === "visible"), ie = D < Ie && (Y.overflowY === "auto" || Y.overflowY === "scroll" || Y.overflowY === "visible")) : (ae = V < ye && (Y.overflowX === "auto" || Y.overflowX === "scroll"), ie = D < Ie && (Y.overflowY === "auto" || Y.overflowY === "scroll"));
      var $e = ae && (Math.abs(z - o) <= s && He + V < ye) - (Math.abs(U - o) <= s && !!He), se = ie && (Math.abs(S - i) <= s && ce + D < Ie) - (Math.abs(w - i) <= s && !!ce);
      if (!A[m])
        for (var be = 0; be <= m; be++)
          A[be] || (A[be] = {});
      (A[m].vx != $e || A[m].vy != se || A[m].el !== v) && (A[m].el = v, A[m].vx = $e, A[m].vy = se, clearInterval(A[m].pid), ($e != 0 || se != 0) && (f = !0, A[m].pid = setInterval((function() {
        a && this.layer === 0 && g.active._onTouchMove(mt);
        var Me = A[this.layer].vy ? A[this.layer].vy * l : 0, fe = A[this.layer].vx ? A[this.layer].vx * l : 0;
        typeof p == "function" && p.call(g.dragged.parentNode[W], fe, Me, e, mt, A[this.layer].el) !== "continue" || $n(A[this.layer].el, fe, Me);
      }).bind({
        layer: m
      }), 24))), m++;
    } while (t.bubbleScroll && h !== c && (h = he(h, !1)));
    en = f;
  }
}, 30), An = function(t) {
  var n = t.originalEvent, a = t.putSortable, o = t.dragEl, i = t.activeSortable, s = t.dispatchSortableEvent, l = t.hideGhostForTarget, c = t.unhideGhostForTarget;
  if (n) {
    var f = a || i;
    l();
    var p = n.changedTouches && n.changedTouches.length ? n.changedTouches[0] : n, m = document.elementFromPoint(p.clientX, p.clientY);
    c(), f && !f.el.contains(m) && (s("spill"), this.onSpill({
      dragEl: o,
      putSortable: a
    }));
  }
};
function an() {
}
an.prototype = {
  startIndex: null,
  dragStart: function(t) {
    var n = t.oldDraggableIndex;
    this.startIndex = n;
  },
  onSpill: function(t) {
    var n = t.dragEl, a = t.putSortable;
    this.sortable.captureAnimationState(), a && a.captureAnimationState();
    var o = Te(this.sortable.el, this.startIndex, this.options);
    o ? this.sortable.el.insertBefore(n, o) : this.sortable.el.appendChild(n), this.sortable.animateAll(), a && a.animateAll();
  },
  drop: An
};
ee(an, {
  pluginName: "revertOnSpill"
});
function on() {
}
on.prototype = {
  onSpill: function(t) {
    var n = t.dragEl, a = t.putSortable, o = a || this.sortable;
    o.captureAnimationState(), n.parentNode && n.parentNode.removeChild(n), o.animateAll();
  },
  drop: An
};
ee(on, {
  pluginName: "removeOnSpill"
});
var K;
function Li() {
  function e() {
    this.defaults = {
      swapClass: "sortable-swap-highlight"
    };
  }
  return e.prototype = {
    dragStart: function(n) {
      var a = n.dragEl;
      K = a;
    },
    dragOverValid: function(n) {
      var a = n.completed, o = n.target, i = n.onMove, s = n.activeSortable, l = n.changed, c = n.cancel;
      if (s.options.swap) {
        var f = this.sortable.el, p = this.options;
        if (o && o !== f) {
          var m = K;
          i(o) !== !1 ? (N(o, p.swapClass, !0), K = o) : K = null, m && m !== K && N(m, p.swapClass, !1);
        }
        l(), a(!0), c();
      }
    },
    drop: function(n) {
      var a = n.activeSortable, o = n.putSortable, i = n.dragEl, s = o || this.sortable, l = this.options;
      K && N(K, l.swapClass, !1), K && (l.swap || o && o.options.swap) && i !== K && (s.captureAnimationState(), s !== a && a.captureAnimationState(), Fi(i, K), s.animateAll(), s !== a && a.animateAll());
    },
    nulling: function() {
      K = null;
    }
  }, ee(e, {
    pluginName: "swap",
    eventProperties: function() {
      return {
        swapItem: K
      };
    }
  });
}
function Fi(e, t) {
  var n = e.parentNode, a = t.parentNode, o, i;
  !n || !a || n.isEqualNode(t) || a.isEqualNode(e) || (o = R(e), i = R(t), n.isEqualNode(a) && o < i && i++, n.insertBefore(t, n.children[o]), a.insertBefore(e, a.children[i]));
}
var _ = [], J = [], Ne, ne, Le = !1, G = !1, De = !1, O, Fe, tt;
function Ri() {
  function e(t) {
    for (var n in this)
      n.charAt(0) === "_" && typeof this[n] == "function" && (this[n] = this[n].bind(this));
    t.options.avoidImplicitDeselect || (t.options.supportPointer ? E(document, "pointerup", this._deselectMultiDrag) : (E(document, "mouseup", this._deselectMultiDrag), E(document, "touchend", this._deselectMultiDrag))), E(document, "keydown", this._checkKeyDown), E(document, "keyup", this._checkKeyUp), this.defaults = {
      selectedClass: "sortable-selected",
      multiDragKey: null,
      avoidImplicitDeselect: !1,
      setData: function(o, i) {
        var s = "";
        _.length && ne === t ? _.forEach(function(l, c) {
          s += (c ? ", " : "") + l.textContent;
        }) : s = i.textContent, o.setData("Text", s);
      }
    };
  }
  return e.prototype = {
    multiDragKeyDown: !1,
    isMultiDrag: !1,
    delayStartGlobal: function(n) {
      var a = n.dragEl;
      O = a;
    },
    delayEnded: function() {
      this.isMultiDrag = ~_.indexOf(O);
    },
    setupClone: function(n) {
      var a = n.sortable, o = n.cancel;
      if (this.isMultiDrag) {
        for (var i = 0; i < _.length; i++)
          J.push(nn(_[i])), J[i].sortableIndex = _[i].sortableIndex, J[i].draggable = !1, J[i].style["will-change"] = "", N(J[i], this.options.selectedClass, !1), _[i] === O && N(J[i], this.options.chosenClass, !1);
        a._hideClone(), o();
      }
    },
    clone: function(n) {
      var a = n.sortable, o = n.rootEl, i = n.dispatchSortableEvent, s = n.cancel;
      this.isMultiDrag && (this.options.removeCloneOnHide || _.length && ne === a && (wn(!0, o), i("clone"), s()));
    },
    showClone: function(n) {
      var a = n.cloneNowShown, o = n.rootEl, i = n.cancel;
      this.isMultiDrag && (wn(!1, o), J.forEach(function(s) {
        y(s, "display", "");
      }), a(), tt = !1, i());
    },
    hideClone: function(n) {
      var a = this, o = n.cloneNowHidden, i = n.cancel;
      this.isMultiDrag && (J.forEach(function(s) {
        y(s, "display", "none"), a.options.removeCloneOnHide && s.parentNode && s.parentNode.removeChild(s);
      }), o(), tt = !0, i());
    },
    dragStartGlobal: function(n) {
      !this.isMultiDrag && ne && ne.multiDrag._deselectMultiDrag(), _.forEach(function(a) {
        a.sortableIndex = R(a);
      }), _ = _.sort(function(a, o) {
        return a.sortableIndex - o.sortableIndex;
      }), De = !0;
    },
    dragStarted: function(n) {
      var a = this, o = n.sortable;
      if (this.isMultiDrag) {
        if (this.options.sort && (o.captureAnimationState(), this.options.animation)) {
          _.forEach(function(s) {
            s !== O && y(s, "position", "absolute");
          });
          var i = T(O, !1, !0, !0);
          _.forEach(function(s) {
            s !== O && bn(s, i);
          }), G = !0, Le = !0;
        }
        o.animateAll(function() {
          G = !1, Le = !1, a.options.animation && _.forEach(function(s) {
            _t(s);
          }), a.options.sort && nt();
        });
      }
    },
    dragOver: function(n) {
      var a = n.target, o = n.completed, i = n.cancel;
      G && ~_.indexOf(a) && (o(!1), i());
    },
    revert: function(n) {
      var a = n.fromSortable, o = n.rootEl, i = n.sortable, s = n.dragRect;
      _.length > 1 && (_.forEach(function(l) {
        i.addAnimationState({
          target: l,
          rect: G ? T(l) : s
        }), _t(l), l.fromRect = s, a.removeAnimationState(l);
      }), G = !1, Ai(!this.options.removeCloneOnHide, o));
    },
    dragOverCompleted: function(n) {
      var a = n.sortable, o = n.isOwner, i = n.insertion, s = n.activeSortable, l = n.parentEl, c = n.putSortable, f = this.options;
      if (i) {
        if (o && s._hideClone(), Le = !1, f.animation && _.length > 1 && (G || !o && !s.options.sort && !c)) {
          var p = T(O, !1, !0, !0);
          _.forEach(function(h) {
            h !== O && (bn(h, p), l.appendChild(h));
          }), G = !0;
        }
        if (!o)
          if (G || nt(), _.length > 1) {
            var m = tt;
            s._showClone(a), s.options.animation && !tt && m && J.forEach(function(h) {
              s.addAnimationState({
                target: h,
                rect: Fe
              }), h.fromRect = Fe, h.thisAnimationDuration = null;
            });
          } else
            s._showClone(a);
      }
    },
    dragOverAnimationCapture: function(n) {
      var a = n.dragRect, o = n.isOwner, i = n.activeSortable;
      if (_.forEach(function(l) {
        l.thisAnimationDuration = null;
      }), i.options.animation && !o && i.multiDrag.isMultiDrag) {
        Fe = ee({}, a);
        var s = Ce(O, !0);
        Fe.top -= s.f, Fe.left -= s.e;
      }
    },
    dragOverAnimationComplete: function() {
      G && (G = !1, nt());
    },
    drop: function(n) {
      var a = n.originalEvent, o = n.rootEl, i = n.parentEl, s = n.sortable, l = n.dispatchSortableEvent, c = n.oldIndex, f = n.putSortable, p = f || this.sortable;
      if (a) {
        var m = this.options, h = i.children;
        if (!De)
          if (m.multiDragKey && !this.multiDragKeyDown && this._deselectMultiDrag(), N(O, m.selectedClass, !~_.indexOf(O)), ~_.indexOf(O))
            _.splice(_.indexOf(O), 1), Ne = null, Re({
              sortable: s,
              rootEl: o,
              name: "deselect",
              targetEl: O,
              originalEvent: a
            });
          else {
            if (_.push(O), Re({
              sortable: s,
              rootEl: o,
              name: "select",
              targetEl: O,
              originalEvent: a
            }), a.shiftKey && Ne && s.el.contains(Ne)) {
              var v = R(Ne), b = R(O);
              if (~v && ~b && v !== b) {
                var w, S;
                for (b > v ? (S = v, w = b) : (S = b, w = v + 1); S < w; S++)
                  ~_.indexOf(h[S]) || (N(h[S], m.selectedClass, !0), _.push(h[S]), Re({
                    sortable: s,
                    rootEl: o,
                    name: "select",
                    targetEl: h[S],
                    originalEvent: a
                  }));
              }
            } else
              Ne = O;
            ne = p;
          }
        if (De && this.isMultiDrag) {
          if (G = !1, (i[W].options.sort || i !== o) && _.length > 1) {
            var U = T(O), z = R(O, ":not(." + this.options.selectedClass + ")");
            if (!Le && m.animation && (O.thisAnimationDuration = null), p.captureAnimationState(), !Le && (m.animation && (O.fromRect = U, _.forEach(function(D) {
              if (D.thisAnimationDuration = null, D !== O) {
                var ae = G ? T(D) : U;
                D.fromRect = ae, p.addAnimationState({
                  target: D,
                  rect: ae
                });
              }
            })), nt(), _.forEach(function(D) {
              h[z] ? i.insertBefore(D, h[z]) : i.appendChild(D), z++;
            }), c === R(O))) {
              var V = !1;
              _.forEach(function(D) {
                if (D.sortableIndex !== R(D)) {
                  V = !0;
                  return;
                }
              }), V && (l("update"), l("sort"));
            }
            _.forEach(function(D) {
              _t(D);
            }), p.animateAll();
          }
          ne = p;
        }
        (o === i || f && f.lastPutMode !== "clone") && J.forEach(function(D) {
          D.parentNode && D.parentNode.removeChild(D);
        });
      }
    },
    nullingGlobal: function() {
      this.isMultiDrag = De = !1, J.length = 0;
    },
    destroyGlobal: function() {
      this._deselectMultiDrag(), k(document, "pointerup", this._deselectMultiDrag), k(document, "mouseup", this._deselectMultiDrag), k(document, "touchend", this._deselectMultiDrag), k(document, "keydown", this._checkKeyDown), k(document, "keyup", this._checkKeyUp);
    },
    _deselectMultiDrag: function(n) {
      if (!(typeof De < "u" && De) && ne === this.sortable && !(n && Q(n.target, this.options.draggable, this.sortable.el, !1)) && !(n && n.button !== 0))
        for (; _.length; ) {
          var a = _[0];
          N(a, this.options.selectedClass, !1), _.shift(), Re({
            sortable: this.sortable,
            rootEl: this.sortable.el,
            name: "deselect",
            targetEl: a,
            originalEvent: n
          });
        }
    },
    _checkKeyDown: function(n) {
      n.key === this.options.multiDragKey && (this.multiDragKeyDown = !0);
    },
    _checkKeyUp: function(n) {
      n.key === this.options.multiDragKey && (this.multiDragKeyDown = !1);
    }
  }, ee(e, {
    // Static methods & properties
    pluginName: "multiDrag",
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function(n) {
        var a = n.parentNode[W];
        !a || !a.options.multiDrag || ~_.indexOf(n) || (ne && ne !== a && (ne.multiDrag._deselectMultiDrag(), ne = a), N(n, a.options.selectedClass, !0), _.push(n));
      },
      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function(n) {
        var a = n.parentNode[W], o = _.indexOf(n);
        !a || !a.options.multiDrag || !~o || (N(n, a.options.selectedClass, !1), _.splice(o, 1));
      }
    },
    eventProperties: function() {
      var n = this, a = [], o = [];
      return _.forEach(function(i) {
        a.push({
          multiDragElement: i,
          index: i.sortableIndex
        });
        var s;
        G && i !== O ? s = -1 : G ? s = R(i, ":not(." + n.options.selectedClass + ")") : s = R(i), o.push({
          multiDragElement: i,
          index: s
        });
      }), {
        items: di(_),
        clones: [].concat(J),
        oldIndicies: a,
        newIndicies: o
      };
    },
    optionListeners: {
      multiDragKey: function(n) {
        return n = n.toLowerCase(), n === "ctrl" ? n = "Control" : n.length > 1 && (n = n.charAt(0).toUpperCase() + n.substr(1)), n;
      }
    }
  });
}
function Ai(e, t) {
  _.forEach(function(n, a) {
    var o = t.children[n.sortableIndex + (e ? Number(a) : 0)];
    o ? t.insertBefore(n, o) : t.appendChild(n);
  });
}
function wn(e, t) {
  J.forEach(function(n, a) {
    var o = t.children[n.sortableIndex + (e ? Number(a) : 0)];
    o ? t.insertBefore(n, o) : t.appendChild(n);
  });
}
function nt() {
  _.forEach(function(e) {
    e !== O && e.parentNode && e.parentNode.removeChild(e);
  });
}
g.mount(new Ni());
g.mount(on, an);
g.mount(new Li());
g.mount(new Ri());
const zi = ':host{display:block;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif;width:inherit}.nylas-booking-form-config{width:inherit;display:flex;flex-direction:column;margin:1rem}.nylas-booking-form-config .header{padding:1rem;display:flex;justify-content:space-between}.nylas-booking-form-config .header .header_text h3{margin:0;font-size:16px;font-weight:500;line-height:20px;color:var(--nylas-base-900);text-align:left}.nylas-booking-form-config .header .header_text p{margin:0.25rem 0 0 0;font-size:0.875rem;font-weight:400;line-height:20px;color:var(--nylas-base-600);text-align:left}.nylas-booking-form-config .header .header_action{display:flex}.nylas-booking-form-config .header .header_action select-dropdown::part(sd_dropdown-button){width:100%;display:flex;justify-content:space-between;align-items:center;border:1px solid var(--nylas-base-200);border-radius:var(--nylas-border-radius-2x);padding:1rem}.nylas-booking-form-config .content{padding:1rem;color:var(--nylas-base-900);font-size:16px;font-family:var(--nylas-font-family)}@media screen and (max-width: 504px){.nylas-booking-form-config .content{font-size:15px}}.nylas-booking-form-config .content .additional_fields{display:flex;flex-direction:column;gap:1rem;margin:1rem 0;position:relative;overflow:auto}@media screen and (max-width: 504px){.nylas-booking-form-config .content .additional_fields{gap:0.5rem;padding:0}}.nylas-booking-form-config .content .additional_fields .form-field{border-radius:var(--nylas-border-radius-2x);border:1px solid var(--nylas-base-200);padding:1rem;user-select:none;background-color:white;position:relative}.nylas-booking-form-config .content .additional_fields .form-field.highlight{background-color:var(--nylas-base-200)}.nylas-booking-form-config .content .additional_fields .form-field .form-field_header{display:flex;justify-content:space-between;align-items:center}.nylas-booking-form-config .content .additional_fields .form-field .form-field_header .dragable{cursor:move}.nylas-booking-form-config .content .additional_fields .form-field .form-field_header .form-field_header_text{flex:1;text-align:left;padding-left:1rem}.nylas-booking-form-config .content .additional_fields .form-field .form-field_header .form-field_header_text h4{margin:0;font-size:16px;line-height:20px;color:var(--nylas-base-900);text-align:left}.nylas-booking-form-config .content .additional_fields .form-field .form-field_header .form-field_header_text p{margin:0.25rem 0 0 0;font-size:0.875rem;font-weight:400;line-height:20px;color:var(--nylas-base-600);text-align:left}.nylas-booking-form-config .content .additional_fields .form-field .form-field_header .form-field_header_actions{display:flex;align-items:center}.nylas-booking-form-config .content .additional_fields .form-field .form-field_header .form-field_header_actions .is-required{color:var(--nylas-base-500);background-color:var(--nylas-base-50);font-weight:600;padding:4px 8px;border-radius:var(--nylas-border-radius-2x)}.nylas-booking-form-config .content .additional_fields .form-field .form-field_header .form-field_header_actions button{border:none;background:transparent;height:40px;margin:0 1rem;cursor:pointer;color:var(--nylas-base-800)}.nylas-booking-form-config .content .additional_fields .form-field .form-field_header .form-field_header_actions button:hover,.nylas-booking-form-config .content .additional_fields .form-field .form-field_header .form-field_header_actions button:active{color:var(--nylas-primary)}.nylas-booking-form-config .content .additional_fields .form-field .form-field_header .form-field_header_actions .chevron{display:flex;align-self:center;cursor:pointer}.nylas-booking-form-config .content .additional_fields .form-field .form-field_header .form-field_header_actions .chevron:hover,.nylas-booking-form-config .content .additional_fields .form-field .form-field_header .form-field_header_actions .chevron:active{color:var(--nylas-primary)}.nylas-booking-form-config .content .additional_fields .form-field .form-field_header .form-field_header_actions .chevron.open{transform:rotate(90deg)}.nylas-booking-form-config .content .additional_fields .form-field .form-field_header .form-field_header_actions .chevron.closed{transform:rotate(270deg)}.nylas-booking-form-config .content .additional_fields .form-field .form-field_content{padding:1.5rem 0 0 2.7rem}.nylas-booking-form-config .content .additional_fields .form-field .form-field_content.hidden{display:none}.nylas-booking-form-config .content .additional_fields .form-field .form-field_content .inputs{display:flex}.nylas-booking-form-config .content .additional_fields .form-field .form-field_content .inputs .label-input{padding:0 1rem 0 0}.nylas-booking-form-config .content .additional_fields .form-field .form-field_content .inputs .required-input{display:flex}.nylas-booking-form-config .content .additional_fields .form-field .form-field_content .inputs .required-input label{padding:0.5rem}.nylas-booking-form-config .content .additional_fields .form-field .form-field_content .inputs .required-input input[type=checkbox]{transform:scale(1.3)}.nylas-booking-form-config .content .additional_fields .form-field .form-field_content .options-container h4{margin:0;font-size:16px;line-height:20px;font-weight:500;padding:0.5rem 0;color:var(--nylas-base-900);text-align:left}.nylas-booking-form-config .content .additional_fields .form-field .form-field_content .options-container button{border:none;background:transparent;height:40px;margin:1rem 0;cursor:pointer;color:var(--nylas-base-800);display:flex;align-items:center;justify-content:space-between}.nylas-booking-form-config .content .additional_fields .form-field .form-field_content .options-container button:hover,.nylas-booking-form-config .content .additional_fields .form-field .form-field_content .options-container button:active{color:var(--nylas-primary)}.nylas-booking-form-config .content .additional_fields .form-field .form-field_content .options-container .options{display:flex;flex-direction:column;gap:1rem}.nylas-booking-form-config .content .additional_fields .form-field .form-field_content .options-container .options .option{display:flex;justify-content:space-between;align-items:center}.nylas-booking-form-config .content .additional_fields .form-field .form-field_content .options-container .options .option button{border:none;background:transparent;height:40px;margin:0 1rem;cursor:pointer;color:var(--nylas-base-800)}.nylas-booking-form-config .content .additional_fields .form-field .form-field_content .options-container .options .option button:hover,.nylas-booking-form-config .content .additional_fields .form-field .form-field_content .options-container .options .option button:active{color:var(--nylas-primary)}', ji = zi;
var Bi = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, Tt = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const zn = class {
  constructor(e) {
    x(this, e), this.valueChanged = L(this, "valueChanged", 7), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals), this.selectedConfiguration = void 0, this.name = "booking-form-config", this.additonalFields = [], this.formFields = [
      {
        type: "text",
        label: "Your name",
        key: "your_name",
        typeLabel: "Short text",
        readonly: !0,
        required: !0,
        isOpen: !1,
        order: 0
      },
      {
        type: "email",
        label: "Your Email",
        key: "your_email",
        typeLabel: "Email",
        readonly: !0,
        isOpen: !1,
        required: !0,
        order: 1
      },
      ...this.additonalFields.sort((t, n) => t.order - n.order).map((t, n) => {
        const { typeLabel: a } = dn.find((o) => o.type === t.type);
        return t.order = n + 2, { ...t, isOpen: !1, typeLabel: a };
      })
    ];
  }
  elementNameChangedHandler(e) {
    d("nylas-calendar-picker", "elementNameChangedHandler", e), this.host.setAttribute("name", e);
  }
  connectedCallback() {
    d("nylas-booking-form-config", "connectedCallback");
  }
  disconnectedCallback() {
    d("nylas-booking-form-config", "disconnectedCallback");
  }
  componentWillLoad() {
    d("nylas-booking-form-config", "componentWillLoad"), this.host.setAttribute("name", this.name);
  }
  componentDidLoad() {
    var t;
    d("nylas-booking-form-config", "componentDidLoad");
    const e = (t = this.host.shadowRoot) == null ? void 0 : t.getElementById("fields");
    g.create(e, {
      animation: 150,
      swap: !0,
      swapClass: "highlight",
      onEnd: this.swapFields.bind(this),
      filter: ".fixed",
      onMove: (n) => !n.related.classList.contains("fixed")
    });
  }
  watchHandler(e) {
    const a = e.filter((o) => !o.readonly).sort((o, i) => o.order - i.order).map((o, i) => ({ ...{
      type: o.type,
      required: o.required,
      label: o.label,
      order: i + 1,
      options: o.options,
      key: o.key
    } })).reduce((o, i) => (o[i.key] = {
      type: i.type,
      required: i.required,
      order: i.order,
      options: i.options,
      label: i.label
    }, o), {});
    this.valueChanged.emit({
      value: a,
      name: this.name
    });
  }
  nylasFormDropdownChangedHandler(e) {
    const { name: t, value: n } = e.detail;
    if (t === "add-field") {
      const a = dn.find((l) => l.type === n), o = Math.max(...this.formFields.map((l) => l.order)), i = { ...a, order: o + 1 }, s = this.formFields.filter((l) => l.label.startsWith(a.label));
      if (s && s.length > 0) {
        const l = `${a.label} ${s.length + 1}`;
        i.label = l;
        const c = l.split(" ").join("_");
        i.key = c;
      }
      this.formFields = [...this.formFields, i];
    }
  }
  nylasFormInputChangedHandler(e) {
    const { name: t } = e.detail, [n, a] = t.split("_");
    a ? this.fieldOptionChange(parseInt(n), parseInt(a), e) : this.fieldLabelChange(parseInt(n), e);
  }
  swapFields(e) {
    const { oldIndex: t, newIndex: n } = e;
    if (t !== void 0 && n !== void 0 && t !== n) {
      const a = [...this.formFields].map((o) => o.order === t ? {
        ...o,
        order: n
      } : o.order === n ? {
        ...o,
        order: t
      } : o);
      this.formFields = a;
    }
  }
  fieldToggle(e) {
    this.formFields = this.formFields.map((t, n) => (e == n && (t.isOpen = !t.isOpen), t));
  }
  fieldRemove(e) {
    this.formFields = this.formFields.filter((t, n) => n !== e);
  }
  fieldRequired(e) {
    this.formFields = this.formFields.map((t, n) => (n === e && (t.required = !t.required), t));
  }
  fieldLabelChange(e, t) {
    const n = t.detail;
    this.formFields = this.formFields.map((a, o) => (o === e && (a.label = n.value), a));
  }
  fieldOptionAdd(e) {
    this.formFields = this.formFields.map((t, n) => (n === e && (t.options || (t.options = []), t.options = [...t.options, ""]), t));
  }
  fieldOptionRemove(e, t) {
    this.formFields = this.formFields.map((n, a) => (a === e && (n.options || (n.options = []), n.options = n.options.filter((o, i) => i !== t)), n));
  }
  fieldOptionChange(e, t, n) {
    this.formFields = this.formFields.map((a, o) => (o === e && (a.options || (a.options = []), a.options = a.options.map((i, s) => (s === t && (i = n.detail.value), i))), a));
  }
  render() {
    return r(H, { key: "06f5993da0d37ecfa8d52b05087f3332e2ff3584" }, r("div", { key: "a5607b9d0a3e302199fec4826fd520897b9b7ac5", class: "nylas-booking-form-config" }, r("div", { key: "4ae825b6b21476e9ac944abfba3bcc4b3554a1f5", class: "header", part: "nbfc__header" }, r("div", { key: "b190e92adf6f52413d105552ab60ca1fdfe9107b", class: "header_text" }, r("h3", { key: "cc7e0ced6387888ce33dd47cdbc3675d0a226deb" }, "Booking form"), r("p", { key: "4631f069176cbe6e66161c75ebedd0d33b3872bb" }, "Customize the questions asked on the booking page.")), r("div", { key: "1e6bb648297adf4fd940fee7a7cf79d79cb0c79e", class: "header_action" }, r("select-dropdown", { key: "cf8f137c1674ab0ffd3ccb24fb26038775aa4905", name: "add-field", exportparts: "sd_dropdown: nbfc__add_field, sd_dropdown-button: nbfc__add_field-button, sd_dropdown-content: nbfc__add_field-dropdown-content", options: fa, withSearch: !1, withChevron: !1, dropdownButtonText: "Add new type" }, r("span", { key: "e7fe11729f4333e521eb13251582a9a2f8161014", slot: "select-icon" }, r("plus-icon", { key: "7a6956015c10621dca8badfa4b82554c370cc9f0", width: "15", height: "15" }))))), r("div", { key: "8154ad2f7d58aa55228c77c258e770b237c7a984", class: "content" }, r("div", { key: "f4ee5c314defa730b0fe0b8901fade765ac3b2c6", id: "fields", class: "additional_fields", part: "nbfc__additional_fields" }, this.formFields.map((e, t) => r("div", { class: `form-field draggable ${e.readonly && "fixed"}`, part: "nbfc__form_field", key: t }, r("div", { class: "form-field_header", part: "nbfc__form_field-header" }, r("span", { class: "dragable" }, r("dragable-icon", { width: "24", height: "25" })), r("div", { class: "form-field_header_text" }, r("h4", null, e.label), r("p", null, e.typeLabel)), r("div", { class: "form-field_header_actions" }, r("span", { class: "is-required" }, e.required ? "Required" : "Optional"), !e.readonly && r("button", { onClick: () => {
      this.fieldRemove(t);
    } }, r("close-icon", null)), r("span", { class: `chevron ${e.isOpen ? "open" : "closed"}`, onClick: () => {
      this.fieldToggle(t);
    } }, r("chevron-icon", { width: "24", height: "24" })))), r("div", { class: `form-field_content ${!e.isOpen && "hidden"}`, part: "nbfc__form_field-content" }, r("div", { class: "inputs" }, r("input-component", { class: "label-input", name: `${t}`, key: t, label: "Label", required: !1, readOnly: e.readonly, pattern: /^[a-zA-Z0-9\s]*$/, defaultValue: e.label }, r("div", { class: "required-input", slot: "additional-input" }, r("input", { type: "checkbox", name: `required_${e.order}`, id: `required_${e.order}`, onClick: () => {
      this.fieldRequired(t);
    }, checked: e.required, disabled: e.readonly }), r("label", { htmlFor: `required_${e.order}`, "aria-label": "Required" }, "Required")))), e.options != null && r("div", { class: "options-container" }, r("h4", null, "ALL OPTIONS"), r("div", { class: "options" }, e.options.map((n, a) => r("div", { class: "option" }, r("input-component", { key: a, name: `${t}_${a}`, label: e.typeLabel + " option " + (a + 1), required: !0, pattern: /^[a-zA-Z0-9\s]*$/, defaultValue: n }, a > 1 && r("div", { class: "required-input", slot: "additional-input" }, r("button", { onClick: () => {
      this.fieldOptionRemove(t, a);
    } }, r("close-icon", null))))))), r("button", { onClick: () => {
      this.fieldOptionAdd(t);
    }, part: "nap__add-time-range" }, r("add-circle-icon", null), " Add an option")))))))));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return $(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"],
      formFields: ["watchHandler"]
    };
  }
};
Bi([
  M({
    name: "nylas-booking-form-config",
    stateToProps: /* @__PURE__ */ new Map([["schedulerConfig.selectedConfiguration", "selectedConfiguration"]]),
    fireRegisterEvent: !0
  }),
  Tt("design:type", Function),
  Tt("design:paramtypes", []),
  Tt("design:returntype", void 0)
], zn.prototype, "render", null);
zn.style = ji;
const Wi = ':host{display:block;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif;width:inherit}.nylas-buffer-time{width:inherit;display:flex;flex-direction:column;margin:1rem;border-radius:var(--nylas-border-radius-2x);border:1px solid var(--nylas-base-200);text-align:left}.nylas-buffer-time .header{padding:1rem;border-bottom:1px solid var(--nylas-base-200)}.nylas-buffer-time .header h3{margin:0;font-size:1rem;font-weight:600;line-height:20px;color:var(--nylas-base-900);text-align:left}.nylas-buffer-time .header p{margin:0.25rem 0 0 0;font-size:0.875rem;font-weight:400;line-height:20px;color:var(--nylas-base-600);text-align:left}.nylas-buffer-time .nylas-buffer-time__body{display:grid;grid-template-columns:1fr auto}@media screen and (max-width: 768px){.nylas-buffer-time .nylas-buffer-time__body{grid-template-columns:1fr}}.nylas-buffer-time .nylas-buffer-time__body .nylas-buffer-time__dropdown{padding:1rem;display:flex;flex-direction:column;gap:1rem;border-right:1px solid var(--nylas-base-200);color:var(--nylas-base-800)}@media screen and (max-width: 768px){.nylas-buffer-time .nylas-buffer-time__body .nylas-buffer-time__dropdown{border:none}}.nylas-buffer-time .nylas-buffer-time__body .nylas-buffer-time__dropdown .nylas-buffer-time__row{display:grid;grid-template-columns:auto 1fr;align-items:center;gap:1rem}.nylas-buffer-time .nylas-buffer-time__body .nylas-buffer-time__dropdown .nylas-buffer-time__row label{width:200px}.nylas-buffer-time .nylas-buffer-time__body .nylas-buffer-time__dropdown .nylas-buffer-time__row .dropdown-container{display:flex;gap:1rem;align-items:center;justify-content:flex-end}.nylas-buffer-time .nylas-buffer-time__body .nylas-buffer-time__preview{width:208px;background:var(--nylas-base-25);border-bottom-right-radius:var(--nylas-border-radius-2x)}@media screen and (max-width: 768px){.nylas-buffer-time .nylas-buffer-time__body .nylas-buffer-time__preview{width:inherit;border-bottom-left-radius:var(--nylas-border-radius-2x)}}.nylas-buffer-time .nylas-buffer-time__body .nylas-buffer-time__preview h4{font-size:14px;line-height:24px;color:var(--nylas-base-600);font-family:var(--nylas-font-family);font-weight:500;text-align:center;margin:0.75rem 0}.nylas-buffer-time .nylas-buffer-time__body .nylas-buffer-time__preview .preview-container{padding:0 2rem 1rem}.nylas-buffer-time .nylas-buffer-time__body .nylas-buffer-time__preview .preview-container .slot{background-color:transparent;border-top:1px solid var(--nylas-base-300)}.nylas-buffer-time .nylas-buffer-time__body .nylas-buffer-time__preview .preview-container .slot.active{background-color:var(--nylas-base-100)}.nylas-buffer-time .nylas-buffer-time__body .nylas-buffer-time__preview .preview-container .slot:last-of-type{border-bottom:1px solid var(--nylas-base-300)}.nylas-buffer-time .nylas-buffer-time__body .nylas-buffer-time__preview .preview-container .event-slot{background-color:var(--nylas-base-600);border-top:1px solid var(--nylas-base-300)}.nylas-buffer-time .nylas-buffer-time__dropdown select-dropdown::part(sd_dropdown-button){width:104px;display:flex;justify-content:space-between;align-items:center;border:1px solid var(--nylas-base-200);border-radius:var(--nylas-border-radius-2x);padding:1rem}.nylas-buffer-time .nylas-buffer-time__dropdown select-dropdown::part(sd_dropdown-content){width:100%}.nylas-buffer-time .nylas-buffer-time__dropdown select-dropdown::part(sd_dropdown-button-selected-label){max-width:calc(100% - 2rem);font-family:var(--nylas-font-family);font-size:16px;line-height:24px}', Zi = Wi;
var Ui = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, It = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const jn = class {
  constructor(e) {
    x(this, e), this.valueChanged = L(this, "valueChanged", 7), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals), this.name = "buffer-time", this.buffer = { before: 0, after: 0 }, this.selectedBeforeBufferTime = this.buffer.before, this.selectedAfterBufferTime = this.buffer.after;
  }
  connectedCallback() {
    d("nylas-buffer-time", "connectedCallback");
  }
  disconnectedCallback() {
    d("nylas-buffer-time", "disconnectedCallback");
  }
  componentWillLoad() {
    d("nylas-buffer-time", "componentWillLoad"), this.host.setAttribute("name", this.name);
  }
  componentDidLoad() {
    if (d("nylas-buffer-time", "componentDidLoad"), typeof this.internals.setFormValue == "function") {
      const e = {
        before: this.selectedBeforeBufferTime,
        after: this.selectedAfterBufferTime
      };
      this.internals.setFormValue(JSON.stringify(e), this.name);
    }
    this.selectedAfterBufferTime = this.buffer.after, this.selectedBeforeBufferTime = this.buffer.before;
  }
  componentWillUpdate() {
    d("nylas-buffer-time", "componentWillUpdate");
  }
  componentDidUpdate() {
    d("nylas-buffer-time", "componentDidUpdate");
  }
  componentWillRender() {
    d("nylas-buffer-time", "componentWillRender");
  }
  componentDidRender() {
    d("nylas-buffer-time", "componentDidRender");
  }
  elementNameChangedHandler(e) {
    d("nylas-buffer-time", "elementNameChangedHandler", e), this.host.setAttribute("name", e);
  }
  nylasFormDropdownChangedHandler(e) {
    d("nylas-buffer-time", "nylasFormDropdownChangedHandler", e.detail);
    const t = (n) => {
      const { value: a, name: o } = n.detail;
      o === "before-buffer-time" ? this.selectedBeforeBufferTime = parseInt(a) : o === "after-buffer-time" && (this.selectedAfterBufferTime = parseInt(a));
      const i = {
        before: this.selectedBeforeBufferTime,
        after: this.selectedAfterBufferTime
      };
      this.internals.setFormValue(JSON.stringify(i), "booking-calendar");
    };
    this.valueChanged.emit({ ...e.detail, valueChanged: t });
  }
  renderPreview() {
    const a = (s) => {
      const l = Math.floor(s / 30), c = s % 30 / 30 * 10;
      return {
        fullSlots: l,
        partialFillHeight: c
      };
    }, o = () => {
      const { fullSlots: s, partialFillHeight: l } = a(this.selectedBeforeBufferTime);
      return Array.from({ length: 4 }, (c, f) => {
        const p = this.selectedBeforeBufferTime > 0 && f > 4 - s - 1, m = this.selectedBeforeBufferTime > 0 && f === 4 - s - 1 && l > 0;
        let h = {};
        return p && !m ? h.backgroundColor = "var(--nylas-base-100)" : m && (h.background = `linear-gradient(to top, var(--nylas-base-100) ${l}px, transparent 0)`), r("div", { key: f, class: `slot ${p ? "active" : ""}`, style: {
          height: "10px",
          ...h
        } });
      });
    }, i = () => {
      const { fullSlots: s, partialFillHeight: l } = a(this.selectedAfterBufferTime);
      return Array.from({ length: 4 }, (c, f) => {
        const p = this.selectedAfterBufferTime > 0 && f < s, m = f === s && l > 0;
        let h = {};
        return p && !m ? h.backgroundColor = "var(--nylas-base-100)" : m && (h.background = `linear-gradient(to bottom, var(--nylas-base-100) ${l}px, transparent 0)`), r("div", { key: f, class: `slot ${p ? "active" : ""}`, style: {
          height: "10px",
          ...h
        } });
      });
    };
    return r("div", { class: "preview-container" }, o(), r("div", { class: "event-slot", style: { height: "20px" } }), i());
  }
  render() {
    const e = Array.from({ length: 25 }, (t, n) => {
      const a = n * 5;
      return {
        label: a.toString(),
        value: a
      };
    });
    return r(H, null, r("div", { class: "nylas-buffer-time", part: "nbt" }, r("div", { class: "header", part: "nbt__header" }, r("h3", null, "Buffer time"), r("p", null, "Add buffer time before and after the event.")), r("div", { class: "nylas-buffer-time__body", part: "nbt__body" }, r("div", { class: "nylas-buffer-time__dropdown" }, r("div", { class: "nylas-buffer-time__row" }, r("label", null, "Before the event"), r("div", { class: "dropdown-container" }, r("select-dropdown", { id: "before-buffer-time", withSearch: !1, name: "before-buffer-time", exportparts: "sd_dropdown: nbt__dropdown-before, sd_dropdown-button: nbt__dropdown-button-before, sd_dropdown-content: nbt__dropdown-content-before", options: e, defaultSelectedOption: e.find((t) => t.value == this.selectedBeforeBufferTime) ?? e[0] }), r("span", null, "mins"))), r("div", { class: "nylas-buffer-time__row" }, r("label", null, "After the event"), r("div", { class: "dropdown-container" }, r("select-dropdown", { id: "after-buffer-time", withSearch: !1, name: "after-buffer-time", exportparts: "sd_dropdown: nbt__dropdown-after, sd_dropdown-button: nbt__dropdown-button-after, sd_dropdown-content: nbt__dropdown-content-after", options: e, defaultSelectedOption: e.find((t) => t.value == this.selectedAfterBufferTime) ?? e[0] }), r("span", null, "mins")))), r("div", { class: "nylas-buffer-time__preview", part: "nbt__preview" }, r("h4", null, "PREVIEW"), this.renderPreview()))));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return $(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"]
    };
  }
};
Ui([
  M({
    name: "nylas-buffer-time",
    eventToProps: {
      valueChanged: async (e, t) => {
        const { valueChanged: n } = e.detail;
        n && n(e);
      }
    },
    fireRegisterEvent: !0
  }),
  It("design:type", Function),
  It("design:paramtypes", []),
  It("design:returntype", void 0)
], jn.prototype, "render", null);
jn.style = Zi;
const Vi = ':host{display:block;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif;width:inherit}.nylas-calendar-picker{width:inherit;display:flex;flex-direction:column;margin:1rem;border-radius:var(--nylas-border-radius-2x);border:1px solid var(--nylas-base-200)}.nylas-calendar-picker .nylas-calendar-picker__loading{padding-bottom:1rem;display:flex;flex-direction:column;gap:4px}.nylas-calendar-picker .nylas-calendar-picker__loading .label{display:flex;align-items:center;gap:0.5rem;margin:1rem 1rem 0;color:var(--nylas-base-800)}.nylas-calendar-picker .nylas-calendar-picker__loading .label tooltip-component{display:flex}.nylas-calendar-picker .nylas-calendar-picker__loading .loading-button{margin:0 1rem;padding:0;width:inherit;height:48px;color:black;font-size:1rem;cursor:not-allowed;display:flex;gap:0.5rem;justify-content:space-between;align-items:center;background:transparent;border:1px solid var(--nylas-base-200);border-radius:var(--nylas-border-radius-2x)}.nylas-calendar-picker .nylas-calendar-picker__loading .loading-button span{padding:0 1rem}.nylas-calendar-picker .nylas-calendar-picker__dropdown{padding:1rem}.nylas-calendar-picker .nylas-calendar-picker__dropdown multi-select-dropdown::part(msd_dropdown){width:100%;display:flex;flex-direction:column;gap:4px}.nylas-calendar-picker .nylas-calendar-picker__dropdown multi-select-dropdown::part(msd_dropdown-button){width:100%;display:flex;justify-content:space-between;align-items:center;border:1px solid var(--nylas-base-200);border-radius:var(--nylas-border-radius-2x);padding:1rem}.nylas-calendar-picker .nylas-calendar-picker__dropdown multi-select-dropdown::part(msd_dropdown-button--error){border:1px solid var(--nylas-error)}.nylas-calendar-picker .nylas-calendar-picker__dropdown multi-select-dropdown::part(msd_dropdown-content){width:100%;max-width:unset}.nylas-calendar-picker .nylas-calendar-picker__dropdown multi-select-dropdown::part(msd_dropdown-button-selected-label){max-width:calc(100% - 2rem);font-family:var(--nylas-font-family);font-size:16px;line-height:24px}', qi = Vi;
var Gi = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, Ht = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const Bn = class {
  constructor(e) {
    x(this, e), this.valueChanged = L(this, "valueChanged", 7), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals), this.calendars = void 0, this.currentUser = void 0, this.name = "calendar", this.defaultSelectedCalendars = [], this.selectedCalendars = [], this.error = "";
  }
  elementNameChangedHandler(e) {
    d("nylas-calendar-picker", "elementNameChangedHandler", e), this.host.setAttribute("name", e);
  }
  connectedCallback() {
    d("nylas-calendar-picker", "connectedCallback");
  }
  disconnectedCallback() {
    d("nylas-calendar-picker", "disconnectedCallback");
  }
  componentWillLoad() {
    d("nylas-calendar-picker", "componentWillLoad"), this.host.setAttribute("name", this.name);
  }
  componentDidLoad() {
    d("nylas-calendar-picker", "componentDidLoad"), typeof this.internals.setFormValue == "function" && (this.internals.setFormValue(this.defaultSelectedCalendars.toString(), "calendar"), this.valueChanged.emit({ value: this.defaultSelectedCalendars, name: this.name }));
  }
  componentWillUpdate() {
    d("nylas-calendar-picker", "componentWillUpdate");
  }
  componentDidUpdate() {
    d("nylas-calendar-picker", "componentDidUpdate");
  }
  componentWillRender() {
    d("nylas-calendar-picker", "componentWillRender");
  }
  componentDidRender() {
    d("nylas-calendar-picker", "componentDidRender");
  }
  selectedOptionsChangedHandler(e) {
    d("nylas-calendar-picker", "nylasFormDropdownChangedHandler", e.detail);
    const t = (n) => {
      const { value: a } = n.detail;
      this.selectedCalendars = [...a], this.selectedCalendars.length === 0 ? (this.error = "At least one calendar must be selected.", this.internals.setValidity({ customError: !0 }, "At least one calendar must be selected.")) : (this.error = "", this.internals.setValidity({})), this.internals.setFormValue(a.toString(), this.name);
    };
    this.valueChanged.emit({ ...e.detail, name: this.name, valueChangedHandler: t });
  }
  render() {
    var t;
    const e = ((t = this.calendars) == null ? void 0 : t.map((n) => {
      var a, o, i, s;
      return {
        value: n.id,
        label: n.name,
        selected: ((a = this.defaultSelectedCalendars) == null ? void 0 : a.includes(n.id)) || ((o = this.defaultSelectedCalendars) != null && o.includes("primary") || ((i = this.defaultSelectedCalendars) == null ? void 0 : i.length) === 0 ? n.id === ((s = this.currentUser) == null ? void 0 : s.email) || n.id === this.name.split("participant-")[1] : !1)
      };
    })) ?? [];
    return r(H, null, r("div", { class: "nylas-calendar-picker", part: "ncp" }, e.length > 0 ? r("div", { class: "nylas-calendar-picker__dropdown" }, r("multi-select-dropdown", { name: this.name, options: e, error: this.error, exportparts: "msd_dropdown: ncp__dropdown, msd_dropdown-button: ncp__dropdown-button, msd_dropdown-content: ncp__dropdown-content" })) : r("div", { class: "nylas-calendar-picker__loading" }, r("span", { class: "label" }, "Select calendars that will be checked for availability ", r("info-icon", null)), r("div", { class: "loading-button" }, r("span", null, "Loading...")))));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return $(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"]
    };
  }
};
Gi([
  M({
    name: "nylas-calendar-picker",
    stateToProps: /* @__PURE__ */ new Map([["schedulerConfig.currentUser", "currentUser"]]),
    eventToProps: {
      valueChanged: async (e, t) => {
        const { valueChangedHandler: n } = e.detail;
        n && n(e);
      }
    },
    fireRegisterEvent: !0
  }),
  Ht("design:type", Function),
  Ht("design:paramtypes", []),
  Ht("design:returntype", void 0)
], Bn.prototype, "render", null);
Bn.style = qi;
const Yi = ':host{--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif}.nylas-cancellation-policy{display:flex;flex-direction:column;gap:4px}.nylas-cancellation-policy label{display:flex;align-items:center;color:var(--nylas-base-800);font-size:16px;font-style:normal;font-weight:400;line-height:150%;}.nylas-cancellation-policy label span.label-icon{margin-left:4px}.nylas-cancellation-policy label span.label-icon tooltip-component{display:flex}.nylas-cancellation-policy textarea{padding:12px 16px;border-width:1;resize:vertical;border-radius:8px;font-family:var(--nylas-font-family);font-size:16px;line-height:24px;border:1px solid var(--nylas-base-200)}.nylas-cancellation-policy textarea::-webkit-resizer{display:none}', Ji = Yi;
var Xi = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, $t = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const Wn = class {
  constructor(e) {
    var t, n;
    x(this, e), this.valueChanged = L(this, "valueChanged", 7), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals), this.selectedConfiguration = void 0, this.cancellationPolicy = void 0, this.name = "cancelation-policy", this.message = this.cancellationPolicy || ((n = (t = this.selectedConfiguration) == null ? void 0 : t.scheduler) == null ? void 0 : n.cancellation_policy) || "";
  }
  elementNameChangedHandler(e) {
    d("nylas-cancellation-policy", "elementNameChangedHandler", e), this.host.setAttribute("name", e);
  }
  selectedConfigurationChangedHandler(e, t) {
    var n, a;
    d("nylas-custom-booking-flow", "selectedConfigurationChangedHandler", e, t), (n = e == null ? void 0 : e.scheduler) != null && n.cancellation_policy && (this.message = (a = e == null ? void 0 : e.scheduler) == null ? void 0 : a.cancellation_policy);
  }
  connectedCallback() {
    d("nylas-cancellation-policy", "connectedCallback");
  }
  componentWillLoad() {
    d("nylas-cancellation-policy", "componentWillLoad"), this.host.setAttribute("name", this.name);
  }
  componentDidLoad() {
    d("nylas-cancellation-policy", "componentDidLoad");
  }
  disconnectedCallback() {
    d("nylas-cancellation-policy", "disconnectedCallback");
  }
  handleChange(e) {
    const t = qe(e.target.value);
    this.message = t, this.internals.setFormValue(t, this.name), this.valueChanged.emit({ value: t, name: this.name });
  }
  render() {
    return r(H, { key: "876b5cdeb90cbf79881c806ac75114ed06e63435" }, r("div", { key: "80feeecf3e9885c2e4b382e74951691d471585b7", class: "nylas-cancellation-policy", part: "ncpolicy" }, r("label", { key: "d19f1ce00b6aa75da62de1db90a7cc9adcc1695e", htmlFor: this.name }, "Cancellation policy message", r("span", { key: "2651d7b35bfbf27d3e26bc0c5827fa846cbe5541", class: "label-icon" }, r("tooltip-component", { key: "45cc24192af2ed658aeee9707a89b76bf16a6cfd" }, r("info-icon", { key: "7f579d6beed8041ed6875c8d33d832953edf97ae", slot: "tooltip-icon" }), r("span", { key: "b853d3fdb97dad7eec2ff58566d146ec9682e279", slot: "tooltip-content" }, "Attendees receive this message if trying to cancel the event. Attendees are asked to provide a reason for cancellation.")))), r("textarea", { key: "1e013eef034a9a41e96e5f58d996a4372acdfd34", id: this.name, part: "ncpolicy__textarea", name: this.name, value: this.message, maxlength: "250", onInput: (e) => this.handleChange(e) })));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return $(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"],
      selectedConfiguration: ["selectedConfigurationChangedHandler"]
    };
  }
};
Xi([
  M({
    name: "nylas-cancellation-policy",
    stateToProps: /* @__PURE__ */ new Map([["schedulerConfig.selectedConfiguration", "selectedConfiguration"]]),
    eventToProps: {},
    fireRegisterEvent: !0
  }),
  $t("design:type", Function),
  $t("design:paramtypes", []),
  $t("design:returntype", void 0)
], Wn.prototype, "render", null);
Wn.style = Ji;
const Ki = ':host{display:block;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif;width:inherit}.nylas-confirmation-email{width:inherit;display:flex;flex-direction:column;margin:1rem;border-radius:var(--nylas-border-radius-2x);border:1px solid var(--nylas-base-200);text-align:left}.nylas-confirmation-email .header{padding:1rem;display:grid;grid-template-columns:1fr auto;border-bottom:1px solid var(--nylas-base-200)}.nylas-confirmation-email .header h3{border-radius:var(--nylas-border-radius-2x);margin:0;font-size:1rem;font-weight:600;line-height:20px;color:var(--nylas-base-900);text-align:left}.nylas-confirmation-email .header p{margin:0.25rem 0 0 0;font-size:0.875rem;font-weight:400;line-height:20px;color:var(--nylas-base-600);text-align:left}.nylas-confirmation-email .header .confirmation-email-toggle{display:flex;gap:24px;align-items:center}.nylas-confirmation-email .header .confirmation-email-toggle .chevron{display:flex;align-self:center;cursor:pointer}.nylas-confirmation-email .header .confirmation-email-toggle .chevron:hover,.nylas-confirmation-email .header .confirmation-email-toggle .chevron:active{color:var(--nylas-primary)}.nylas-confirmation-email .header .confirmation-email-toggle .chevron.open{transform:rotate(90deg)}.nylas-confirmation-email .header .confirmation-email-toggle .chevron.closed{transform:rotate(270deg)}.nylas-confirmation-email .header .confirmation-email-toggle .chevron.disabled{cursor:not-allowed;color:var(--nylas-base-300)}.nylas-confirmation-email .header .confirmation-email-toggle .chevron.disabled:hover{color:var(--nylas-base-300)}.nylas-confirmation-email .nylas-confirmation-email__body{display:grid;grid-template-columns:1fr auto;background-color:var(--nylas-base-25);border-radius:var(--nylas-border-radius-2x)}@media screen and (max-width: 768px){.nylas-confirmation-email .nylas-confirmation-email__body{grid-template-columns:1fr}}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__section{padding:1rem;display:flex;flex-direction:column;gap:1rem;color:var(--nylas-base-800)}@media screen and (max-width: 768px){.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__section{border:none}}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__section .nylas-confirmation-email__row{display:grid;grid-template-columns:1fr auto;align-items:center;gap:1rem}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__section .nylas-confirmation-email__row.full-width-col{grid-template-columns:1fr}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__section .nylas-confirmation-email__row label{display:flex;align-items:center}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__section .nylas-confirmation-email__row label span.required{color:var(--nylas-error, #cc4841)}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__section .nylas-confirmation-email__row label span.label-icon{margin-left:4px}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__section .nylas-confirmation-email__row label span.label-icon tooltip-component{display:flex}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__section .nylas-confirmation-email__row p{margin:0.25rem 0 0 0;font-size:1rem;font-weight:500;line-height:24px;color:var(--nylas-base-900)}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__section .nylas-confirmation-email__row .company-logo-container{display:flex;gap:32px;width:100%}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__section .nylas-confirmation-email__row .company-logo-container .input-container{display:flex;flex-direction:column;flex:1}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__section .nylas-confirmation-email__row .company-logo-container .company-logo{display:flex;justify-content:center;align-items:center;width:200px;height:100px;border:var(--nylas-base-200) solid 1px;border-radius:var(--nylas-border-radius-2x);overflow:hidden;padding:10px}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__section .nylas-confirmation-email__row .company-logo-container .company-logo img{height:100%;object-fit:cover;object-position:center}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__section .nylas-confirmation-email__row span.selected-value{font-weight:500}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__section .subsection{display:flex;flex-direction:column;gap:1rem}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__section .subsection h3{margin:0;font-size:1rem;font-weight:600;line-height:20px;color:var(--nylas-base-900);text-align:left}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__section .subsection .input-container{display:flex;flex-direction:column;gap:0.25rem}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__section .subsection .input-container textarea{padding:12px 16px;border-width:1;resize:vertical;border-radius:8px;font-family:var(--nylas-font-family);font-size:16px;line-height:24px;border:1px solid var(--nylas-base-200)}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__preview{width:208px;background:var(--nylas-base-25);border-bottom-right-radius:var(--nylas-border-radius-2x)}@media screen and (max-width: 768px){.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__preview{width:inherit;border-bottom-left-radius:var(--nylas-border-radius-2x)}}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__preview h4{font-size:14px;line-height:24px;color:var(--nylas-base-600);font-family:var(--nylas-font-family);font-weight:500;text-align:center;margin:0.75rem 0}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__preview .preview-container{padding:0 2rem 1rem}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__preview .preview-container .slot{background-color:transparent;border-top:1px solid var(--nylas-base-300)}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__preview .preview-container .slot.active{background-color:var(--nylas-base-100)}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__preview .preview-container .slot:last-of-type{border-bottom:1px solid var(--nylas-base-300)}.nylas-confirmation-email .nylas-confirmation-email__body .nylas-confirmation-email__preview .preview-container .event-slot{background-color:var(--nylas-base-600);border-top:1px solid var(--nylas-base-300)}.nylas-confirmation-email .nylas-confirmation-email__body span.error-message{color:var(--nylas-error)}.nylas-confirmation-email .nylas-confirmation-email__body span.help-text{margin:0.25rem 0 0 0;font-size:0.875rem;font-weight:400;line-height:20px;color:var(--nylas-base-600);text-align:left}.nylas-confirmation-email .nylas-confirmation-email__summary{padding:0.75rem 1rem;display:grid;grid-template-columns:auto 1fr;column-gap:1rem}.nylas-confirmation-email .nylas-confirmation-email__summary p{margin:0;display:flex;align-items:center;column-gap:4px;font-size:0.875rem;font-weight:400;line-height:21px;color:var(--nylas-base-600);text-align:left}.nylas-confirmation-email .nylas-confirmation-email__summary p span.summary-icon{display:flex;justify-content:center;min-width:20px}sp-divider{background-color:var(--nylas-base-200);height:1px;margin:0.25rem 0}', Qi = Ki;
var eo = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, Mt = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const Zn = class {
  constructor(e) {
    x(this, e), this.valueChanged = L(this, "valueChanged", 7), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals), this.confirmationEmailTemplate = {}, this.isOpen = !1, this.participants = [], this.companyLogoErrorMessage = "", this.name = "confirmation-email-template", this.confirmationEmail = this.confirmationEmailTemplate;
  }
  connectedCallback() {
    d("nylas-confirmation-email", "connectedCallback");
  }
  disconnectedCallback() {
    d("nylas-confirmation-email", "disconnectedCallback");
  }
  componentWillLoad() {
    d("nylas-confirmation-email", "componentWillLoad"), this.host.setAttribute("name", this.name);
  }
  componentDidLoad() {
    d("nylas-confirmation-email", "componentDidLoad");
  }
  componentWillUpdate() {
    d("nylas-confirmation-email", "componentWillUpdate");
  }
  componentDidUpdate() {
    d("nylas-confirmation-email", "componentDidUpdate");
  }
  componentWillRender() {
    d("nylas-confirmation-email", "componentWillRender");
  }
  componentDidRender() {
    d("nylas-confirmation-email", "componentDidRender");
  }
  elementNameChangedHandler(e) {
    d("nylas-confirmation-email", "elementNameChangedHandler", e), this.host.setAttribute("name", e);
  }
  async nylasFormInputChangeHandler(e) {
    const { name: t, value: n } = e.detail;
    t === "confirmation-email-title" && (this.confirmationEmail = { ...this.confirmationEmail, booking_confirmed: { ...this.confirmationEmail.booking_confirmed, title: n } }, this.internals.setFormValue(JSON.stringify(this.confirmationEmail), "confirmation-email-template"), this.valueChanged.emit({ value: JSON.stringify(this.confirmationEmail), name: this.name }));
  }
  async nylasFormInputBlurHandler(e) {
    const { name: t, value: n } = e.detail;
    t === "company-logo" && (this.companyLogoErrorMessage = "", this.isValidLogoSize(n).then((a) => {
      if (!a) {
        this.companyLogoErrorMessage = "Image cannot exceed 100px in height and 200px in width.";
        return;
      }
      this.confirmationEmail = { ...this.confirmationEmail, logo: n }, this.internals.setFormValue(JSON.stringify(this.confirmationEmail), "confirmation-email-template"), this.valueChanged.emit({ value: JSON.stringify(this.confirmationEmail), name: "confirmation-email-template" });
    }).catch(() => {
      this.companyLogoErrorMessage = "Failed to validate the image.";
    }));
  }
  isValidLogoSize(e) {
    return new Promise((t, n) => {
      if (e === "")
        return t(!0);
      const a = new Image();
      a.src = e, a.onerror = () => {
        this.companyLogoErrorMessage = "Invalid image URL.", n(!1);
      }, a.onload = () => {
        a.width <= 200 && a.height <= 100 ? t(!0) : (this.companyLogoErrorMessage = "Image cannot exceed 100px in height and 200px in width.", t(!1));
      };
    });
  }
  updateConfirmationFormValue() {
    d("nylas-confirmation-email", "updateConfirmationFormValue"), this.internals.setFormValue(JSON.stringify(this.confirmationEmail), this.name), this.valueChanged.emit({ value: JSON.stringify(this.confirmationEmail), name: this.name });
  }
  toggleConfirmationEmail() {
    this.isOpen = !this.isOpen;
  }
  handleEmailBodyChange(e) {
    const t = qe(e.target.value);
    this.confirmationEmail = { ...this.confirmationEmail, booking_confirmed: { ...this.confirmationEmail.booking_confirmed, body: t } }, this.internals.setFormValue(JSON.stringify(this.confirmationEmail), this.name), this.valueChanged.emit({ value: JSON.stringify(this.confirmationEmail), name: this.name });
  }
  render() {
    var t;
    const e = (t = this.participants.find((n) => n.is_organizer)) == null ? void 0 : t.name;
    return r(H, { key: "d903a0549fcc0d961f5d000328b03d8f7fe069c3" }, r("div", { key: "bfada3e8b012ee1f53167ed5c23ff69a44357ecb", class: "nylas-confirmation-email", part: "nce" }, r("div", { key: "338032e7ee7b2135f4f6fe33c8d5695cbec6ac46", class: "header", part: "nce__header" }, r("div", { key: "dc7ab9474e27fd3ab9b125109054901dd9c4bc13" }, r("h3", { key: "a780b5b868982743ce3b6553ee3e9afe50a37984" }, this.confirmationEmail.booking_confirmed.title ?? `Booking confirmed with ${e ? ` with ${e}` : ""}`), r("p", { key: "07ec617af3828252083491fe86a912e6a171ab58" }, "Booking confirmation email")), this.isOpen ? r("div", { class: "confirmation-email-toggle", part: "nce__confirmation-email-toggle--container" }, r("span", { class: `chevron ${this.isOpen ? "open" : "closed"} `, onClick: () => this.toggleConfirmationEmail() }, r("chevron-icon", { width: "24", height: "24" }))) : r("button-component", { variant: "basic", clickHandler: (n) => {
      n.preventDefault(), this.toggleConfirmationEmail();
    } }, r("edit-icon", { width: "16", height: "16" }), "Edit")), this.isOpen ? r("div", { class: "nylas-confirmation-email__body", part: "nce__body" }, r("div", { class: "nylas-confirmation-email__section" }, r("div", { class: "nylas-confirmation-email__row" }, r("label", null, "Send confirmation email when", r("span", { class: "label-icon" }, r("tooltip-component", null, r("info-icon", { slot: "tooltip-icon" }), r("span", { slot: "tooltip-content" }, "You and your guests will receive a confirmation email immediately upon booking.")))), r("span", { class: "selected-value" }, "Immediately upon booking")), r("div", { class: `nylas-confirmation-email__row ${this.companyLogoErrorMessage ? "" : "full-width-col"} ` }, r("div", { class: "subsection" }, r("div", { class: "input-container" }, r("label", null, "Company logo URL", r("span", { class: "label-icon" }, r("tooltip-component", null, r("info-icon", { slot: "tooltip-icon" }), r("span", { slot: "tooltip-content" }, "Provide a URL to a logo or image that will be included in your confirmation and reminder emails. Max size 200px by 100px.")))), r("div", { class: "company-logo-container" }, r("div", { class: "input-container" }, r("input-component", { name: "company-logo", id: "company-logo", type: "text", required: !1, part: "nrt__input-textfield", defaultValue: this.confirmationEmail.logo ?? "" }), this.companyLogoErrorMessage && r("span", { class: "error-message" }, this.companyLogoErrorMessage)), this.confirmationEmail.logo && !this.companyLogoErrorMessage && r("div", { class: "company-logo" }, r("img", { src: this.confirmationEmail.logo, alt: "Company logo" })))))), r("sp-divider", null), r("div", { class: "nylas-confirmation-email__row full-width-col" }, r("div", { class: "subsection" }, r("h3", null, "Email message"), r("div", { class: "input-container" }, r("label", { htmlFor: "title" }, "Email subject", r("span", { class: "label-icon" }, r("tooltip-component", null, r("info-icon", { slot: "tooltip-icon" }), r("span", { slot: "tooltip-content" }, "Enter the subject for your event confirmation.")))), r("input-component", { name: "confirmation-email-title", maxLength: 60, defaultValue: this.confirmationEmail.booking_confirmed.title ?? `Booking confirmed ${e ? `with ${e}` : ""}` })), r("div", { class: "input-container" }, r("label", { htmlFor: "title" }, "Email body"), r("textarea", { id: "description", part: "nrt__textarea", name: "confirmation-email-body", value: this.confirmationEmail.booking_confirmed.body ?? "Default body", maxlength: "500", rows: 2, onInput: (n) => this.handleEmailBodyChange(n) })))))) : r("div", { class: "nylas-confirmation-email__summary", part: "nce__summary" }, r("p", null, r("span", { class: "summary-icon" }, r("person-clipboard-icon", null)), "All host & guests"), r("p", null, r("span", { class: "summary-icon" }, r("clock-icon", null)), "Immediately on booking"))));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return $(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"]
    };
  }
};
eo([
  M({
    name: "nylas-confirmation-email",
    eventToProps: {
      valueChanged: async (e, t) => {
        const { valueChanged: n } = e.detail;
        n && n(e);
      }
    },
    fireRegisterEvent: !0
  }),
  Mt("design:type", Function),
  Mt("design:paramtypes", []),
  Mt("design:returntype", void 0)
], Zn.prototype, "render", null);
Zn.style = Qi;
const to = ':host{display:block;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif;width:inherit}.nylas-connected-calendars{width:inherit;display:flex;flex-direction:column;margin:1rem;border-radius:var(--nylas-border-radius-2x);border:1px solid var(--nylas-base-200)}.nylas-connected-calendars .header{padding:1rem}.nylas-connected-calendars .header h3{margin:0;font-size:16px;font-weight:600;line-height:20px;color:var(--nylas-base-900);text-align:left}.nylas-connected-calendars .header p{margin:0.25rem 0 0 0;font-size:0.875rem;font-weight:400;line-height:20px;color:var(--nylas-base-600);text-align:left;display:flex;align-items:center;gap:4px}.nylas-connected-calendars .content .participant-container{padding-top:12px;border-top:1px solid var(--nylas-base-200)}.nylas-connected-calendars .content .participant-container .participant-title{display:flex;justify-content:space-between;align-items:center;padding:4px 16px 16px}.nylas-connected-calendars .content .participant-container .participant-title p{margin:0}.nylas-connected-calendars .content .participant-container .participant-title .participant-toggle{display:flex;gap:24px;align-items:center}.nylas-connected-calendars .content .participant-container .participant-title .participant-toggle .chevron{display:flex;align-self:center;cursor:pointer}.nylas-connected-calendars .content .participant-container .participant-title .participant-toggle .chevron:hover,.nylas-connected-calendars .content .participant-container .participant-title .participant-toggle .chevron:active{color:var(--nylas-primary)}.nylas-connected-calendars .content .participant-container .participant-title .participant-toggle .chevron.open{transform:rotate(90deg)}.nylas-connected-calendars .content .participant-container .participant-title .participant-toggle .chevron.closed{transform:rotate(270deg)}.nylas-connected-calendars .content .participant-container .participant-title .participant-toggle .chevron.disabled{cursor:not-allowed;color:var(--nylas-base-300)}.nylas-connected-calendars .content .participant-container .participant-title .participant-toggle .chevron.disabled:hover{color:var(--nylas-base-300)}nylas-calendar-picker::part(ncp){margin:0;border:none;border-top:1px solid var(--nylas-base-200);border-top-right-radius:0;border-top-left-radius:0}', no = to;
var ao = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, Pt = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const Un = class {
  constructor(e) {
    x(this, e), this.valueChanged = L(this, "valueChanged", 7), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals), this.name = "connected-calendars", this.participants = void 0, this.calendars = void 0, this.participantOptions = void 0, this.selectedCalendars = this.setParticipants(this.participants), this.participantCalendars = {}, this.participantDefaultSelectedCalendars = {};
  }
  elementNameChangedHandler(e) {
    d("nylas-connected-calendars", "elementNameChangedHandler", e), this.host.setAttribute("name", e);
  }
  calendarsChangedHandler(e) {
    d("nylas-connected-calendars", "calendarsChangedHandler", e), this.participantCalendars = this.getParticipantCalendarOptions(this.participants, this.participantOptions);
  }
  participantsChangedHandler(e) {
    d("nylas-connected-calendars", "participantsChangedHandler", e), this.selectedCalendars = this.setParticipants(e), this.participantCalendars = this.getParticipantCalendarOptions(e, this.participantOptions);
  }
  participantOptionsChangedHandler(e) {
    d("nylas-calendar-picker", "participantOptionsChangedHandler", e), this.participantCalendars = this.getParticipantCalendarOptions(this.participants, e);
  }
  getParticipantCalendarOptions(e, t) {
    var o;
    const n = this.participants.find((i) => i.is_organizer), a = {};
    return t && e.filter((s) => t.some((l) => l.email === s.email)).forEach((s) => {
      var f, p, m;
      const l = t.find((h) => h.email === s.email);
      if (!l)
        return;
      this.participantDefaultSelectedCalendars[s.email] = ((f = s.availability) == null ? void 0 : f.calendar_ids) || [];
      const c = l.calendars ?? [];
      (m = (p = s.availability) == null ? void 0 : p.calendar_ids) == null || m.forEach((h) => {
        !c.some((v) => v.id === h) && h !== "primary" && c.push({ id: h, name: h });
      }), a[s.email] = c;
    }), n && (a[n.email] = this.calendars ?? [{ id: "primary", name: n.email }], this.participantDefaultSelectedCalendars[n.email] = ((o = n.availability) == null ? void 0 : o.calendar_ids) || []), a;
  }
  getUniqueCalendars(e) {
    return e.filter((t, n, a) => a.findIndex((o) => o.id === t.id) === n);
  }
  connectedCallback() {
    d("nylas-connected-calendars", "connectedCallback");
  }
  disconnectedCallback() {
    d("nylas-connected-calendars", "disconnectedCallback");
  }
  componentWillLoad() {
    d("nylas-connected-calendars", "componentWillLoad");
  }
  componentDidLoad() {
    d("nylas-connected-calendars", "componentDidLoad");
  }
  handleValueChanged(e) {
    d("[nylas-editor-tabs]", "handleValueChanged", e);
    const { name: t, value: n } = e.detail;
    if (!t.startsWith("participant-"))
      return;
    if (this.connectedCalendarsFormRef.checkValidity())
      this.internals.setValidity({});
    else {
      this.internals.setValidity({ customError: !0 }, "Please select at least one calendar for each participant.");
      return;
    }
    const a = t.split("participant-")[1];
    if (!this.selectedCalendars[a])
      return;
    this.selectedCalendars[a].calendars = n, this.selectedCalendars = { ...this.selectedCalendars };
    const o = {};
    this.participants.forEach((i) => {
      o[i.email] = this.selectedCalendars[i.email].calendars;
    }), this.internals.setFormValue(JSON.stringify(o), this.name), this.valueChanged.emit({ value: JSON.stringify(o), name: this.name });
  }
  setParticipants(e) {
    const t = {};
    return e.forEach((n) => {
      const a = !!n.is_organizer;
      t[n.email] = {
        isOpen: a,
        name: n.name || n.email,
        availability: n.availability
      };
    }), t;
  }
  render() {
    return r(H, { key: "030d545fbb0c15f618f3881697828de814c82f1d" }, r("div", { key: "ddb4080a13e6be83ba61ef464743ce7be566f6f8", class: "nylas-connected-calendars", part: "npca" }, r("div", { key: "a41f65a371e0f8e07f17605b96784d26c5d956a5", class: "header", part: "npca__header" }, r("h3", { key: "84efcaca6c59d41e93693eb207c9255ce016d264" }, "Connected Calendars"), r("p", { key: "efab18e1f8cb89d5cf7ef5d28e91392895e8a085" }, "Select the calendars to use for checking your availability.", r("tooltip-component", { key: "ab719574171d554d71105fe2de9bb299208e7a25" }, r("info-icon", { key: "df312e01bacb7ed9e65394af22b02fcb23e3e368", slot: "tooltip-icon" }), r("span", { key: "6bae0c1039be8e527fea071a3799155a2a8ce7ea", slot: "tooltip-content" }, "Check availability across one or multiple calendars. If multiple calendars are selected, you must be available across all of them to be considered available. The default is your primary calendar if none are selected.")))), r("div", { key: "69e39f96735726d45fd3c09be9a11a6626183141", class: "content", part: "npca__content" }, r("form", { key: "e268937ab913a4cd139d791a928f08fb63c3fb0f", ref: (e) => this.connectedCalendarsFormRef = e }, Object.keys(this.participantCalendars).map((e, t) => {
      const n = this.selectedCalendars[e], a = this.participantCalendars[e];
      if (!(!n || !n.name))
        return r("div", { class: "participant-container", part: "npca__participant-container", key: `participant-conatiner-${t}` }, r("div", { class: "participant-title", part: "npca__participant-title" }, r("p", null, "Set ", n.name, "'s connected calendars"), r("div", { class: "participant-toggle", part: "npca__participant-toggle--container" }, r("span", { class: `chevron ${n.isOpen ? "open" : "closed"}`, onClick: () => {
          this.selectedCalendars[e].isOpen = !n.isOpen, this.selectedCalendars = { ...this.selectedCalendars };
        } }, r("chevron-icon", { width: "24", height: "24" })))), n.isOpen && r("nylas-calendar-picker", { key: e, name: `participant-${e}`, calendars: a, defaultSelectedCalendars: this.participantDefaultSelectedCalendars[e] }));
    })))));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return $(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"],
      calendars: ["calendarsChangedHandler"],
      participants: ["participantsChangedHandler"],
      participantOptions: ["participantOptionsChangedHandler"]
    };
  }
};
ao([
  M({
    name: "nylas-connected-calendars",
    stateToProps: /* @__PURE__ */ new Map([
      ["schedulerConfig.additionalParticipants", "participantOptions"],
      ["schedulerConfig.calendars", "calendars"]
    ]),
    eventToProps: {},
    fireRegisterEvent: !0
  }),
  Pt("design:type", Function),
  Pt("design:paramtypes", []),
  Pt("design:returntype", void 0)
], Un.prototype, "render", null);
Un.style = no;
const io = ':host{display:block;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif;width:inherit}.nylas-customize-booking-settings{width:inherit;display:flex;flex-direction:column;margin:1rem;border-radius:var(--nylas-border-radius-2x);border:1px solid var(--nylas-base-200)}.nylas-customize-booking-settings .header{padding:1rem;border-bottom:1px solid var(--nylas-base-200)}.nylas-customize-booking-settings .header h3{margin:0;font-size:1rem;font-weight:600;line-height:20px;color:var(--nylas-base-900);text-align:left}.nylas-customize-booking-settings .header p{margin:0.25rem 0 0 0;font-size:0.875rem;font-weight:400;line-height:20px;color:var(--nylas-base-600);text-align:left}.nylas-customize-booking-settings .nylas-customize-booking-settings__settings{display:flex;flex-direction:column;gap:1.5rem;padding:1rem;margin:1rem 0}.nylas-customize-booking-settings .nylas-customize-booking-settings__settings .nylas-customize-booking-settings__settings-div{display:flex;align-items:center;gap:4px}.label{margin-left:32px;font-size:16px;font-weight:400;color:var(--nylas-base-800);line-height:24px}.label .label-contents{margin:0;display:inline-block}@media screen and (max-width: 768px){.label .label-contents{display:block}}.label tooltip-component{display:inline-block}@media screen and (max-width: 768px){tooltip-component#guests::part(tc__content){left:58px}}tooltip-component#reschedule::part(tc__content){left:58px}@media screen and (max-width: 768px){tooltip-component#reschedule::part(tc__content){left:58px}}tooltip-component#cancel::part(tc__content){left:-58px}@media screen and (max-width: 768px){tooltip-component#cancel::part(tc__content){left:58px}}', oo = io;
var ro = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, Nt = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const Vn = class {
  constructor(e) {
    var t, n, a, o, i, s;
    x(this, e), this.valueChanged = L(this, "valueChanged", 7), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals), this.selectedConfiguration = void 0, this.defaultHideAdditionalGuests = ((n = (t = this.selectedConfiguration) == null ? void 0 : t.scheduler) == null ? void 0 : n.hide_additional_guests) ?? !1, this.defaultHideCancellationOptions = ((o = (a = this.selectedConfiguration) == null ? void 0 : a.scheduler) == null ? void 0 : o.hide_cancellation_options) ?? !1, this.defaultHideReschedulingOptions = ((s = (i = this.selectedConfiguration) == null ? void 0 : i.scheduler) == null ? void 0 : s.hide_rescheduling_options) ?? !1, this.name = "customize-booking-settings", this.allowGuestsToInvite = this.defaultHideAdditionalGuests, this.hideCancellationOptions = this.defaultHideCancellationOptions, this.hideReschedulingOptions = this.defaultHideReschedulingOptions;
  }
  elementNameChangedHandler(e) {
    d("nylas-customize-booking-settings", "elementNameChangedHandler", e), this.host.setAttribute("name", e);
  }
  selectedConfigurationChangedHandler(e) {
    var t, n, a;
    d("nylas-customize-booking-settings", "selectedConfigurationChangedHandler", e), this.allowGuestsToInvite = !((t = e == null ? void 0 : e.scheduler) != null && t.hide_additional_guests), this.hideCancellationOptions = ((n = e == null ? void 0 : e.scheduler) == null ? void 0 : n.hide_cancellation_options) ?? !1, this.hideReschedulingOptions = ((a = e == null ? void 0 : e.scheduler) == null ? void 0 : a.hide_rescheduling_options) ?? !1;
  }
  connectedCallback() {
    d("nylas-customize-booking-settings", "connectedCallback");
  }
  disconnectedCallback() {
    d("nylas-customize-booking-settings", "disconnectedCallback");
  }
  componentWillLoad() {
    d("nylas-customize-booking-settings", "componentWillLoad"), this.host.setAttribute("name", this.name);
  }
  componentDidLoad() {
    d("nylas-customize-booking-settings", "componentDidLoad");
  }
  componentWillUpdate() {
    d("nylas-customize-booking-settings", "componentWillUpdate");
  }
  componentDidUpdate() {
    d("nylas-customize-booking-settings", "componentDidUpdate");
  }
  componentWillRender() {
    d("nylas-customize-booking-settings", "componentWillRender");
  }
  componentDidRender() {
    d("nylas-customize-booking-settings", "componentDidRender");
  }
  checkboxToggledHandler(e) {
    const { name: t, checked: n } = e.detail;
    switch (t) {
      case "hide_additional_guests":
        this.allowGuestsToInvite = n;
        break;
      case "hide_cancellation_options":
        this.hideCancellationOptions = n;
        break;
      case "hide_rescheduling_options":
        this.hideReschedulingOptions = n;
        break;
    }
    this.valueChanged.emit({
      value: JSON.stringify({
        additionalGuestsHidden: !this.allowGuestsToInvite,
        hideCancellationOptions: this.hideCancellationOptions,
        hideReschedulingOptions: this.hideReschedulingOptions
      }),
      name: this.name
    }), this.internals.setFormValue(JSON.stringify({
      additionalGuestsHidden: !this.allowGuestsToInvite,
      hideCancellationOptions: this.hideCancellationOptions,
      hideReschedulingOptions: this.hideReschedulingOptions
    }), this.name);
  }
  render() {
    return r(H, { key: "b86f8367da723a6bb404ccaee3bfdeb5b0a70d7e" }, r("div", { key: "460b0732f7a732e4299f170a078c880b53832ae0", class: "nylas-customize-booking-settings", part: "ncbs" }, r("div", { key: "67522557b35f996cd73017a83ee3b872bb71da4d", class: "header", part: "ncbs__header" }, r("h3", { key: "7e54bd0343592a2a7d47c280da88178f8e14a9be" }, "Additional settings"), r("p", { key: "9c542130cac7f74124f6cda97f9a404de855674e" }, "Booking settings for the event.")), r("div", { key: "13ed47dce41b865713928019b24d9c0a3ecf84d7", class: "nylas-customize-booking-settings__settings", part: "ncbs__settings" }, r("div", { key: "2977cac09c4bf0c26b53b3258fc17a2b9dcafd7b", class: "nylas-customize-booking-settings__settings-div", part: "ncbs__settings-div , ncbs__additional_guests" }, r("checkbox-component", { key: "91cbb7d5059bef9e2ca448fe86fd91bd58ba47f4", name: "hide_additional_guests", label: "Allow guests to invite additional guests.", checked: this.allowGuestsToInvite }, r("span", { key: "bf2f13b04417c31afe6eb2d89e459be0002ddd36", slot: "label", class: "label" }, r("p", { key: "5dc7820f9779ea4a16b29c6a6a8c294f59e04473", class: "label-contents" }, "Allow guests to invite additional guests to the booking."), r("tooltip-component", { key: "b5bbb6bd723f5464c0d8db069c072521ae182972", id: "guests" }, r("info-icon", { key: "ec2c7e2b4fe456ec53dc381d5a4900db1b64c47d", slot: "tooltip-icon" }), r("span", { key: "43f9d2feac4e91f9378fa44a9d816993c0ba69c8", slot: "tooltip-content" }, "Allow guests to invite additional guests to the event. If enabled, the guest will be able to add additional guests' email addresses."))))), r("div", { key: "8ab4fd673289c8bb84ad9047d614da83c5a77d3e", class: "nylas-customize-booking-settings__settings-div", part: "ncbs__settings-div , ncbs__rescheduling_options" }, r("checkbox-component", { key: "36e39fed89119d320b5b480aadfaf19bbf0f5fb5", name: "hide_rescheduling_options", label: "Hide 'Reschedule' option on booking page and emails.", checked: this.hideReschedulingOptions }, r("span", { key: "688e8f1422d446a9a01e05da946595537e394602", slot: "label", class: "label" }, r("p", { key: "500df676d0aab2e6af7774b3c442105bb0baf3b6", class: "label-contents" }, "Hide the ", r("strong", { key: "383e2b3b6546d114968ddd4dedce2d2a2eb694a1" }, "Reschedule"), " button on the Scheduling Page and in the email notifications."), r("tooltip-component", { key: "c9d41d14a36bcdb88eb0c2454f13cea22e8e9f84", id: "reschedule" }, r("info-icon", { key: "064e0e8abca84d1af897c2d0ac163a882de1366b", slot: "tooltip-icon" }), r("span", { key: "d13e1b449f396d7e26c79b0595f3de48ea5efac0", slot: "tooltip-content" }, "If enabled, the guest will not be able to reschedule the booking."))))), r("div", { key: "1ac9618b10e0f213ca9fbdafd460c3a8aaa58078", class: "nylas-customize-booking-settings__settings-div", part: "ncbs__settings-div , ncbs__cancellation_options" }, r("checkbox-component", { key: "52c6989299ebefcb1a10adbd3b493db3008469aa", name: "hide_cancellation_options", label: "Hide 'Cancel' option on booking page and emails.", checked: this.hideCancellationOptions }, r("span", { key: "1d3b3351f98d1dfbc5ea08b82e537cbac19db263", slot: "label", class: "label" }, r("p", { key: "c6bd5032ddc0953e52ae5af93eb95cd5f2618879", class: "label-contents" }, "Hide the ", r("strong", { key: "78808c4b7421513f3dd17518229151d37bc1a97f" }, "Cancel"), " button on the Scheduling Page and in the email notifications."), r("tooltip-component", { key: "7cc734130df33c2a840a71d70533cfbdf043902a", id: "cancel" }, r("info-icon", { key: "160a8bf8ed89df4190385d0a482266cc08abd20d", slot: "tooltip-icon" }), r("span", { key: "82e0e814be08483e4d346848dae8f4f0c3e9c3b5", slot: "tooltip-content" }, "If enabled, the guest will not be able to cancel the booking."))))))));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return $(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"],
      selectedConfiguration: ["selectedConfigurationChangedHandler"]
    };
  }
};
ro([
  M({
    name: "nylas-customize-booking-settings",
    stateToProps: /* @__PURE__ */ new Map([["schedulerConfig.selectedConfiguration", "selectedConfiguration"]]),
    fireRegisterEvent: !0
  }),
  Nt("design:type", Function),
  Nt("design:paramtypes", []),
  Nt("design:returntype", void 0)
], Vn.prototype, "render", null);
Vn.style = oo;
const so = ':host{--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif}.nylas-event-description{display:flex;flex-direction:column;gap:4px}.nylas-event-description label{display:flex;align-items:center;color:var(--nylas-base-800);font-size:16px;font-style:normal;font-weight:400;line-height:150%;}.nylas-event-description label span.label-icon{margin-left:4px}.nylas-event-description label span.label-icon tooltip-component{display:flex}.nylas-event-description textarea{padding:12px 16px;border-width:1;resize:vertical;border-radius:8px;font-family:var(--nylas-font-family);font-size:16px;line-height:24px;border:1px solid var(--nylas-base-200)}.nylas-event-description textarea::-webkit-resizer{display:none}', lo = so;
var co = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, Lt = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const qn = class {
  constructor(e) {
    var t, n;
    x(this, e), this.valueChanged = L(this, "valueChanged", 7), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals), this.selectedConfiguration = void 0, this.eventDescription = void 0, this.name = "description", this.description = this.eventDescription || ((n = (t = this.selectedConfiguration) == null ? void 0 : t.event_booking) == null ? void 0 : n.description) || "";
  }
  elementNameChangedHandler(e) {
    d("nylas-event-description", "elementNameChangedHandler", e), this.host.setAttribute("name", e);
  }
  selectedConfigurationChangedHandler(e, t) {
    var n, a;
    d("nylas-custom-booking-flow", "selectedConfigurationChangedHandler", e, t), (n = e == null ? void 0 : e.event_booking) != null && n.description && (this.description = (a = e == null ? void 0 : e.event_booking) == null ? void 0 : a.description);
  }
  connectedCallback() {
    d("nylas-event-description", "connectedCallback");
  }
  componentWillLoad() {
    d("nylas-event-description", "componentWillLoad"), this.host.setAttribute("name", this.name);
  }
  componentDidLoad() {
    d("nylas-event-description", "componentDidLoad");
  }
  disconnectedCallback() {
    d("nylas-event-description", "disconnectedCallback");
  }
  handleChange(e) {
    const t = qe(e.target.value);
    this.description = t, this.internals.setFormValue(t, "description"), this.valueChanged.emit({ value: t, name: this.name });
  }
  render() {
    return r(H, { key: "ac483c56982373fb625c6d1af54eed749ce820e2" }, r("div", { key: "3924853ea2c94d72bf2a04a319bee5fc61eb7642", class: "nylas-event-description", part: "nedesc" }, r("label", { key: "e8f9990a4f0766de9691080ef02b823c4cd6beb4", htmlFor: "description" }, "Event description", r("span", { key: "dc7fa731cc60ed6e59032cdb35d0b410de300750", class: "label-icon" }, r("tooltip-component", { key: "1c0b1a5a547227bf7d4f499cc7c319349ec26e2d" }, r("info-icon", { key: "e74034f5a5d8ab86c0d497b15c9cb8016d22f38e", slot: "tooltip-icon" }), r("span", { key: "c5efa1fc3adc9290e39d40f1f7998e0c6bdd3bf4", slot: "tooltip-content" }, "Provide any additional details for your event.")))), r("textarea", { key: "45d8cc241ab90a24ec437499234b02cc401fa720", id: "description", part: "nedesc__textarea", name: "description", value: this.description, maxlength: "8192", onInput: (e) => this.handleChange(e) })));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return $(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"],
      selectedConfiguration: ["selectedConfigurationChangedHandler"]
    };
  }
};
co([
  M({
    name: "nylas-event-description",
    stateToProps: /* @__PURE__ */ new Map([["schedulerConfig.selectedConfiguration", "selectedConfiguration"]]),
    eventToProps: {},
    fireRegisterEvent: !0
  }),
  Lt("design:type", Function),
  Lt("design:paramtypes", []),
  Lt("design:returntype", void 0)
], qn.prototype, "render", null);
qn.style = lo;
const fo = ':host{display:block;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif}.nylas-event-duration{display:flex;flex-direction:column;gap:4px}.nylas-event-duration label{display:flex;align-items:center;color:var(--nylas-base-800);font-size:16px;font-style:normal;font-weight:400;line-height:150%;}.nylas-event-duration label span.required{color:var(--nylas-error, #cc4841)}.nylas-event-duration label span.label-icon{margin-left:4px}.nylas-event-duration label span.label-icon tooltip-component{display:flex}.nylas-event-duration__wrapper{display:flex;align-items:center;gap:0.5rem}.nylas-event-duration__wrapper input{padding:12px 16px;border-width:1;border-radius:8px;border:1px solid var(--nylas-base-200);font-family:var(--nylas-font-family);font-size:16px;line-height:24px;width:48px}.nylas-event-duration__wrapper input-dropdown::part(id_dropdown-input){border:1px solid var(--nylas-base-200);border-radius:var(--nylas-border-radius-2x);padding:14px 16px;width:50px}.nylas-event-duration__wrapper input-dropdown::part(id_dropdown-content){width:100%;min-width:unset;height:200px}.nylas-event-duration__wrapper select-dropdown{width:120px}@media screen and (max-width: 768px){.nylas-event-duration__wrapper select-dropdown{width:100%}}.nylas-event-duration__wrapper select-dropdown::part(sd_dropdown-button){border:1px solid var(--nylas-base-200)}', po = fo;
var mo = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, Ft = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const Gn = class {
  constructor(e) {
    x(this, e), this.valueChanged = L(this, "valueChanged", 7), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals), this.selectedConfiguration = void 0, this.name = "duration", this.eventDurationMinutes = void 0, this.duration = this.eventDurationMinutes ? this.eventDurationMinutes >= 60 ? this.eventDurationMinutes / 60 : this.eventDurationMinutes : 30, this.durationMinutes = this.eventDurationMinutes ?? 30, this.durationIncrement = this.eventDurationMinutes && this.eventDurationMinutes >= 60 ? 60 : 1, this.durationMinutesOptions = [
      { value: 15, label: "15" },
      { value: 30, label: "30" },
      { value: 45, label: "45" },
      { value: 60, label: "60" }
    ];
  }
  elementNameChangedHandler(e) {
    d("nylas-event-duration", "elementNameChangedHandler", e), this.host.setAttribute("name", e);
  }
  selectedConfigurationChangedHandler(e) {
    var n;
    const t = (n = e == null ? void 0 : e.availability) == null ? void 0 : n.duration_minutes;
    t && (this.duration = t >= 60 ? t / 60 : t, this.durationMinutes = t ?? 30, this.durationIncrement = t >= 60 ? 60 : 1);
  }
  durationMinutesChangedHandler(e, t) {
    d("nylas-event-duration", "durationMinutesChangedHandler", e), e !== t && this.valueChanged.emit({ value: e.toString(), name: this.name });
  }
  connectedCallback() {
    d("nylas-event-duration", "connectedCallback");
  }
  componentWillLoad() {
    d("nylas-event-duration", "componentWillLoad"), this.host.setAttribute("name", this.name), this.setDurationMintueOptions();
  }
  componentDidLoad() {
    d("nylas-event-duration", "componentDidLoad"), this.internals.setFormValue(this.durationMinutes.toString(), "duration");
  }
  disconnectedCallback() {
    d("nylas-event-duration", "disconnectedCallback");
  }
  setDurationMintueOptions() {
    return this.durationIncrement === 1 ? this.durationMinutesOptions = [
      { value: 15, label: "15" },
      { value: 30, label: "30" },
      { value: 45, label: "45" },
      { value: 60, label: "60" }
    ] : this.durationMinutesOptions = Array.from({ length: 23 }, (e, t) => ({ value: t + 1, label: (t + 1).toString() })), this.durationMinutesOptions;
  }
  handleChange(e) {
    this.duration = e.target.value, this.durationMinutes = this.duration * this.durationIncrement, this.internals.setFormValue(this.durationMinutes.toString(), this.name);
  }
  nylasFormDropdownChangedHandler(e) {
    d("nylas-calendar-picker", "nylasFormDropdownChangedHandler", e.detail);
    const { value: t } = e.detail;
    this.durationIncrement = parseInt(t), this.durationIncrement === 1 ? this.duration = 60 : this.duration = 1, this.setDurationMintueOptions(), this.durationMinutes = this.duration * this.durationIncrement, this.internals.setFormValue(this.durationMinutes.toString(), "duration");
  }
  inputOptionChangedHandler(e) {
    d("nylas-calendar-picker", "inputOptionChangedHandler", e.detail);
    const { value: t } = e.detail;
    this.duration = t, this.durationMinutes = this.duration * this.durationIncrement, this.internals.setFormValue(this.durationMinutes.toString(), this.name);
  }
  render() {
    const e = [
      { value: 1, label: "minute" },
      { value: 60, label: "hour" }
    ];
    return r(H, { key: "c8ab90c7a45ce6a5379552af0a9059b9d829e82c" }, r("div", { key: "d957e610bd31a55430235b0ca903905c8bf3706b", class: "nylas-event-duration", part: "ned" }, r("label", { key: "39324d77ad9da4bc0c1f36d15c28384f423c1976", htmlFor: "duration" }, "Event duration", r("span", { key: "8f222a8a5d03899ff06790133434028dd1a62cd4", class: "required" }, "*"), r("span", { key: "6b83c675faa33db229ded711eac8c1f565bc9a61", class: "label-icon" }, r("tooltip-component", { key: "01b7ba340e2883e5a22d4559f67feda4bc745109" }, r("info-icon", { key: "acbfa3dcbc994dec0e502ea9ded00612bf24b315", slot: "tooltip-icon" }), r("span", { key: "e691c2a8ce4953e448cb6850ab2648645ae688c0", slot: "tooltip-content" }, "Set the duration of your event.")))), r("div", { key: "294766a022ba73042705050bc2fbc294cd1433b4", class: "nylas-event-duration__wrapper" }, r("input-dropdown", { key: "9a61a9527ae4c9991dc1f1596fbed85a5dd57966", name: "event-duration", options: this.durationMinutesOptions, inputValue: this.duration.toString(), exportparts: "id_dropdown: ned__input_dropdown, id_dropdown-input: ned__input_dropdown-input, id_dropdown-content: ned__input_dropdown-content", defaultInputOption: this.durationMinutesOptions.find((t) => t.value == this.duration) ?? e[0] }), r("select-dropdown", { key: "edcda0700a80961b9a8b9f325288d70a1aa4e6f0", name: "event-duration", options: e, pluralizedLabel: this.duration > 1 ? "s" : "", exportparts: "sd_dropdown: ned__dropdown, sd_dropdown-button: ned__dropdown-button, sd_dropdown-content: ned__dropdown-content", defaultSelectedOption: e.find((t) => t.value == this.durationIncrement) ?? e[0], withSearch: !1 }))));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return $(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"],
      selectedConfiguration: ["selectedConfigurationChangedHandler"],
      durationMinutes: ["durationMinutesChangedHandler"]
    };
  }
};
mo([
  M({
    name: "nylas-event-duration",
    stateToProps: /* @__PURE__ */ new Map([["schedulerConfig.selectedConfiguration", "selectedConfiguration"]]),
    eventToProps: {},
    fireRegisterEvent: !0
  }),
  Ft("design:type", Function),
  Ft("design:paramtypes", []),
  Ft("design:returntype", void 0)
], Gn.prototype, "render", null);
Gn.style = po;
const uo = ':host{display:block;margin:1rem;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif}.nylas-event-info__title{color:var(--nylas-base-900);font-size:16px;font-style:normal;font-weight:600;line-height:20px;margin:0;text-align:left}.nylas-event-info__subtitle{color:var(--nylas-base-600);font-size:14px;font-style:normal;font-weight:400;line-height:20px;margin:0.25rem 0px 0px;text-align:left}.nylas-event-info__content{padding:1rem;display:flex;flex-direction:column;gap:1rem}.nylas-event-info__block{display:flex;justify-content:space-between;gap:0.5rem}', ho = uo;
var yo = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, Rt = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const Yn = class {
  constructor(e) {
    x(this, e), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals);
  }
  connectedCallback() {
    d("nylas-event-info", "connectedCallback");
  }
  componentWillLoad() {
    d("nylas-event-info", "componentWillLoad");
  }
  componentDidLoad() {
    d("nylas-event-info", "componentDidLoad"), xn(["inputs"], this.el);
  }
  disconnectedCallback() {
    d("nylas-event-info", "disconnectedCallback");
  }
  render() {
    return r(H, { key: "372985af2cad0d48f0b6426efdf57dc426e635ce" }, r("nylas-form-card", { key: "03101178a10d153a877e31034552fd29b2c78897", exportparts: "nfc__header: nei__header" }, r("h1", { key: "3ebf8b9831ed7a6ca28fcce719d0673e3ed2f6d7", slot: "header-title", class: "nylas-event-info__title", part: "nei__title" }, "Event information"), r("h3", { key: "1dc5761e9998d5685b5beb0765d777ac25cbf8ed", slot: "header-subtitle", class: "nylas-event-info__subtitle", part: "nei__subtitle" }, "Enter all event information."), r("div", { key: "d03c233d645368adda34afeab1aebafabd2adb9d", slot: "content", class: "nylas-event-info__content" }, r("slot", { key: "715992e0621e0656135705e4abc3cc75219eb4c9", name: "inputs" }))));
  }
  static get formAssociated() {
    return !0;
  }
  get el() {
    return $(this);
  }
};
yo([
  M({
    name: "nylas-event-info",
    eventToProps: {},
    fireRegisterEvent: !0
  }),
  Rt("design:type", Function),
  Rt("design:paramtypes", []),
  Rt("design:returntype", void 0)
], Yn.prototype, "render", null);
Yn.style = ho;
const bo = ':host{display:block;margin:1rem;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif}.nylas-event-limits__title{color:var(--nylas-base-900);font-size:16px;font-style:normal;font-weight:600;line-height:20px;margin:0;text-align:left}.nylas-event-limits__subtitle{color:var(--nylas-base-600);font-size:14px;font-style:normal;font-weight:400;line-height:20px;margin:0.25rem 0px 0px;text-align:left}.nylas-event-limits__content{padding:1rem;display:flex;flex-direction:column;gap:1rem}.nylas-event-limits__block{display:flex;justify-content:space-between;gap:0.5rem}', go = bo;
var vo = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, At = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const Jn = class {
  constructor(e) {
    x(this, e), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals);
  }
  connectedCallback() {
    d("nylas-event-limits", "connectedCallback");
  }
  componentWillLoad() {
    d("nylas-event-limits", "componentWillLoad");
  }
  componentDidLoad() {
    d("nylas-event-limits", "componentDidLoad"), xn(["inputs"], this.el);
  }
  disconnectedCallback() {
    d("nylas-event-limits", "disconnectedCallback");
  }
  render() {
    return r(H, { key: "8a06058ea2224b629bc103d0c649f9d092b4ecb1" }, r("nylas-form-card", { key: "4055001375b7d0356f1025dbc19f6d50bc7d5034", exportparts: "nfc__header: nel__header" }, r("h1", { key: "13e674b2bf62d1e2daec83b8cbe128e3ee8971ce", slot: "header-title", class: "nylas-event-limits__title" }, "Event limits"), r("h3", { key: "c26824ac9ff4f41e25f305105ff76424be851f44", slot: "header-subtitle", class: "nylas-event-limits__subtitle" }, "Manage event limits."), r("div", { key: "80aadbc633d0b6f49f768b4cede35c9f295b62f5", slot: "content", class: "nylas-event-limits__content" }, r("slot", { key: "0bc8720c54a4235f9108d7c78164671e3db64d1a", name: "inputs" }))));
  }
  static get formAssociated() {
    return !0;
  }
  get el() {
    return $(this);
  }
};
vo([
  M({
    name: "nylas-event-limits",
    eventToProps: {},
    fireRegisterEvent: !0
  }),
  At("design:type", Function),
  At("design:paramtypes", []),
  At("design:returntype", void 0)
], Jn.prototype, "render", null);
Jn.style = go;
const _o = ':host{--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif}.nylas-event-location{display:flex;flex-direction:column;gap:4px;font-family:var(--nylas-font-family)}.nylas-event-location label{display:flex;align-items:center;color:var(--nylas-base-800);font-size:16px;font-style:normal;font-weight:400;line-height:150%;}.nylas-event-location label span.label-icon{margin-left:4px}.nylas-event-location label span.label-icon tooltip-component{display:flex}.nylas-event-location span[slot=select-icon]{border-right:1px solid var(--nylas-base-200);padding:16px 0.75rem 16px 0.5rem;border-radius:var(--nylas-border-radius-2x);border-bottom-right-radius:0;border-top-right-radius:0;height:20px}.nylas-event-location div.location-input{display:grid;grid-template-columns:auto 1fr;width:100%;gap:0.5rem}@media screen and (max-width: 768px){.nylas-event-location div.location-input{grid-template-columns:1fr}}.nylas-event-location div.location-input input{border:1px solid var(--nylas-base-200);border-radius:var(--nylas-border-radius-2x);padding:12px 16px;font-family:var(--nylas-font-family);font-size:16px;line-height:24px}.nylas-event-location select-dropdown{width:208px}@media screen and (max-width: 768px){.nylas-event-location select-dropdown{width:100%}}.nylas-event-location select-dropdown::part(sd_dropdown){width:100%}.nylas-event-location select-dropdown::part(sd_dropdown-content){left:calc(35px + 0.5rem)}.nylas-event-location select-dropdown::part(sd_dropdown-button){display:flex;justify-content:space-between;width:100%;border:1px solid var(--nylas-base-200);padding:0 0.5rem}.nylas-event-location select-dropdown::part(sd_dropdown-button-selected-label){display:inline-flex;align-self:center;padding:14px 0;font-family:var(--nylas-font-family);font-size:16px;line-height:24px}', Co = _o;
var wo = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, zt = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const Xn = class {
  constructor(e) {
    x(this, e), this.valueChanged = L(this, "valueChanged", 7), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals), this.name = "location", this.userProvider = void 0, this.eventConferencing = void 0, this.conferenceProviders = void 0, this.selectedConfiguration = void 0, this.eventLocation = void 0, this.location = this.eventLocation ?? "", this.grantId = this.setDefaultGrantID(), this.selectedLocationOption = this.setDefaultLocationOption();
  }
  elementNameChangedHandler(e) {
    d("nylas-event-location", "elementNameChangedHandler", e), this.host.setAttribute("name", e);
  }
  selectedConfigurationChangedHandler(e, t) {
    var o, i;
    d("nylas-custom-booking-flow", "selectedConfigurationChangedHandler", e, t);
    const n = (o = e == null ? void 0 : e.event_booking) == null ? void 0 : o.location;
    if ((i = e == null ? void 0 : e.event_booking) == null ? void 0 : i.conferencing) {
      this.selectedLocationOption = this.setDefaultLocationOption(), this.grantId = this.setDefaultGrantID(), this.location = n ?? "";
      return;
    }
    if (n) {
      this.selectedLocationOption = n ? "custom" : "none", this.location = n;
      return;
    }
  }
  eventLocationChangedHandler(e, t) {
    d("nylas-event-location", "eventLocationChangedHandler", e);
  }
  connectedCallback() {
    d("nylas-event-location", "connectedCallback");
  }
  componentWillLoad() {
    d("nylas-event-location", "componentWillLoad"), this.host.setAttribute("name", this.name);
  }
  componentDidLoad() {
    d("nylas-event-location", "componentDidLoad");
  }
  disconnectedCallback() {
    d("nylas-event-location", "disconnectedCallback");
  }
  nylasFormDropdownChangedHandler(e) {
    var n, a, o;
    this.selectedLocationOption = e.detail.value;
    let t;
    switch (this.selectedLocationOption) {
      case "none":
        this.location = "", this.setFormValue("", this.name), this.valueChanged.emit({ value: "", name: this.name }), this.valueChanged.emit({ value: JSON.stringify({}), name: "conference" });
        break;
      case "custom":
        this.valueChanged.emit({ value: JSON.stringify({}), name: "conference" });
        break;
      case "google":
        this.location = "", this.setFormValue("", this.name);
        const i = (n = this.conferenceProviders) == null ? void 0 : n.google;
        t = {
          provider: ht.google,
          autocreate: i ? {
            conf_grant_id: i
          } : {}
        }, this.valueChanged.emit({ value: JSON.stringify(t), name: "conference" }), this.valueChanged.emit({ value: "", name: this.name });
        break;
      case "microsoft":
        this.location = "", this.setFormValue("", this.name);
        const s = (a = this.conferenceProviders) == null ? void 0 : a.microsoft;
        t = {
          provider: ht.microsoft,
          autocreate: s ? {
            conf_grant_id: s
          } : {}
        }, this.valueChanged.emit({ value: JSON.stringify(t), name: "conference" }), this.valueChanged.emit({ value: "", name: this.name });
        break;
      case "zoom":
        this.location = "", this.setFormValue("", this.name);
        const l = (o = this.conferenceProviders) == null ? void 0 : o.zoom;
        t = {
          provider: ht.zoom,
          autocreate: l ? {
            conf_grant_id: l
          } : {}
        }, this.valueChanged.emit({ value: JSON.stringify(t), name: "conference" }), this.valueChanged.emit({ value: "", name: this.name });
        break;
    }
  }
  setDefaultLocationOption() {
    return this.eventConferencing != null && this.eventConferencing.provider != null && this.eventConferencing.autocreate != null ? pa[this.eventConferencing.provider] : this.eventLocation ? "custom" : "none";
  }
  setDefaultGrantID() {
    return this.eventConferencing != null && this.eventConferencing.autocreate != null ? this.eventConferencing.autocreate.conf_grant_id : "";
  }
  setFormValue(e, t) {
    typeof this.internals.setFormValue == "function" && this.internals.setFormValue(e, t);
  }
  handleChange(e) {
    const t = qe(e.target.value);
    this.location = t, this.setFormValue(t, this.name), this.valueChanged.emit({ value: t, name: this.name });
  }
  render() {
    const e = [
      { value: "none", label: "None" },
      { value: "custom", label: "Custom location" },
      { value: "zoom", label: "Zoom Meeting" }
    ];
    switch (this.userProvider) {
      case "google":
        e.push({ value: "google", label: "Google Meet" });
        break;
      case "microsoft":
        e.push({ value: "microsoft", label: "Microsoft Teams" });
        break;
    }
    const t = {
      none: r("location-off-icon", { key: "704e3432c3b98f3a2a8da51fb68dffcf90c3698d" }),
      custom: r("location-icon", { key: "ff185ff6c48fd9187900ed282c5e22621c6fe59a" }),
      google: r("google-meet-icon", { key: "248524df1929cafea72a90be4af826b750bfe163" }),
      microsoft: r("microsoft-teams-icon", { key: "29171eb5e309f4febafc3c756f8129626c4bea91" }),
      zoom: r("zoom-icon", { key: "3d7edb2034e1fa7eb5c331f4fb65ec48c0496bfb" })
    };
    return r(H, { key: "14187990ecb61f66f028cf8c505734bb1ac53918" }, r("div", { key: "bc0a77eba223fb0bd7a856b63699018087b369af", class: "nylas-event-location", part: "nel" }, r("label", { key: "4e4a1713cec90bc565cf9236e1c441382b3fa93f", htmlFor: "location" }, "Location type", r("span", { key: "ebd373624e792510b375f34a1de01abc1c9a264a", class: "label-icon" }, r("tooltip-component", { key: "117a041a1f1bc3e81f5073bbf51801d3ce83aa6a" }, r("info-icon", { key: "34e01edf44b933bb3c0499f435b749b4d1df0277", slot: "tooltip-icon" }), r("span", { key: "f945db849454c25e6ae73f99f7e3f15fc2637efb", slot: "tooltip-content" }, "Choose how you’ll meet with the participants at the scheduled time. Pick from available conferencing options or add a custom location.")))), r("div", { key: "00fe0bac3684e266a9f4269d2f7765c43e8a9752", class: "location-input" }, r("select-dropdown", { key: "a0a5200c2e9201f35ac099165cf628a4eadd17bd", withSearch: !1, name: "location", options: e.reverse(), defaultSelectedOption: e.find((n) => n.value == this.selectedLocationOption), exportparts: "sd_dropdown: nel__dropdown, sd_dropdown-button: nel__dropdown-button, sd_dropdown-content: nel__dropdown-content" }, r("span", { key: "4f5907df275a6e4e077167a90d11c5f97c840432", slot: "select-icon" }, t[this.selectedLocationOption])), this.selectedLocationOption === "custom" && r("input", { type: "text", part: "nel__location", id: "location", name: "location", maxlength: "1024", value: this.location, onInput: (n) => this.handleChange(n) }))));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return $(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"],
      selectedConfiguration: ["selectedConfigurationChangedHandler"],
      eventLocation: ["eventLocationChangedHandler"]
    };
  }
};
wo([
  M({
    name: "nylas-event-location",
    stateToProps: /* @__PURE__ */ new Map([
      ["schedulerConfig.selectedConfiguration", "selectedConfiguration"],
      ["schedulerConfig.conferenceProviders", "conferenceProviders"]
    ]),
    eventToProps: {},
    fireRegisterEvent: !0
  }),
  zt("design:type", Function),
  zt("design:paramtypes", []),
  zt("design:returntype", void 0)
], Xn.prototype, "render", null);
Xn.style = Co;
const xo = ':host{display:block;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif}.nylas-event-title{display:flex;flex-direction:column;gap:4px;position:relative;text-align:left}.nylas-event-title div.title{padding:12px 16px;border:1px solid var(--nylas-base-200);border-radius:var(--nylas-border-radius-2x);overflow:scroll;white-space:nowrap;scrollbar-width:thin}.nylas-event-title div.title::-webkit-scrollbar{width:6px;height:6px}.nylas-event-title div.title.error{border-color:var(--nylas-error);outline:none}.nylas-event-title input{padding:12px 16px;border-width:1;border-radius:8px;border:1px solid var(--nylas-base-200)}.nylas-event-title span.help-text{color:var(--nylas-base-800);font-size:14px;font-style:normal;font-weight:400;line-height:21px}.nylas-event-title span.error-message{color:var(--nylas-error)}.nylas-event-title label{display:flex;align-items:center;color:var(--nylas-base-800);font-size:16px;font-style:normal;font-weight:400;line-height:150%;}.nylas-event-title label span.required{color:var(--nylas-error, #cc4841)}.nylas-event-title label span.label-icon{margin-left:4px}.nylas-event-title label span.label-icon tooltip-component{display:flex}.highlighted-tag{background-color:var(--nylas-base-200);border-radius:var(--nylas-border-radius);padding:5px;margin-left:4px}.token-options{display:block;background-color:var(--nylas-base-0);width:100%;max-height:336px;overflow:auto;z-index:1;border-radius:4px;position:absolute;top:80px;box-shadow:0px 4px 6px -2px rgba(0, 0, 0, 0.0509803922);box-shadow:0px 10px 15px -3px rgba(0, 0, 0, 0.1019607843)}@media screen and (max-width: 768px){.token-options{right:0;width:325px;max-width:unset}}.token-options ul{padding:0;list-style-type:none;color:var(--nylas-base-900);max-height:336px;margin:0}.token-options ul li{padding:16px, 12px, 16px, 12px;color:black;padding:12px 16px;text-decoration:none;display:block;font-family:inherit;font-size:14px;font-weight:400;line-height:20px;letter-spacing:0px;text-align:left;cursor:pointer}.token-options ul li .token-label{display:flex;flex-direction:column;font-weight:400}.token-options ul li .token-label .token{color:var(--nylas-abse-900);font-size:16px;line-height:24px}.token-options ul li .token-label .description{color:var(--nylas-base-600);font-size:14px;line-height:21px}.token-options ul li:hover,.token-options ul li:focus,.token-options ul li:active,.token-options ul li.active{background-color:var(--nylas-base-100)}.token-options ul li:hover .token-label .token,.token-options ul li:focus .token-label .token,.token-options ul li:active .token-label .token,.token-options ul li.active .token-label .token{color:var(--nylas-primary)}.token-options .selected{background-color:var(--nylas-base-100)}', ko = xo;
var Eo = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, jt = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const Kn = class {
  constructor(e) {
    var t, n;
    x(this, e), this.valueChanged = L(this, "valueChanged", 7), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals), this.selectedConfiguration = void 0, this.eventTitle = (n = (t = this.selectedConfiguration) == null ? void 0 : t.event_booking) == null ? void 0 : n.title, this.name = "title", this.showTokens = !1, this.availableTokens = cn.map((a) => ({
      label: a.token,
      value: a.value,
      labelHTML: a
    })), this.filteredTokens = this.availableTokens, this.ariaActivedescendant = "", this.currentWord = { $value: "", fullText: "", index: -1, focusOffset: -1 }, this.validationError = "", this.configEventTitle = "";
  }
  elementNameChangedHandler(e) {
    d("nylas-event-title", "elementNameChangedHandler", e), this.host.setAttribute("name", e);
  }
  ariaActivedescendantChangedHandler(e) {
    var t, n;
    if (d("nylas-event-title", "ariaActivedescendantChangedHandler", e), e !== "") {
      const a = (t = this.host.shadowRoot) == null ? void 0 : t.getElementById(e);
      a == null || a.classList.add("active");
    } else {
      const a = (n = this.host.shadowRoot) == null ? void 0 : n.querySelectorAll(".token-options li.active");
      a == null || a.forEach((o) => o.classList.remove("active"));
    }
  }
  configChangedHandler(e) {
    var n;
    const t = (n = e == null ? void 0 : e.event_booking) == null ? void 0 : n.title;
    this.configEventTitle = t, t && this.updateEventTitleFromProp(t);
  }
  connectedCallback() {
    d("nylas-event-title", "connectedCallback");
  }
  componentWillLoad() {
    d("nylas-event-title", "componentWillLoad"), this.host.setAttribute("name", this.name);
  }
  componentDidLoad() {
    d("nylas-event-title", "componentDidLoad"), this.updateEventTitleFromProp(this.eventTitle || "");
  }
  disconnectedCallback() {
    d("nylas-event-title", "disconnectedCallback");
  }
  formSubmittedHandler(e) {
    var t, n;
    d("nylas-event-title", "formSubmittedHandler", e), (n = (t = this.internals) == null ? void 0 : t.validity) != null && n.valid ? this.validationError = "" : this.validationError = "Event title is required";
  }
  updateEventTitleFromProp(e) {
    var n, a;
    d("nylas-event-title", "eventTitleChangedHandler", e);
    const t = e || this.configEventTitle;
    this.titleRef && (this.titleRef.innerHTML = this.highlightTokens(t), this.titleRef.focus(), typeof this.internals.setValidity == "function" && (t === "" ? (n = this.internals) == null || n.setValidity({ customError: !0 }, "Event title is required", this.titleRef) : (a = this.internals) == null || a.setValidity({ customError: !1 })));
  }
  highlightTokens(e) {
    let t = e;
    return cn.forEach((n) => {
      const a = n.value, o = new RegExp(`(\\${a})(?!\\w)`, "g");
      t = t.replace(o, '<span class="highlighted-tag">$1</span>');
    }), t;
  }
  getCurrentSelectionForBrowser() {
    var a, o, i;
    const e = (s, l, c, f) => {
      const p = s.replace(/[\u200B-\u200D\uFEFF]/g, ""), m = p.lastIndexOf("$"), h = p.substring(m).split(" ")[0];
      return {
        focusOffset: l,
        dollarIndex: m,
        lastWord: h,
        currentText: p,
        node: c,
        allSelected: f
      };
    }, t = (s) => {
      var l, c;
      return s.anchorOffset === 0 && s.focusOffset === ((c = (l = s.focusNode) == null ? void 0 : l.nodeValue) == null ? void 0 : c.length);
    };
    switch (ca()) {
      case "Chrome":
        const s = (a = this.host.shadowRoot) == null ? void 0 : a.getSelection(), l = s == null ? void 0 : s.focusNode, c = (l == null ? void 0 : l.nodeValue) || "", f = s && t(s);
        return e(c, (s == null ? void 0 : s.focusOffset) || -1, l, f);
      case "Firefox":
        const p = document.getSelection(), m = ((o = p == null ? void 0 : p.anchorNode) == null ? void 0 : o.nodeValue) || "", h = p && t(p);
        return e(m, (p == null ? void 0 : p.focusOffset) || -1, p == null ? void 0 : p.anchorNode, h);
      case "Safari":
        const v = window.getSelection(), b = v == null ? void 0 : v.getComposedRanges(this.host.shadowRoot)[0], w = ((i = b == null ? void 0 : b.startContainer) == null ? void 0 : i.nodeValue) || "", S = v && t(v);
        return e(w, (b == null ? void 0 : b.endOffset) || -1, b == null ? void 0 : b.startContainer, S);
      default:
        return console.warn("Browser not supported"), null;
    }
  }
  handleChange(e) {
    let t = e.target.textContent || "";
    t = qe(t);
    const n = this.getCurrentSelectionForBrowser();
    if (!n) {
      this.updateEventTitle(t), this.resetDropdown();
      return;
    }
    const { focusOffset: a, dollarIndex: o, lastWord: i, currentText: s } = n;
    if (o === -1 || a < o) {
      this.updateEventTitle(t), this.resetDropdown();
      return;
    }
    i.startsWith("$") ? (this.showTokens = !0, this.currentWord = {
      $value: i,
      fullText: s,
      index: o,
      focusOffset: a
    }, this.populateSuggestionsDropdown(i)) : this.resetDropdown(), this.updateEventTitle(t);
  }
  handleInputKeyDown(e) {
    var n, a, o, i;
    const t = this.getCurrentSelectionForBrowser();
    if (t != null && t.allSelected && !da(e) && (this.titleRef.innerHTML = ""), e.key === "Enter") {
      e.preventDefault();
      const s = (n = this.host.shadowRoot) == null ? void 0 : n.getElementById(this.ariaActivedescendant);
      s && (s.click(), this.ariaActivedescendant = "");
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      const s = (a = this.host.shadowRoot) == null ? void 0 : a.getElementById(this.ariaActivedescendant);
      if (s) {
        const l = s.nextElementSibling;
        l ? this.ariaActivedescendant = l.id : this.ariaActivedescendant = this.filteredTokens[0].label;
      } else
        this.ariaActivedescendant = this.filteredTokens[0].label;
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      const s = (o = this.host.shadowRoot) == null ? void 0 : o.getElementById(this.ariaActivedescendant);
      if (s) {
        const l = s.previousElementSibling;
        l ? this.ariaActivedescendant = l.id : this.ariaActivedescendant = this.filteredTokens[this.filteredTokens.length - 1].label;
      } else
        this.ariaActivedescendant = this.filteredTokens[this.filteredTokens.length - 1].label;
    } else
      e.key === "Escape" ? (e.preventDefault(), this.resetDropdown()) : (e.key === "Backspace" || e.key === "Delete") && (t != null && t.currentText.startsWith("${") && (i = t == null ? void 0 : t.node) != null && i.parentNode && t.node.parentNode.removeChild(t.node), (this.titleRef.textContent === "" || (t == null ? void 0 : t.currentText) === "" || t != null && t.allSelected) && (this.titleRef.innerHTML = ""));
  }
  selectOption(e, t) {
    var w;
    e.preventDefault();
    const n = this.currentWord.fullText, a = this.currentWord.$value;
    let o = this.titleRef.firstChild, i = null;
    for (; o; ) {
      if (o.nodeType === 3) {
        const S = ((w = o.textContent) == null ? void 0 : w.replace(/[\u200B-\u200D\uFEFF]/g, "")) || "", U = n.replace(/[\u200B-\u200D\uFEFF]/g, "");
        if (S.includes(U)) {
          i = o;
          break;
        }
      }
      o = o.nextSibling;
    }
    if (!i)
      return;
    const s = i.textContent || "", l = s.indexOf(a), c = s.substring(0, l), f = s.substring(l + a.length), p = document.createTextNode(c), m = document.createRange(), h = document.createElement("span");
    h.classList.add("highlighted-tag"), h.textContent = `${t.value}`;
    const v = document.createTextNode(f);
    if (f !== "")
      i.replaceWith(p, h, v), m.setStart(v, 1);
    else {
      const S = document.createTextNode("​");
      i.replaceWith(p, h, S), m.setStart(S, 1);
    }
    this.resetDropdown(), this.titleRef.focus();
    const b = window.getSelection();
    m.collapse(!0), b == null || b.removeAllRanges(), b == null || b.addRange(m), this.updateEventTitle(this.titleRef.textContent || "");
  }
  populateSuggestionsDropdown(e = "") {
    this.filteredTokens = this.availableTokens.filter((t) => t.label.startsWith(e.toString()) || t.value.startsWith(e.toString())), this.filteredTokens.length > 0 && (this.ariaActivedescendant = this.filteredTokens[0].label);
  }
  updateEventTitle(e) {
    var n, a, o;
    const t = e.replace(/ +/g, " ");
    t === "" ? ((n = this.internals) == null || n.setValidity({ customError: !0 }, "Event title is required", this.titleRef), this.validationError = "Event title is required") : ((a = this.internals) == null || a.setValidity({ customError: !1 }), this.validationError = ""), (o = this.internals) == null || o.setFormValue(t, this.name), this.valueChanged.emit({ value: t, name: this.name });
  }
  resetDropdown() {
    this.showTokens = !1, this.ariaActivedescendant = "";
  }
  getLabelHTML(e) {
    return r("div", { class: "token-label" }, r("span", { class: "token" }, e.token), r("span", { class: "description" }, e.description));
  }
  render() {
    var e;
    return r(H, { key: "0d32eb86a4d773fd568b1948c12d0a2d33d3f0e7" }, r("div", { key: "bdd513cb14da7c59bd8be9f3f9a1f9b29f868024", class: "nylas-event-title", part: "net" }, r("label", { key: "f27076dfed25dd2cdc0b84b591a2920681a4730c", htmlFor: "title" }, "Event title", r("span", { key: "932ccbe6b9966725e9d5be799473f7bb74db8b4a", class: "required" }, "*"), r("span", { key: "8733b7c850db9dc5a59d8fb339f7e9c8b58ec60c", class: "label-icon" }, r("tooltip-component", { key: "6ff9f5349c2c9d6392a4948fb176f9117508ac30" }, r("info-icon", { key: "9d7938109fdb9699cf2d2b53957a5345626d98a3", slot: "tooltip-icon" }), r("span", { key: "a47b13a6f9a399a9bad53e6dc988606245769ac0", slot: "tooltip-content" }, "Enter a title for your event.")))), r("div", { key: "d7c94160c40be05054e1e802fdbd7ddb270101c3", class: {
      title: !0,
      error: this.validationError !== ""
    }, part: "net__title", ref: (t) => this.titleRef = t, contentEditable: "true", onInput: (t) => this.handleChange(t), onKeyDown: (t) => this.handleInputKeyDown(t) }), this.showTokens && ((e = this.filteredTokens) == null ? void 0 : e.length) > 0 && r("div", { class: "token-options", part: "net__dropdown-content" }, r("ul", { tabindex: "-1", role: "listbox", "aria-label": this.name, "aria-activedescendant": this.ariaActivedescendant }, this.filteredTokens.map((t) => r("li", { tabindex: "0", key: t.label, id: t.label, class: { active: this.ariaActivedescendant === t.label }, onClick: (n) => this.selectOption(n, t), role: "option" }, this.getLabelHTML(t.labelHTML))))), r("span", { key: "27d92e3439cdd74ea7175907c96ec413d7d67af6", class: "help-text" }, "Create a dynamic templated event title by typing $."), this.validationError != "" && r("span", { class: "error-message" }, this.validationError)));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return $(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"],
      ariaActivedescendant: ["ariaActivedescendantChangedHandler"],
      selectedConfiguration: ["configChangedHandler"]
    };
  }
};
Eo([
  M({
    name: "nylas-event-title",
    stateToProps: /* @__PURE__ */ new Map([["schedulerConfig.selectedConfiguration", "selectedConfiguration"]]),
    eventToProps: {},
    fireRegisterEvent: !0
  }),
  jt("design:type", Function),
  jt("design:paramtypes", []),
  jt("design:returntype", void 0)
], Kn.prototype, "render", null);
Kn.style = ko;
const Do = ':host{--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif}.nylas-limit-future-bookings{display:flex;justify-content:space-between;font-family:var(--nylas-font-family)}@media screen and (max-width: 768px){.nylas-limit-future-bookings{flex-direction:column;gap:0.5rem}}.nylas-limit-future-bookings label{display:flex;align-items:center;color:var(--nylas-base-800);font-size:16px;font-style:normal;font-weight:400;line-height:150%;}.nylas-limit-future-bookings label span.label-icon{margin-left:4px}.nylas-limit-future-bookings label span.label-icon tooltip-component{display:flex}select-dropdown::part(sd_dropdown-button){border:none}', So = Do;
var Oo = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, Bt = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const Qn = class {
  constructor(e) {
    x(this, e), this.valueChanged = L(this, "valueChanged", 7), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals), this.selectedConfiguration = void 0, this.availableDaysInFuture = void 0, this.name = "limit-future-bookings", this.selectedNumber = 1, this.selectedPeriod = "day";
  }
  elementNameChangedHandler(e) {
    d("nylas-limit-future-bookings", "elementNameChangedHandler", e), this.host.setAttribute("name", e);
  }
  selectedConfigurationChangedHandler(e) {
    var n;
    const t = (n = e == null ? void 0 : e.scheduler) == null ? void 0 : n.available_days_in_future;
    t && this.updateNumberAndPeriodFromDays(t);
  }
  availableDaysInFutureChanged(e) {
    this.updateNumberAndPeriodFromDays(e);
  }
  connectedCallback() {
    d("nylas-limit-future-bookings", "connectedCallback");
  }
  componentWillLoad() {
    d("nylas-limit-future-bookings", "componentWillLoad"), this.host.setAttribute("name", this.name);
  }
  componentDidLoad() {
    var e;
    d("nylas-limit-future-bookings", "componentDidLoad"), this.availableDaysInFutureChanged(this.availableDaysInFuture ?? 1), typeof this.internals.setFormValue == "function" && this.internals.setFormValue(((e = this.availableDaysInFuture) == null ? void 0 : e.toString()) ?? "1", this.name);
  }
  disconnectedCallback() {
    d("nylas-limit-future-bookings", "disconnectedCallback");
  }
  timePeriodChangedHandler(e) {
    const { number: t, period: n } = e.detail;
    let a;
    n === "day" ? a = t : n === "week" ? a = t * 7 : a = t * 30, this.valueChanged.emit({ value: a, name: "availableDaysInFuture" }), typeof this.internals.setFormValue == "function" && this.internals.setFormValue(a.toString(), this.name);
  }
  updateNumberAndPeriodFromDays(e) {
    let t, n;
    e >= 30 && e % 30 === 0 ? (t = e / 30, n = "month") : e >= 7 && e % 7 === 0 ? (t = e / 7, n = "week") : (t = e, n = "day"), this.selectedNumber = t, this.selectedPeriod = n;
  }
  render() {
    return r(H, { key: "5f9e1b76c6d9bef357d3e1a60616c9cf316f00c9" }, r("div", { key: "1dff7a12f7a972cff77b8feebcec2af8989ccc36", class: "nylas-limit-future-bookings", part: "nlfb" }, r("label", { key: "cb9d669c721974684d1840fa5c0f044525e53d0e" }, "Limit future bookings", r("span", { key: "ff0ed108352c5ef35645792160375b6e73586407", class: "label-icon" }, r("tooltip-component", { key: "d9e7fd840433856089b7c2c7881aa0152e5dc8d9" }, r("info-icon", { key: "fe67f1f6f44e958bab00e9266bebe92c6c43816c", slot: "tooltip-icon" }), r("span", { key: "25df0e3072ca37bc689f8d7a8916d866ee591494", slot: "tooltip-content" }, "The limit on how far in the future bookings can be made.")))), r("time-period-selector", { key: "b69d1984eb0ad209f2540b42cdd813749069e07b", id: "limit-future-bookings", timePeriods: ["day", "week", "month"], exportparts: "tps__number-dropdown: nlfb__number-dropdown, tps__number-dropdown-button: nlfb__number-dropdown-button, tps__number-dropdown-content: nlfb__number-dropdown-content, tps__period-dropdown: nlfb__period-dropdown, tps__period-dropdown-button: nlfb__period-dropdown-button, tps__period-dropdown-content: nlfb__period-dropdown-content", defaultSelectedNumber: this.selectedNumber, defaultSelectedPeriod: this.selectedPeriod })));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return $(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"],
      selectedConfiguration: ["selectedConfigurationChangedHandler"],
      availableDaysInFuture: ["availableDaysInFutureChanged"]
    };
  }
};
Oo([
  M({
    name: "nylas-limit-future-bookings",
    stateToProps: /* @__PURE__ */ new Map([["schedulerConfig.selectedConfiguration", "selectedConfiguration"]]),
    eventToProps: {},
    fireRegisterEvent: !0
  }),
  Bt("design:type", Function),
  Bt("design:paramtypes", []),
  Bt("design:returntype", void 0)
], Qn.prototype, "render", null);
Qn.style = So;
const To = ':host{--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif}.nylas-min-booking-notice{display:flex;justify-content:space-between;font-family:var(--nylas-font-family)}@media screen and (max-width: 768px){.nylas-min-booking-notice{flex-direction:column;gap:0.5rem}}.nylas-min-booking-notice label{display:flex;align-items:center;color:var(--nylas-base-800);font-size:16px;font-style:normal;font-weight:400;line-height:150%;}.nylas-min-booking-notice label span.label-icon{margin-left:4px}.nylas-min-booking-notice label span.label-icon tooltip-component{display:flex}select-dropdown::part(sd_dropdown-button){border:none}', Io = To;
var Ho = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, Wt = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const ea = class {
  constructor(e) {
    x(this, e), this.valueChanged = L(this, "valueChanged", 7), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals), this.selectedConfiguration = void 0, this.minBookingNotice = void 0, this.name = "min-booking-notice", this.selectedNumber = 1, this.selectedPeriod = "hour";
  }
  elementNameChangedHandler(e) {
    d("nylas-min-booking-notice", "elementNameChangedHandler", e), this.host.setAttribute("name", e);
  }
  selectedConfigurationChangedHandler(e) {
    var n;
    const t = (n = e == null ? void 0 : e.scheduler) == null ? void 0 : n.min_booking_notice;
    t && this.updateNumberAndPeriodFromMinutes(t);
  }
  availableDaysInFutureChanged(e) {
    this.updateNumberAndPeriodFromMinutes(e);
  }
  connectedCallback() {
    d("nylas-min-booking-notice", "connectedCallback");
  }
  componentWillLoad() {
    d("nylas-min-booking-notice", "componentWillLoad"), this.host.setAttribute("name", this.name);
  }
  componentDidLoad() {
    var e;
    d("nylas-min-booking-notice", "componentDidLoad"), this.availableDaysInFutureChanged(this.minBookingNotice ?? 1), typeof this.internals.setFormValue == "function" && this.internals.setFormValue(((e = this.minBookingNotice) == null ? void 0 : e.toString()) ?? "1", this.name);
  }
  disconnectedCallback() {
    d("nylas-min-booking-notice", "disconnectedCallback");
  }
  timePeriodChangedHandler(e) {
    const { number: t, period: n } = e.detail;
    let a;
    const o = 60, i = o * 24, s = i * 7, l = i * 30;
    n === "minute" ? a = t : n === "hour" ? a = t * o : n === "day" ? a = t * i : n === "week" ? a = t * s : n === "month" ? a = t * l : a = 0, this.valueChanged.emit({ value: a, name: "minBookingNotice" }), typeof this.internals.setFormValue == "function" && this.internals.setFormValue(a.toString(), this.name);
  }
  updateNumberAndPeriodFromMinutes(e) {
    let i, s;
    e >= 43200 ? (i = Math.floor(e / 43200), s = "month") : e >= 10080 ? (i = Math.floor(e / 10080), s = "week") : e >= 1440 ? (i = Math.floor(e / 1440), s = "day") : e >= 60 ? (i = Math.floor(e / 60), s = "hour") : (i = e, s = "minute"), this.selectedNumber = i, this.selectedPeriod = s;
  }
  render() {
    return r(H, { key: "47d97cf15413ac6d2a1983c31bf5285da9d22416" }, r("div", { key: "a2c14ed28cdf180a791f779c8df40b55ee72799c", class: "nylas-min-booking-notice", part: "nmbn" }, r("label", { key: "0e3e640e89b16308d94402a28c650533d157cc37" }, "Minimum booking notice", r("span", { key: "70a1590c751002c54e03ee524bd9e1ffce424897", class: "label-icon" }, r("tooltip-component", { key: "ebf5aa08d5750cb435d92712af6419f418289686" }, r("info-icon", { key: "96182bbb2aa2e4e75e85aef9032903fbdc7319ed", slot: "tooltip-icon" }), r("span", { key: "652f4ff744011f6974376c44c6a61f4e6488b2fd", slot: "tooltip-content" }, "The minimum amount of time in the future that a new booking can be made.")))), r("time-period-selector", { key: "28b99b166c06d72cb57a70fe11acb970d4f295ac", id: "min-booking-notice", exportparts: "tps__number-dropdown: nmbn__number-dropdown, tps__number-dropdown-button: nmbn__number-dropdown-button, tps__number-dropdown-content: nmbn__number-dropdown-content, tps__period-dropdown: nmbn__period-dropdown, tps__period-dropdown-button: nmbn__period-dropdown-button, tps__period-dropdown-content: nmbn__period-dropdown-content", timePeriods: ["minute", "hour", "day", "week"], defaultSelectedNumber: this.selectedNumber, defaultSelectedPeriod: this.selectedPeriod })));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return $(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"],
      selectedConfiguration: ["selectedConfigurationChangedHandler"],
      availableDaysInFuture: ["availableDaysInFutureChanged"]
    };
  }
};
Ho([
  M({
    name: "nylas-min-booking-notice",
    stateToProps: /* @__PURE__ */ new Map([["schedulerConfig.selectedConfiguration", "selectedConfiguration"]]),
    eventToProps: {},
    fireRegisterEvent: !0
  }),
  Wt("design:type", Function),
  Wt("design:paramtypes", []),
  Wt("design:returntype", void 0)
], ea.prototype, "render", null);
ea.style = Io;
const $o = ':host{--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif}.nylas-min-cancellation-notice{display:flex;justify-content:space-between;font-family:var(--nylas-font-family)}@media screen and (max-width: 768px){.nylas-min-cancellation-notice{flex-direction:column;gap:0.5rem}}.nylas-min-cancellation-notice label{display:flex;align-items:center;color:var(--nylas-base-800);font-size:16px;font-style:normal;font-weight:400;line-height:150%;}.nylas-min-cancellation-notice label span.label-icon{margin-left:4px}.nylas-min-cancellation-notice label span.label-icon tooltip-component{display:flex}select-dropdown::part(sd_dropdown-button){border:none}', Mo = $o;
var Po = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, Zt = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const ta = class {
  constructor(e) {
    x(this, e), this.valueChanged = L(this, "valueChanged", 7), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals), this.selectedConfiguration = void 0, this.minCancellationNotice = void 0, this.name = "min-cancellation-notice", this.selectedNumber = 1, this.selectedPeriod = "day";
  }
  elementNameChangedHandler(e) {
    d("nylas-min-cancellation-notice", "elementNameChangedHandler", e), this.host.setAttribute("name", e);
  }
  selectedConfigurationChangedHandler(e) {
    var n;
    const t = (n = e == null ? void 0 : e.scheduler) == null ? void 0 : n.min_cancellation_notice;
    t && this.updateNumberAndPeriodFromMinutes(t);
  }
  availableDaysInFutureChanged(e) {
    this.updateNumberAndPeriodFromMinutes(e);
  }
  connectedCallback() {
    d("nylas-min-cancellation-notice", "connectedCallback");
  }
  componentWillLoad() {
    d("nylas-min-cancellation-notice", "componentWillLoad"), this.host.setAttribute("name", this.name);
  }
  componentDidLoad() {
    var e;
    d("nylas-min-cancellation-notice", "componentDidLoad"), this.availableDaysInFutureChanged(this.minCancellationNotice ?? 1), typeof this.internals.setFormValue == "function" && this.internals.setFormValue(((e = this.minCancellationNotice) == null ? void 0 : e.toString()) ?? "1", this.name);
  }
  disconnectedCallback() {
    d("nylas-min-cancellation-notice", "disconnectedCallback");
  }
  timePeriodChangedHandler(e) {
    const { number: t, period: n } = e.detail;
    let a;
    const o = 60, i = o * 24, s = i * 7, l = i * 30;
    n === "minute" ? a = t : n === "hour" ? a = t * o : n === "day" ? a = t * i : n === "week" ? a = t * s : n === "month" ? a = t * l : a = 0, this.valueChanged.emit({ value: a, name: "minCancellationNotice" }), typeof this.internals.setFormValue == "function" && this.internals.setFormValue(a.toString(), this.name);
  }
  updateNumberAndPeriodFromMinutes(e) {
    let i, s;
    e >= 43200 ? (i = Math.floor(e / 43200), s = "month") : e >= 10080 ? (i = Math.floor(e / 10080), s = "week") : e >= 1440 ? (i = Math.floor(e / 1440), s = "day") : e >= 60 ? (i = Math.floor(e / 60), s = "hour") : (i = e, s = "minute"), this.selectedNumber = i, this.selectedPeriod = s;
  }
  render() {
    return r(H, { key: "1371e8247f4cfb764ba3d63982047c2964b9dca2" }, r("div", { key: "a7487dc7385a1d39e176f208fb23238579223af9", class: "nylas-min-cancellation-notice", part: "nmcn" }, r("label", { key: "3bcd720132d8cdfe80c94a64b901da3470ad57e9" }, "Minimum cancellation notice", r("span", { key: "8764ad54ab4ca8bd0b014d88e5fad58a75a6a1ad", class: "label-icon" }, r("tooltip-component", { key: "34e80e1f906b16c4239bc21ea8e975f8b71c9e6a" }, r("info-icon", { key: "2beaf33348a329d461c32de462319d7be2c87381", slot: "tooltip-icon" }), r("span", { key: "8ccef7385c54c61a062d59650665f11b7314270b", slot: "tooltip-content" }, "The minimum amount of time required to cancel a booking.")))), r("time-period-selector", { key: "be775a679e24b786a6c453db478b59cef0dd30f4", id: "min-cancellation-notice", exportparts: "tps__number-dropdown: nmcn__number-dropdown, tps__number-dropdown-button: nmcn__number-dropdown-button, tps__number-dropdown-content: nmcn__number-dropdown-content, tps__period-dropdown: nmcn__period-dropdown, tps__period-dropdown-button: nmcn__period-dropdown-button, tps__period-dropdown-content: nmcn__period-dropdown-content", timePeriods: ["minute", "hour", "day", "week"], defaultSelectedNumber: this.selectedNumber, defaultSelectedPeriod: this.selectedPeriod })));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return $(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"],
      selectedConfiguration: ["selectedConfigurationChangedHandler"],
      availableDaysInFuture: ["availableDaysInFutureChanged"]
    };
  }
};
Po([
  M({
    name: "nylas-min-cancellation-notice",
    stateToProps: /* @__PURE__ */ new Map([["schedulerConfig.selectedConfiguration", "selectedConfiguration"]]),
    eventToProps: {},
    fireRegisterEvent: !0
  }),
  Zt("design:type", Function),
  Zt("design:paramtypes", []),
  Zt("design:returntype", void 0)
], ta.prototype, "render", null);
ta.style = Mo;
const No = ':host{display:block;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif;width:inherit}.nylas-participant-booking-calendars{width:inherit;display:flex;flex-direction:column;margin:1rem;border-radius:var(--nylas-border-radius-2x);border:1px solid var(--nylas-base-200)}.nylas-participant-booking-calendars .header{padding:1rem}.nylas-participant-booking-calendars .header h3{margin:0;font-size:16px;font-weight:600;line-height:20px;color:var(--nylas-base-900);text-align:left}.nylas-participant-booking-calendars .header p{margin:0.25rem 0 0 0;font-size:0.875rem;font-weight:400;line-height:20px;color:var(--nylas-base-600);text-align:left;display:flex;align-items:center;gap:4px}.nylas-participant-booking-calendars .content .participant-container{padding-top:12px;border-top:1px solid var(--nylas-base-200)}.nylas-participant-booking-calendars .content .participant-container .participant-title{display:flex;justify-content:space-between;align-items:center;padding:4px 16px 16px}.nylas-participant-booking-calendars .content .participant-container .participant-title p{margin:0}.nylas-participant-booking-calendars .content .participant-container .participant-title .participant-toggle{display:flex;gap:24px;align-items:center}.nylas-participant-booking-calendars .content .participant-container .participant-title .participant-toggle .chevron{display:flex;align-self:center;cursor:pointer}.nylas-participant-booking-calendars .content .participant-container .participant-title .participant-toggle .chevron:hover,.nylas-participant-booking-calendars .content .participant-container .participant-title .participant-toggle .chevron:active{color:var(--nylas-primary)}.nylas-participant-booking-calendars .content .participant-container .participant-title .participant-toggle .chevron.open{transform:rotate(90deg)}.nylas-participant-booking-calendars .content .participant-container .participant-title .participant-toggle .chevron.closed{transform:rotate(270deg)}.nylas-participant-booking-calendars .content .participant-container .participant-title .participant-toggle .chevron.disabled{cursor:not-allowed;color:var(--nylas-base-300)}.nylas-participant-booking-calendars .content .participant-container .participant-title .participant-toggle .chevron.disabled:hover{color:var(--nylas-base-300)}nylas-booking-calendar-picker::part(nbcp){margin:0;border:none;border-top:1px solid var(--nylas-base-200);border-top-right-radius:0;border-top-left-radius:0}', Lo = No;
var Fo = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, Ut = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const na = class {
  constructor(e) {
    x(this, e), this.valueChanged = L(this, "valueChanged", 7), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals), this.selectedConfiguration = void 0, this.name = "participant-booking-calendars", this.participants = void 0, this.calendars = void 0, this.participantOptions = void 0, this.selectedCalendars = this.setParticipants(this.participants), this.participantCalendars = {}, this.participantDefaultSelectedCalendar = {};
  }
  elementNameChangedHandler(e) {
    d("nylas-participant-booking-calendars", "elementNameChangedHandler", e), this.host.setAttribute("name", e);
  }
  calendarsChangedHandler(e) {
    d("nylas-participant-booking-calendars", "calendarsChangedHandler", e), this.participantCalendars = this.getParticipantCalendarOptions(this.participants, this.participantOptions);
  }
  participantsChangedHandler(e) {
    d("nylas-participant-booking-calendars", "participantsChangedHandler", e), this.selectedCalendars = this.setParticipants(e), this.participantCalendars = this.getParticipantCalendarOptions(e, this.participantOptions);
  }
  participantOptionsChangedHandler(e) {
    d("nylas-calendar-picker", "participantOptionsChangedHandler", e), this.participantCalendars = this.getParticipantCalendarOptions(this.participants, e);
  }
  selectedConfigurationChangedHandler(e) {
    d("nylas-participant-booking-calendars", "selectedConfigurationChangedHandler", e), this.participantCalendars = this.getParticipantCalendarOptions(this.participants, this.participantOptions);
  }
  getParticipantCalendarOptions(e, t) {
    var i, s, l, c, f;
    const n = (i = this.participants) == null ? void 0 : i.find((p) => p.is_organizer), a = {}, o = ((c = (l = (s = this.selectedConfiguration) == null ? void 0 : s.availability) == null ? void 0 : l.availability_rules) == null ? void 0 : c.availability_method) !== "collective";
    if (t && o) {
      const p = e == null ? void 0 : e.filter((m) => t.some((h) => h.email === m.email));
      p == null || p.forEach((m) => {
        var b;
        const h = t == null ? void 0 : t.find((w) => w.email === m.email);
        if (!h)
          return;
        this.participantDefaultSelectedCalendar[m.email] = ((b = m.booking) == null ? void 0 : b.calendar_id) ?? "primary";
        const v = h.calendars ?? [];
        a[m.email] = v;
      });
    }
    return n && (a[n.email] = this.calendars ?? [{ id: "primary", name: n.email }], this.participantDefaultSelectedCalendar[n.email] = ((f = n == null ? void 0 : n.booking) == null ? void 0 : f.calendar_id) ?? "primary"), a;
  }
  getUniqueCalendars(e) {
    return e == null ? void 0 : e.filter((t, n, a) => a.findIndex((o) => o.id === t.id) === n);
  }
  connectedCallback() {
    d("nylas-participant-booking-calendars", "connectedCallback");
  }
  disconnectedCallback() {
    d("nylas-participant-booking-calendars", "disconnectedCallback");
  }
  componentWillLoad() {
    d("nylas-participant-booking-calendars", "componentWillLoad");
  }
  componentDidLoad() {
    d("nylas-participant-booking-calendars", "componentDidLoad");
  }
  handleValueChanged(e) {
    var i;
    d("[nylas-editor-tabs]", "handleValueChanged", e);
    const { name: t, value: n } = e.detail;
    if (!t.startsWith("participant-booking-"))
      return;
    if (this.bookingCalendarsFormRef.checkValidity())
      this.internals.setValidity({});
    else {
      this.internals.setValidity({ customError: !0 }, "Please select at least one calendar for each participant.");
      return;
    }
    const a = t.split("participant-booking-")[1];
    if (!this.selectedCalendars[a])
      return;
    this.selectedCalendars[a].calendar = n, this.selectedCalendars = { ...this.selectedCalendars };
    const o = {};
    (i = this.participants) == null || i.forEach((s) => {
      o[s.email] = this.selectedCalendars[s.email].calendar;
    }), this.internals.setFormValue(JSON.stringify(o), this.name), this.valueChanged.emit({ value: JSON.stringify(o), name: this.name });
  }
  setParticipants(e) {
    const t = {};
    return e == null || e.forEach((n) => {
      var o;
      const a = !!n.is_organizer;
      t[n.email] = {
        isOpen: a,
        calendar: ((o = n.booking) == null ? void 0 : o.calendar_id) || "primary",
        name: n.name || n.email
      };
    }), t;
  }
  render() {
    return r(H, { key: "4d4bd8b9463489ff3a66f17fe16b250f514c66ab" }, r("div", { key: "91516dc19d10a8932d0f759b3968dbbdf5bc1fa9", class: "nylas-participant-booking-calendars", part: "npbc" }, r("div", { key: "4a3000822113018fe3bc905fc7a34051b0c21f4c", class: "header", part: "npbc__header" }, r("h3", { key: "74d4741419d6352f8c8401e9b9dbea18765d6fc3" }, "Calendar booking"), r("p", { key: "9ed21750d16566885c1626db4f03098a5acc32f0" }, "Select the calendar where you want to add event bookings.", r("tooltip-component", { key: "161b9699355b456539ccaaa902bfdf77e7cd2380" }, r("info-icon", { key: "1429445a348fa2744f65617de14147707c3fc877", slot: "tooltip-icon" }), r("span", { key: "f080b36b751ac19b70703a27ecfbbb6c0635f2b2", slot: "tooltip-content" }, "The calendar will be used to create events.")))), r("div", { key: "032831a62f5066aef357bcd0d7315b67bb5488f2", class: "content", part: "npbc__content" }, r("form", { key: "1cd2a64097d143c76152ce80107ae7df40c458c7", ref: (e) => this.bookingCalendarsFormRef = e }, Object.keys(this.participantCalendars).map((e, t) => {
      const n = this.selectedCalendars[e], a = this.participantCalendars[e];
      if (!(!n || !n.name))
        return r("div", { class: "participant-container", part: "npbc__participant-container", key: `participant-conatiner-${t}` }, r("div", { class: "participant-title", part: "npbc__participant-title" }, r("p", null, "Set ", n.name, "'s booking calendar"), r("div", { class: "participant-toggle", part: "npbc__participant-toggle--container" }, r("span", { class: `chevron ${n.isOpen ? "open" : "closed"}`, onClick: () => {
          this.selectedCalendars[e].isOpen = !n.isOpen, this.selectedCalendars = { ...this.selectedCalendars };
        } }, r("chevron-icon", { width: "24", height: "24" })))), n.isOpen && r("nylas-booking-calendar-picker", { key: e, name: `participant-booking-${e}`, calendars: a, hideHeader: !0, defaultBookingCalendar: this.participantDefaultSelectedCalendar[e] }));
    })))));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return $(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"],
      calendars: ["calendarsChangedHandler"],
      participants: ["participantsChangedHandler"],
      participantOptions: ["participantOptionsChangedHandler"],
      selectedConfiguration: ["selectedConfigurationChangedHandler"]
    };
  }
};
Fo([
  M({
    name: "nylas-participant-booking-calendars",
    stateToProps: /* @__PURE__ */ new Map([
      ["schedulerConfig.additionalParticipants", "participantOptions"],
      ["schedulerConfig.calendars", "calendars"],
      ["schedulerConfig.selectedConfiguration", "selectedConfiguration"]
    ]),
    eventToProps: {},
    fireRegisterEvent: !0
  }),
  Ut("design:type", Function),
  Ut("design:paramtypes", []),
  Ut("design:returntype", void 0)
], na.prototype, "render", null);
na.style = Lo;
const Ro = ':host{display:block;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif;width:inherit}.nylas-participants-custom-availability{width:inherit;display:flex;flex-direction:column;margin:1rem;border-radius:var(--nylas-border-radius-2x);border:1px solid var(--nylas-base-200)}.nylas-participants-custom-availability .header{padding:1rem}.nylas-participants-custom-availability .header h3{margin:0;font-size:16px;font-weight:600;line-height:20px;color:var(--nylas-base-900);text-align:left}.nylas-participants-custom-availability .header p{margin:0.25rem 0 0 0;font-size:0.875rem;font-weight:400;line-height:20px;color:var(--nylas-base-600);text-align:left}.nylas-participants-custom-availability .content .participant-container{padding-top:8px;border-top:1px solid var(--nylas-base-200)}.nylas-participants-custom-availability .content .participant-container .participant-title{display:flex;justify-content:space-between;align-items:center;padding:4px 16px 12px}.nylas-participants-custom-availability .content .participant-container .participant-title p{margin:0}.nylas-participants-custom-availability .content .participant-container .participant-title .participant-toggle{display:flex;gap:24px;align-items:center}.nylas-participants-custom-availability .content .participant-container .participant-title .participant-toggle .chevron{display:flex;align-self:center;cursor:pointer}.nylas-participants-custom-availability .content .participant-container .participant-title .participant-toggle .chevron:hover,.nylas-participants-custom-availability .content .participant-container .participant-title .participant-toggle .chevron:active{color:var(--nylas-primary)}.nylas-participants-custom-availability .content .participant-container .participant-title .participant-toggle .chevron.open{transform:rotate(90deg)}.nylas-participants-custom-availability .content .participant-container .participant-title .participant-toggle .chevron.closed{transform:rotate(270deg)}.nylas-participants-custom-availability .content .participant-container .participant-title .participant-toggle .chevron.disabled{cursor:not-allowed;color:var(--nylas-base-300)}.nylas-participants-custom-availability .content .participant-container .participant-title .participant-toggle .chevron.disabled:hover{color:var(--nylas-base-300)}.nylas-participants-custom-availability .content .participant-container nylas-availability-picker::part(nap){margin:0;border:none}', Ao = Ro;
var zo = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, Vt = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const aa = class {
  constructor(e) {
    x(this, e), this.valueChanged = L(this, "valueChanged", 7), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals), this.selectedConfiguration = void 0, this.name = "participant-custom-availability", this.participants = void 0, this.selectedParticipants = this.setParticipants(this.participants);
  }
  elementNameChangedHandler(e) {
    d("nylas-participants-custom-availability", "elementNameChangedHandler", e), this.host.setAttribute("name", e);
  }
  selectedConfigurationChangedHandler(e, t) {
    d("nylas-participants-custom-availability", "selectedConfigurationChangedHandler", e, t), e != null && e.participants ? this.selectedParticipants = this.setParticipants(e == null ? void 0 : e.participants) : this.selectedParticipants = this.setParticipants(this.participants);
  }
  participantsChangedHandler(e, t) {
    d("nylas-participants-custom-availability", "participantsChangedHandler", e, t), this.selectedParticipants = this.setParticipants(e);
  }
  connectedCallback() {
    d("nylas-participants-custom-availability", "connectedCallback");
  }
  disconnectedCallback() {
    d("nylas-participants-custom-availability", "disconnectedCallback");
  }
  componentWillLoad() {
    d("nylas-participants-custom-availability", "componentWillLoad");
  }
  componentDidLoad() {
    d("nylas-participants-custom-availability", "componentDidLoad");
  }
  nylasFormSwitchToggledHandler(e) {
    d("nylas-participants-custom-availability", "nylasFormSwitchToggledHandler", e.detail), this.selectedParticipants[e.detail.name].isOpen = e.detail.checked, this.selectedParticipants[e.detail.name].setCustom = e.detail.checked, this.selectedParticipants = { ...this.selectedParticipants };
  }
  handleValueChanged(e) {
    d("[nylas-editor-tabs]", "handleValueChanged", e);
    const { name: t, value: n } = e.detail;
    if (!t.startsWith("participant-"))
      return;
    if (this.participantFormRef.checkValidity())
      this.internals.setValidity({});
    else {
      this.internals.setValidity({ customError: !0 }, "Please fix the overlapping time ranges.");
      return;
    }
    const a = JSON.parse(n), o = t.split("-")[2];
    if (!this.selectedParticipants[o])
      return;
    this.selectedParticipants[o].openHours = a.openHours, this.selectedParticipants = { ...this.selectedParticipants };
    const i = {};
    this.participants.forEach((s) => {
      i[s.email] = this.selectedParticipants[s.email].openHours;
    }), this.internals.setFormValue(JSON.stringify(i), this.name), this.valueChanged.emit({ value: JSON.stringify(i), name: this.name });
  }
  setParticipants(e) {
    const t = {};
    return e.forEach((n) => {
      var a, o;
      t[n.email] = {
        isOpen: !1,
        setCustom: !!((a = n.availability) != null && a.open_hours),
        openHours: ((o = n.availability) == null ? void 0 : o.open_hours) || [],
        name: n.name || n.email,
        availability: n.availability
      };
    }), t;
  }
  render() {
    return r(H, { key: "3e7cdcf9612c646be0b96633d387361a562f5894" }, r("div", { key: "42d1fa4e046a101f1ca5b80b640d3f3b619d9035", class: "nylas-participants-custom-availability", part: "npca" }, r("div", { key: "ec6d1290c374f5ced61f8dabcbcacb102e0427bc", class: "header", part: "npca__header" }, r("h3", { key: "26577e0fd9572ed513907f0307fe207de951c2bd" }, "Availability for participants"), r("p", { key: "7a287a227c278b6f9ccc6c6ec8beeca34d521cd0" }, "If not set, the general availability on the Availability tab is used.")), r("div", { key: "42794be072915fd5f42ce4905fba3d9ba9551b84", class: "content", part: "npca__content" }, r("form", { key: "5368bcc8efc3393666271c2a2082d5caf0c739b6", ref: (e) => this.participantFormRef = e }, Object.keys(this.selectedParticipants).map((e, t) => {
      var a, o;
      const n = this.selectedParticipants[e];
      if (!(!n || !n.name || !n.availability))
        return r("div", { class: "participant-container", part: "npca__participant-container", key: `participant-conatiner-${t}` }, r("div", { class: "participant-title", part: "npca__participant-title" }, r("p", null, "Set ", n.name, "'s custom availability"), r("div", { class: "participant-toggle", part: "npca__participant-toggle--container" }, r("toggle-switch", { exportparts: "ts_label: npca__toggle-label, ts_input: npca_toggle-input, ts_slider: npca_toggle-slider", name: e, checked: !!n.openHours && n.openHours.length > 0 }), r("span", { class: `chevron ${n.isOpen ? "open" : "closed"} ${n.setCustom ? "" : "disabled"}`, onClick: () => {
          n.setCustom && (this.selectedParticipants[e].isOpen = !n.isOpen, this.selectedParticipants = { ...this.selectedParticipants });
        } }, r("chevron-icon", { width: "24", height: "24" })))), n.isOpen && r("nylas-availability-picker", { key: t, name: `participant-${t}-${e}`, openHours: n.openHours, defaultTimezone: (o = (a = n.openHours) == null ? void 0 : a[0]) == null ? void 0 : o.timezone, hideHeader: !0 }));
    })))));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return $(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"],
      selectedConfiguration: ["selectedConfigurationChangedHandler"],
      participants: ["participantsChangedHandler"]
    };
  }
};
zo([
  M({
    name: "nylas-participants-custom-availability",
    stateToProps: /* @__PURE__ */ new Map([["schedulerConfig.selectedConfiguration", "selectedConfiguration"]]),
    eventToProps: {},
    fireRegisterEvent: !0
  }),
  Vt("design:type", Function),
  Vt("design:paramtypes", []),
  Vt("design:returntype", void 0)
], aa.prototype, "render", null);
aa.style = Ao;
const jo = ':host{display:block;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif;width:inherit}.cards-container{margin-bottom:4rem}.cards-container .nylas-reminder-email{width:inherit;display:flex;flex-direction:column;margin:1rem;border-radius:var(--nylas-border-radius-2x);border:1px solid var(--nylas-base-200);text-align:left}.cards-container .nylas-reminder-email .header{padding:1rem;display:grid;grid-template-columns:1fr auto;border-bottom:1px solid var(--nylas-base-200)}.cards-container .nylas-reminder-email .header h3{border-radius:var(--nylas-border-radius-2x);margin:0;font-size:1rem;font-weight:600;line-height:20px;color:var(--nylas-base-900);text-align:left}.cards-container .nylas-reminder-email .header p{margin:0.25rem 0 0 0;font-size:0.875rem;font-weight:400;line-height:20px;color:var(--nylas-base-600);text-align:left}.cards-container .nylas-reminder-email .header .confirmation-email-toggle{display:flex;gap:24px;align-items:center}.cards-container .nylas-reminder-email .header .confirmation-email-toggle .chevron{display:flex;align-self:center;cursor:pointer}.cards-container .nylas-reminder-email .header .confirmation-email-toggle .chevron:hover,.cards-container .nylas-reminder-email .header .confirmation-email-toggle .chevron:active{color:var(--nylas-primary)}.cards-container .nylas-reminder-email .header .confirmation-email-toggle .chevron.open{transform:rotate(90deg)}.cards-container .nylas-reminder-email .header .confirmation-email-toggle .chevron.closed{transform:rotate(270deg)}.cards-container .nylas-reminder-email .header .confirmation-email-toggle .chevron.disabled{cursor:not-allowed;color:var(--nylas-base-300)}.cards-container .nylas-reminder-email .header .confirmation-email-toggle .chevron.disabled:hover{color:var(--nylas-base-300)}.cards-container .nylas-reminder-email .nylas-reminder-email__body{display:grid;grid-template-columns:1fr auto;background-color:var(--nylas-base-25);border-radius:var(--nylas-border-radius-2x)}@media screen and (max-width: 768px){.cards-container .nylas-reminder-email .nylas-reminder-email__body{grid-template-columns:1fr}}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__section{padding:1rem;display:flex;flex-direction:column;gap:1rem;color:var(--nylas-base-800)}@media screen and (max-width: 768px){.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__section{border:none}}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__section .nylas-reminder-email__row{display:grid;grid-template-columns:1fr auto;align-items:center;gap:1rem}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__section .nylas-reminder-email__row.full-width-col{grid-template-columns:1fr}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__section .nylas-reminder-email__row label{display:flex;align-items:center}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__section .nylas-reminder-email__row label span.required{color:var(--nylas-error, #cc4841)}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__section .nylas-reminder-email__row label span.label-icon{margin-left:4px}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__section .nylas-reminder-email__row label span.label-icon tooltip-component{display:flex}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__section .nylas-reminder-email__row p{margin:0.25rem 0 0 0;font-size:1rem;font-weight:500;line-height:24px;color:var(--nylas-base-900)}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__section .nylas-reminder-email__row .company-logo-container{display:flex;gap:32px;width:100%}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__section .nylas-reminder-email__row .company-logo-container .input-container{display:flex;flex-direction:column;flex:1}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__section .nylas-reminder-email__row .company-logo-container .company-logo{display:flex;justify-content:center;align-items:center;width:200px;height:100px;border:var(--nylas-base-200) solid 1px;border-radius:var(--nylas-border-radius-2x);overflow:hidden;padding:10px}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__section .nylas-reminder-email__row .company-logo-container .company-logo img{height:100%;object-fit:cover;object-position:center}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__section .nylas-reminder-email__row span.selected-value{font-weight:500}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__section .subsection{display:flex;flex-direction:column;gap:1rem}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__section .subsection h3{margin:0;font-size:1rem;font-weight:600;line-height:20px;color:var(--nylas-base-900);text-align:left}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__section .subsection .input-container{display:flex;flex-direction:column;gap:0.25rem}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__section .subsection .input-container textarea{padding:12px 16px;border-width:1;resize:vertical;border-radius:8px;font-family:var(--nylas-font-family);font-size:16px;line-height:24px;border:1px solid var(--nylas-base-200)}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__preview{width:208px;background:var(--nylas-base-25);border-bottom-right-radius:var(--nylas-border-radius-2x)}@media screen and (max-width: 768px){.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__preview{width:inherit;border-bottom-left-radius:var(--nylas-border-radius-2x)}}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__preview h4{font-size:14px;line-height:24px;color:var(--nylas-base-600);font-family:var(--nylas-font-family);font-weight:500;text-align:center;margin:0.75rem 0}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__preview .preview-container{padding:0 2rem 1rem}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__preview .preview-container .slot{background-color:transparent;border-top:1px solid var(--nylas-base-300)}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__preview .preview-container .slot.active{background-color:var(--nylas-base-100)}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__preview .preview-container .slot:last-of-type{border-bottom:1px solid var(--nylas-base-300)}.cards-container .nylas-reminder-email .nylas-reminder-email__body .nylas-reminder-email__preview .preview-container .event-slot{background-color:var(--nylas-base-600);border-top:1px solid var(--nylas-base-300)}.cards-container .nylas-reminder-email .nylas-reminder-email__body span.error-message{color:var(--nylas-error)}.cards-container .nylas-reminder-email .nylas-reminder-email__body span.help-text{margin:0.25rem 0 0 0;font-size:0.875rem;font-weight:400;line-height:20px;color:var(--nylas-base-600);text-align:left}.cards-container .nylas-reminder-email .nylas-reminder-email__summary{padding:0.75rem 1rem;display:grid;grid-template-columns:auto 1fr;column-gap:1rem}.cards-container .nylas-reminder-email .nylas-reminder-email__summary p{margin:0;display:flex;align-items:center;column-gap:4px;font-size:0.875rem;font-weight:400;line-height:21px;color:var(--nylas-base-600);text-align:left}.cards-container .nylas-reminder-email .nylas-reminder-email__summary p span.summary-icon{display:flex;justify-content:center;min-width:20px}sp-divider{background-color:var(--nylas-base-200);height:1px;margin:0.25rem 0}button-component.create-reminder button{margin:1rem;width:calc(100% - 2rem)}button-component.delete-btn button{color:var(--nylas-error) !important}', Bo = jo;
var Wo = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, qt = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const ia = class {
  constructor(e) {
    x(this, e), this.valueChanged = L(this, "valueChanged", 7), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals), this.eventReminders = [], this.participants = [], this.name = "reminder-overrides", this.reminders = this.eventReminders ?? [], this.reminderErrors = {}, this.editingReminderIndex = null;
  }
  connectedCallback() {
    d("nylas-reminder-emails", "connectedCallback");
  }
  disconnectedCallback() {
    d("nylas-reminder-emails", "disconnectedCallback");
  }
  componentWillLoad() {
    d("nylas-reminder-emails", "componentWillLoad"), this.host.setAttribute("name", this.name);
  }
  componentDidLoad() {
    d("nylas-reminder-emails", "componentDidLoad"), this.updateRemindersFormValue();
  }
  componentWillUpdate() {
    d("nylas-reminder-emails", "componentWillUpdate");
  }
  componentDidUpdate() {
    d("nylas-reminder-emails", "componentDidUpdate");
  }
  componentWillRender() {
    d("nylas-reminder-emails", "componentWillRender");
  }
  componentDidRender() {
    d("nylas-reminder-emails", "componentDidRender");
  }
  elementNameChangedHandler(e) {
    d("nylas-reminder-emails", "elementNameChangedHandler", e), this.host.setAttribute("name", e);
  }
  handleValueChanged(e) {
    d("nylas-reminder-emails", "handleValueChanged", e);
    const { name: t, value: n } = e.detail;
    if (t.startsWith("reminder-time-")) {
      const [a, o] = t.split(/(\d+)/), i = [...this.reminders];
      i[o].reminder_minutes = parseInt(n), this.internals.setFormValue(JSON.stringify(i), "reminder-overrides"), this.valueChanged.emit({ value: JSON.stringify(i), name: "reminder-overrides" });
    }
  }
  addReminder() {
    d("nylas-reminder-emails", "addReminder"), this.reminders = [
      ...this.reminders,
      {
        reminder_method: "email",
        reminder_minutes: 30
      }
    ], this.editingReminderIndex = this.reminders.length - 1, this.updateRemindersFormValue();
  }
  deleteReminder(e) {
    this.reminders.splice(e, 1), this.editingReminderIndex = null, this.updateRemindersFormValue();
  }
  updateRemindersFormValue() {
    d("nylas-reminder-emails", "updateRemindersFormValue"), this.internals.setFormValue(JSON.stringify(this.reminders), "reminder-overrides"), this.valueChanged.emit({ value: JSON.stringify(this.reminders), name: "reminder-overrides" });
  }
  formatReminderTime(e) {
    switch (!0) {
      case e > 24 * 60:
        return `${e / 60 / 24} days`;
      case e === 24 * 60:
        return "1 day";
      case (e > 90 || e === 60):
        return `${e / 60} hours`;
      default:
        return `${e} minute${e > 1 ? "s" : ""} `;
    }
  }
  render() {
    var t;
    const e = (t = this.participants.find((n) => n.is_organizer)) == null ? void 0 : t.name;
    return r(H, { key: "3cfc38ae430db98fc5dee57f870e897b1410d8be" }, r("div", { key: "596e3dfd44c26789b707f4cffec8d764c7de3270", class: "cards-container" }, this.reminders.map((n, a) => r("div", { class: "nylas-reminder-email", part: "nre" }, r("div", { class: "header", part: "nre__header" }, r("div", null, r("h3", null, "Upcoming meeting", e ? ` with ${e} ` : ""), r("p", null, "Reminder before event")), this.editingReminderIndex !== a ? r("button-component", { variant: "basic", key: `edit-${a} `, clickHandler: (o) => {
      o.preventDefault(), this.editingReminderIndex = a;
    } }, r("edit-icon", { width: "16", height: "16" }), "Edit") : r("button-component", { variant: "basic", class: "delete-btn", key: `delete -${a} `, clickHandler: (o) => {
      o.preventDefault(), this.deleteReminder(a);
    } }, r("trash-icon", { width: "16", height: "16" }))), this.editingReminderIndex === a ? r("div", { class: "nylas-reminder-email__body", part: "nre__body" }, r("div", { class: "nylas-reminder-email__section" }, r("div", { class: "nylas-reminder-email__row" }, r("label", null, "Send confirmation email when", r("span", { class: "label-icon" }, r("tooltip-component", null, r("info-icon", { slot: "tooltip-icon" }), r("span", { slot: "tooltip-content" }, "You and your guests will receive a confirmation immediately after your booking is set up.")))), r("nylas-reminder-time", { name: `reminder-time-${a}`, eventReminderTimeMinutes: n.reminder_minutes, exportparts: `nrt, nrt__input_dropdown: nre__reminder-input_dropdown,
                          nrt__input_dropdown-input: nre__reminder-input_dropdown-input,
                          nrt__input_dropdown-content: nre__reminder-input_dropdown-content,
                          ` })))) : r("div", { class: "nylas-reminder-email__summary", part: "nre__summary" }, r("p", null, r("span", { class: "summary-icon" }, r("person-clipboard-icon", null)), "All host & guests"), r("p", null, r("span", { class: "summary-icon" }, r("clock-icon", null)), this.formatReminderTime(n.reminder_minutes), " before the event"))))), r("button-component", { key: "3dcd4239f36ad43b16edb0e380876d20c5287d74", class: "create-reminder", variant: "basic", clickHandler: (n) => {
      n.preventDefault(), this.addReminder();
    } }, r("plus-icon", { key: "1931918cc635f1360fb30cbeb77ef8edac3d6dce", width: "16", height: "16" }), "New reminder"));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return $(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"]
    };
  }
};
Wo([
  M({
    name: "nylas-reminder-emails",
    stateToProps: /* @__PURE__ */ new Map([["schedulerConfig.eventReminders", "reminders"]]),
    eventToProps: {
      valueChanged: async (e, t) => {
        const { valueChanged: n } = e.detail;
        n && n(e);
      }
    },
    fireRegisterEvent: !0
  }),
  qt("design:type", Function),
  qt("design:paramtypes", []),
  qt("design:returntype", void 0)
], ia.prototype, "render", null);
ia.style = Bo;
const Zo = ':host{display:block;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif}.nylas-reminder-time{display:flex;flex-direction:column;gap:4px}.nylas-reminder-time label{display:flex;align-items:center;color:var(--nylas-base-800);font-size:16px;font-style:normal;font-weight:400;line-height:150%;}.nylas-reminder-time label span.required{color:var(--nylas-error, #cc4841)}.nylas-reminder-time label span.label-icon{margin-left:4px}.nylas-reminder-time label span.label-icon tooltip-component{display:flex}.nylas-reminder-time__wrapper{display:flex;align-items:center;gap:0.5rem}.nylas-reminder-time__wrapper input{padding:12px 16px;border-width:1;border-radius:8px;border:1px solid var(--nylas-base-200);font-family:var(--nylas-font-family);font-size:16px;line-height:24px;width:48px}.nylas-reminder-time__wrapper input-dropdown::part(id_dropdown-input){border:1px solid var(--nylas-base-200);border-radius:var(--nylas-border-radius-2x);padding:14px 16px;width:50px}.nylas-reminder-time__wrapper input-dropdown::part(id_dropdown-content){width:100%;min-width:unset;height:160px}.nylas-reminder-time__wrapper select-dropdown{width:120px}@media screen and (max-width: 768px){.nylas-reminder-time__wrapper select-dropdown{width:100%}}.nylas-reminder-time__wrapper select-dropdown::part(sd_dropdown-button){border:1px solid var(--nylas-base-200)}', Uo = Zo;
var Vo = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, Gt = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
function qo(e) {
  return e ? e >= 60 * 24 ? e / (60 * 24) : e >= 90 || e === 60 ? e / 60 : e : 30;
}
function Go(e) {
  return e ? e >= 60 * 24 ? 60 * 24 : e >= 90 || e === 60 ? 60 : 1 : 30;
}
const oa = class {
  constructor(e) {
    x(this, e), this.valueChanged = L(this, "valueChanged", 7), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals), this.selectedConfiguration = void 0, this.name = "reminder-time", this.eventReminderTimeMinutes = void 0, this.reminderTime = qo(this.eventReminderTimeMinutes), this.reminderTimeMinutes = this.eventReminderTimeMinutes ?? 30, this.reminderTimeincrement = Go(this.eventReminderTimeMinutes), this.reminderTimeMinutesOptions = fn;
  }
  elementNameChangedHandler(e) {
    d("nylas-reminder-time", "elementNameChangedHandler", e), this.host.setAttribute("name", e);
  }
  reminderTimeMinutesChangedHandler(e, t) {
    d("nylas-reminder-time", "reminderTimeMinutesChangedHandler", e), e !== t && this.valueChanged.emit({ value: e.toString(), name: this.name });
  }
  connectedCallback() {
    d("nylas-reminder-time", "connectedCallback");
  }
  componentWillLoad() {
    d("nylas-reminder-time", "componentWillLoad"), this.host.setAttribute("name", this.name), this.setReminderTimeMinuteOptions();
  }
  componentDidLoad() {
    d("nylas-reminder-time", "componentDidLoad");
  }
  disconnectedCallback() {
    d("nylas-reminder-time", "disconnectedCallback");
  }
  setReminderTimeMinuteOptions() {
    return this.reminderTimeincrement === 1 ? this.reminderTimeMinutesOptions = fn : this.reminderTimeincrement === 60 ? this.reminderTimeMinutesOptions = ma : this.reminderTimeMinutesOptions = ua, this.reminderTimeMinutesOptions;
  }
  nylasFormDropdownChangedHandler(e) {
    d("nylas-calendar-picker", "nylasFormDropdownChangedHandler", e.detail);
    const { value: t } = e.detail;
    this.reminderTimeincrement = parseInt(t), this.reminderTimeincrement === 1 ? this.reminderTime = 60 : this.reminderTime = 1, this.setReminderTimeMinuteOptions(), this.reminderTimeMinutes = this.reminderTime * this.reminderTimeincrement, this.internals.setFormValue(this.reminderTimeMinutes.toString(), this.name);
  }
  inputOptionChangedHandler(e) {
    d("nylas-calendar-picker", "inputOptionChangedHandler", e.detail);
    const { value: t } = e.detail;
    this.reminderTime = t, this.reminderTimeMinutes = this.reminderTime * this.reminderTimeincrement, this.internals.setFormValue(this.reminderTimeMinutes.toString(), this.name);
  }
  render() {
    const e = [
      { value: 1, label: "minute" },
      { value: 60, label: "hour" },
      { value: 1440, label: "day" }
    ];
    return r(H, { key: "2ec181327a9701da34f0665da9cbb712e94e96fd" }, r("div", { key: "37df33a4e4954e8351c9057f820e7e0cd6e4209f", class: "nylas-reminder-time", part: "nrt" }, r("div", { key: "99ff7c8b35c89a5c026eb35677ecd8445db03e11", class: "nylas-reminder-time__wrapper" }, r("input-dropdown", { key: "1a8ce26723d9227cd46100127e3cbc7cb5ce11e0", name: "reminder-time", options: this.reminderTimeMinutesOptions, inputValue: this.reminderTime.toString(), exportparts: "id_dropdown: nrt__input_dropdown, id_dropdown-input: nrt__input_dropdown-input, id_dropdown-content: nrt__input_dropdown-content", defaultInputOption: this.reminderTimeMinutesOptions.find((t) => t.value == this.reminderTime) ?? e[0] }), r("select-dropdown", { key: "d6b9b9093cff0939c6f12f3fa2d2b4b5c925a26e", name: "reminder-time-unit", options: e, pluralizedLabel: this.reminderTime > 1 ? "s" : "", exportparts: "sd_dropdown: nrt__dropdown, sd_dropdown-button: nrt__dropdown-button, sd_dropdown-content: nrt__dropdown-content", defaultSelectedOption: e.find((t) => t.value == this.reminderTimeincrement) ?? e[0], withSearch: !1 }))));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return $(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"],
      reminderTimeMinutes: ["reminderTimeMinutesChangedHandler"]
    };
  }
};
Vo([
  M({
    name: "nylas-reminder-time",
    stateToProps: /* @__PURE__ */ new Map([["schedulerConfig.selectedConfiguration", "selectedConfiguration"]]),
    eventToProps: {},
    fireRegisterEvent: !0
  }),
  Gt("design:type", Function),
  Gt("design:paramtypes", []),
  Gt("design:returntype", void 0)
], oa.prototype, "render", null);
oa.style = Uo;
const Yo = ':host{display:block;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif;width:inherit}.nylas-timeslot-interval{width:inherit;display:flex;flex-direction:column;margin:1rem;border-radius:var(--nylas-border-radius-2x);border:1px solid var(--nylas-base-200)}.nylas-timeslot-interval .header{padding:1rem;border-bottom:1px solid var(--nylas-base-200)}.nylas-timeslot-interval .header h3{margin:0;font-size:1rem;font-weight:600;line-height:20px;color:var(--nylas-base-900);text-align:left}.nylas-timeslot-interval .header p{margin:0.25rem 0 0 0;font-size:0.875rem;font-weight:400;line-height:20px;color:var(--nylas-base-600);text-align:left}.nylas-timeslot-interval .nylas-timeslot-interval__dropdown{padding:1rem;display:flex;flex-direction:column;gap:4px}.nylas-timeslot-interval .nylas-timeslot-interval__dropdown span.label{display:flex;align-items:center;gap:4px;color:var(--nylas-base-800)}.nylas-timeslot-interval .nylas-timeslot-interval__dropdown span.label tooltip-component{display:flex}.nylas-timeslot-interval .nylas-timeslot-interval__dropdown select-dropdown{margin-bottom:1.5rem}.nylas-timeslot-interval .nylas-timeslot-interval__dropdown select-dropdown::part(sd_dropdown){width:100%}.nylas-timeslot-interval .nylas-timeslot-interval__dropdown select-dropdown::part(sd_dropdown-content){width:100%;max-width:unset}.nylas-timeslot-interval .nylas-timeslot-interval__dropdown select-dropdown::part(sd_dropdown-button){width:100%;display:flex;justify-content:space-between;align-items:center;border:1px solid var(--nylas-base-200);border-radius:var(--nylas-border-radius-2x);padding:1rem}.nylas-timeslot-interval .nylas-timeslot-interval__dropdown select-dropdown::part(sd_dropdown-button-selected-label){max-width:calc(100% - 2rem);font-family:var(--nylas-font-family);font-size:16px;line-height:24px}', Jo = Yo;
var Xo = function(e, t, n, a) {
  var o = arguments.length, i = o < 3 ? t : a === null ? a = Object.getOwnPropertyDescriptor(t, n) : a, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, t, n, a);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (s = e[l]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, Yt = function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const at = 15, ra = class {
  constructor(e) {
    var t, n, a, o, i, s;
    x(this, e), this.valueChanged = L(this, "valueChanged", 7), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals), this.selectedConfiguration = void 0, this.name = "timeslot-picker", this.eventDurationMinutes = (n = (t = this.selectedConfiguration) == null ? void 0 : t.availability) == null ? void 0 : n.duration_minutes, this.defaultIntervalMinutes = ((o = (a = this.selectedConfiguration) == null ? void 0 : a.availability) == null ? void 0 : o.interval_minutes) ?? this.eventDurationMinutes ?? 10, this.defaultRoundTo = ((s = (i = this.selectedConfiguration) == null ? void 0 : i.availability) == null ? void 0 : s.round_to) ?? void 0, this.selectedInterval = this.defaultIntervalMinutes, this.selectedRoundTo = !!(this.defaultRoundTo && this.defaultRoundTo === this.defaultIntervalMinutes);
  }
  elementNameChangedHandler(e) {
    d("nylas-timeslot-interval", "elementNameChangedHandler", e), this.host.setAttribute("name", e);
  }
  selectedConfigurationChangedHandler(e) {
    var t, n;
    d("nylas-timeslot-interval", "selectedConfigurationChangedHandler", e), this.defaultIntervalMinutes = ((t = e.availability) == null ? void 0 : t.interval_minutes) ?? this.eventDurationMinutes ?? 10, this.defaultRoundTo = ((n = e.availability) == null ? void 0 : n.round_to) ?? void 0, this.selectedInterval = this.defaultIntervalMinutes, this.selectedRoundTo = !!(this.defaultRoundTo && this.defaultRoundTo === this.defaultIntervalMinutes);
  }
  connectedCallback() {
    d("nylas-timeslot-interval", "connectedCallback");
  }
  disconnectedCallback() {
    d("nylas-timeslot-interval", "disconnectedCallback");
  }
  componentWillLoad() {
    d("nylas-timeslot-interval", "componentWillLoad"), this.host.setAttribute("name", this.name);
  }
  componentDidLoad() {
    d("nylas-timeslot-interval", "componentDidLoad");
  }
  componentWillUpdate() {
    d("nylas-timeslot-interval", "componentWillUpdate");
  }
  componentDidUpdate() {
    d("nylas-timeslot-interval", "componentDidUpdate");
  }
  componentWillRender() {
    d("nylas-timeslot-interval", "componentWillRender");
  }
  componentDidRender() {
    d("nylas-timeslot-interval", "componentDidRender");
  }
  nylasFormDropdownChangedHandler(e) {
    d("nylas-timeslot-interval", "nylasFormDropdownChangedHandler", e.detail), e.detail.value === "duration" ? this.selectedInterval = this.eventDurationMinutes ?? 10 : this.selectedInterval = parseInt(e.detail.value), console.log("nylasFormDropdownChanged selectedRoundTo", this.selectedRoundTo), this.valueChanged.emit({
      value: JSON.stringify({
        interval: this.selectedInterval,
        roundTo: this.selectedRoundTo ? this.selectedInterval : at
      }),
      name: this.name
    }), typeof this.internals.setFormValue == "function" && this.internals.setFormValue(JSON.stringify({ interval: this.selectedInterval, roundTo: this.selectedRoundTo ? this.selectedInterval : at }), this.name);
  }
  nylasFormRadioChangedHandler(e) {
    d("nylas-timeslot-interval", "nylasFormRadioChangedHandler", e.detail), e.detail.value === "no-rounding" ? this.selectedRoundTo = !1 : this.selectedRoundTo = !0, this.valueChanged.emit({
      value: JSON.stringify({
        interval: this.selectedInterval,
        roundTo: this.selectedRoundTo ? this.selectedInterval : at
      }),
      name: this.name
    }), typeof this.internals.setFormValue == "function" && this.internals.setFormValue(JSON.stringify({ interval: this.selectedInterval, roundTo: this.selectedRoundTo ? this.selectedInterval : at }), this.name);
  }
  render() {
    const e = [
      { value: "duration", label: "Length of the booking" },
      { value: "5", label: "5 mins" },
      { value: "10", label: "10 mins" },
      { value: "15", label: "15 mins" },
      { value: "20", label: "20 mins" },
      { value: "30", label: "30 mins" },
      { value: "45", label: "45 mins" },
      { value: "60", label: "60 mins" }
    ];
    return r(H, { key: "f46d995f81a30d766f166f6406a88603cbf3aaad" }, r("div", { key: "89cc8ff75644f16328205c1677df1fa9aee086ea", class: "nylas-timeslot-interval", part: "nti" }, r("div", { key: "8ed89ff973d98c269af29df4a2ccd8ebf2fe415c", class: "header", part: "nti__header" }, r("h3", { key: "b2052070054abe534e94fdbc83e9e3b8749c7bdb" }, "Time slot settings"), r("p", { key: "9983c59b0d36ea78ea75d7301cca3ec773313711" }, "Manage time slot settings.")), r("div", { key: "f947dad8c35ce7bdebafc14395e9f202222c72a4", class: "nylas-timeslot-interval__dropdown" }, r("span", { key: "781db086cd3f5352567d030875f91e8ab5ab93c7", class: "label", part: "nti__input-label" }, "Select a time slot interval."), r("select-dropdown", { key: "748390b781597665c9d6f9282cfff7f7783e6f5e", name: "booking-calendar", options: e, withSearch: !1, exportparts: "sd_dropdown: nti__dropdown, sd_dropdown-button: nti__dropdown-button, sd_dropdown-content: nti__dropdown-content", defaultSelectedOption: this.defaultIntervalMinutes == this.eventDurationMinutes ? e[0] : e.find((t) => t.value == this.defaultIntervalMinutes.toString()) ?? e[0] }), r("span", { key: "15d7e72899d23790467ea37436029b85c50f06da", slot: "label", class: "label", part: "nti__input-label" }, "Select the time slot rounding type", r("tooltip-component", { key: "80bd3ba58556cc02168469b4aea622b48e215077" }, r("info-icon", { key: "a32cdad56ac56113b81580ba5e251af7fb55fc69", slot: "tooltip-icon" }), r("span", { key: "4581e65a2f99acc382570d7953151a8c44543771", slot: "tooltip-content" }, "Select if you want to round the time slots to the nearest interval."))), r("radio-button-group", { key: "53f515d33d71b30fc1f2027363a171f5d150e730", name: "interval-preference", defaultSelectedValue: this.defaultRoundTo && this.defaultRoundTo === this.defaultIntervalMinutes ? "rounding" : "no-rounding", options: [
      { value: "no-rounding", label: "Default", description: "Time slots will be rounded to the nearest quarter-hour." },
      {
        value: "rounding",
        label: "Interval rounding",
        description: "Time slots will begin at times rounded to the interval value."
      }
    ] }))));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return $(this);
  }
  static get watchers() {
    return {
      name: ["elementNameChangedHandler"],
      selectedConfiguration: ["selectedConfigurationChangedHandler"]
    };
  }
};
Xo([
  M({
    name: "nylas-timeslot-interval",
    stateToProps: /* @__PURE__ */ new Map([["schedulerConfig.selectedConfiguration", "selectedConfiguration"]]),
    fireRegisterEvent: !0
  }),
  Yt("design:type", Function),
  Yt("design:paramtypes", []),
  Yt("design:returntype", void 0)
], ra.prototype, "render", null);
ra.style = Jo;
const Ko = ".sc-people-icon-h{display:flex}", Qo = Ko, er = class {
  constructor(e) {
    x(this, e), this.width = "20", this.height = "20";
  }
  render() {
    return r("svg", { key: "c0b42ce25c143f5a4491e86096519df9714de964", xmlns: "http://www.w3.org/2000/svg", width: this.width, height: this.height, fill: "none", viewBox: "0 0 20 20" }, r("path", { key: "228134d8ca11767c736d97cb09b418a4d8c42f8c", fill: "currentColor", d: "M11 10a2 2 0 0 1 2 2v1.5c0 2.054-2.088 3.5-5.5 3.5S2 15.554 2 13.5V12a2 2 0 0 1 2-2h7Zm0 1H4a1 1 0 0 0-1 1v1.5C3 14.907 4.579 16 7.5 16c2.921 0 4.5-1.093 4.5-2.5V12a1 1 0 0 0-1-1Zm5-1a2 2 0 0 1 2 2v.5c0 2.089-1.568 3.5-4.5 3.5-.141 0-.28-.003-.414-.01.208-.242.382-.502.522-.781l.097-.213h.039C15.976 14.931 17 13.96 17 12.5V12a1 1 0 0 0-1-1h-2.171a3 3 0 0 0-.594-1H16ZM7.5 2a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm7 2a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm-7-1a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm7 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" }));
  }
};
er.style = Qo;
const tr = '.switch{--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif;display:inline-block;height:34px;position:relative;width:60px}.switch input{display:none}.slider{background-color:var(--nylas-base-300);bottom:0;cursor:pointer;left:0;position:absolute;right:0;top:0;transition:0.4s}.slider:before{background-color:var(--nylas-base-0);bottom:4px;content:"";height:32px;left:4px;position:absolute;transition:0.4s;width:32px}input:checked+.slider{background-color:var(--nylas-success)}input:checked+.slider:before{transform:translateX(32px)}.slider.round{border-radius:35px;width:72px;height:40px}.slider.round:before{border-radius:50%}', nr = tr, ar = class {
  constructor(e) {
    x(this, e), this.nylasFormSwitchToggled = L(this, "nylasFormSwitchToggled", 7), this.name = "toggle-switch", this.checked = !1, this.label = "", this.isChecked = this.checked;
  }
  componentWillLoad() {
    this.isChecked = this.checked;
  }
  toggleCheck() {
    this.isChecked = !this.isChecked, this.nylasFormSwitchToggled.emit({
      checked: this.isChecked,
      name: this.name,
      label: this.label
    });
  }
  render() {
    return r("label", { key: "959db7dc3d4e06d86f71d28651401e0447e7d346", class: "switch", part: "ts_label" }, r("input", { key: "ebec5634fa29291332efbf403f47db366e5669cf", type: "checkbox", part: "ts_input", name: this.name, checked: this.isChecked, onChange: () => this.toggleCheck() }), r("div", { key: "1618e02ee6386bc8b155c5a25fdd447bf020fa67", class: "slider round", part: "ts_slider" }));
  }
};
ar.style = nr;
const ir = ".sc-trash-icon-h{display:flex}", or = ir, rr = class {
  constructor(e) {
    x(this, e), this.width = "20", this.height = "21";
  }
  render() {
    return r("svg", { key: "457dc40018ce97f25b8f5288dd10ddfef7748112", width: this.width, height: this.height, viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, r("path", { key: "d3d713285c70f97aa0489e8b2357791f5b3fc624", d: "M10 0.25C11.733 0.25 13.1492 1.60645 13.2449 3.31558L13.25 3.5H18.5C18.9142 3.5 19.25 3.83579 19.25 4.25C19.25 4.6297 18.9678 4.94349 18.6018 4.99315L18.5 5H17.704L16.4239 18.0192C16.2912 19.3683 15.1984 20.41 13.8626 20.4945L13.6871 20.5H6.31293C4.95734 20.5 3.81365 19.5145 3.59883 18.1934L3.57614 18.0192L2.295 5H1.5C1.1203 5 0.806509 4.71785 0.756847 4.35177L0.75 4.25C0.75 3.8703 1.03215 3.55651 1.39823 3.50685L1.5 3.5H6.75C6.75 1.70507 8.20507 0.25 10 0.25ZM16.197 5H3.802L5.06893 17.8724C5.12768 18.4696 5.60033 18.9343 6.18585 18.9936L6.31293 19H13.6871C14.2872 19 14.7959 18.5751 14.9123 17.9982L14.9311 17.8724L16.197 5ZM11.75 7.75C12.1297 7.75 12.4435 8.03215 12.4932 8.39823L12.5 8.5V15.5C12.5 15.9142 12.1642 16.25 11.75 16.25C11.3703 16.25 11.0565 15.9678 11.0068 15.6018L11 15.5V8.5C11 8.08579 11.3358 7.75 11.75 7.75ZM8.25 7.75C8.6297 7.75 8.94349 8.03215 8.99315 8.39823L9 8.5V15.5C9 15.9142 8.66421 16.25 8.25 16.25C7.8703 16.25 7.55651 15.9678 7.50685 15.6018L7.5 15.5V8.5C7.5 8.08579 7.83579 7.75 8.25 7.75ZM10 1.75C9.08183 1.75 8.32881 2.45711 8.2558 3.35647L8.25 3.5H11.75C11.75 2.5335 10.9665 1.75 10 1.75Z", fill: "currentColor" }));
  }
};
rr.style = or;
const sr = ".sc-zoom-icon-h{display:flex}", lr = sr, dr = class {
  constructor(e) {
    x(this, e), this.width = "20", this.height = "20";
  }
  render() {
    return r("svg", { key: "95e078e8d3a18451f67c841f7c79b4b9f5aa5caf", width: this.width, height: this.height, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, r("path", { key: "d103a2f8f10f7933d1a2c319ca968b1342e355bf", d: "M19.7495 6.85792C19.2077 3.4745 16.5255 0.792345 13.1421 0.250451C12.1175 0.0865155 11.0702 0 10 0C8.92992 0 7.88256 0.0865155 6.85797 0.250451C3.47453 0.792345 0.792373 3.4745 0.250478 6.85792C0.0865433 7.87796 0 8.92987 0 10C0 11.0701 0.0865433 12.1175 0.250478 13.1421C0.792373 16.5255 3.47453 19.2077 6.85797 19.7495C7.88256 19.9135 8.92992 20 10 20C11.0702 20 12.1175 19.9135 13.1421 19.7495C16.5255 19.2077 19.2077 16.5255 19.7495 13.1421C19.9135 12.122 20 11.0701 20 10C20 8.92987 19.9135 7.88251 19.7495 6.85792Z", fill: "url(#paint0_linear_22_6272)" }), r("path", { key: "3dc008e4988eba935a1423d2e9617477cf6094d8", d: "M12.154 12.1676C12.154 12.7596 11.6759 13.2377 11.0839 13.2377H6.42995C5.24598 13.2377 4.28516 12.2769 4.28516 11.0929V7.87794C4.28516 7.28596 4.76328 6.80786 5.35527 6.80786H10.0092C11.1932 6.80786 12.154 7.7687 12.154 8.95267V12.1676ZM14.8589 7.09475L13.2879 8.27412C13.0193 8.47448 12.8598 8.79324 12.8598 9.13022V10.9153C12.8598 11.2523 13.0193 11.5711 13.2879 11.7714L14.8589 12.9508C15.2141 13.2149 15.715 12.9645 15.715 12.5228V7.5228C15.715 7.08109 15.2096 6.83063 14.8589 7.09475Z", fill: "white" }), r("defs", { key: "0fad58c5b7e753414a3d0976de38b185e74cf1e7" }, r("linearGradient", { key: "3d7e958728dcdc56fac336522926309d952ab411", id: "paint0_linear_22_6272", x1: "10", y1: "19.9954", x2: "10", y2: "-0.00455379", gradientUnits: "userSpaceOnUse" }, r("stop", { key: "a124e8dbfa250f7fe291aa7ff2f6c6b040ef8bad", "stop-color": "#003FAE" }), r("stop", { key: "0089a986d350f08514d79969a53916cbc4495e16", offset: "0.02", "stop-color": "#0142B7" }), r("stop", { key: "0cc898c7b2924733545766dd9d8c3756285048a7", offset: "0.09", "stop-color": "#044BD1" }), r("stop", { key: "f28b780d8b1c551533822316314d8e4dae83f124", offset: "0.16", "stop-color": "#0752E5" }), r("stop", { key: "37df4a982d0ab10b415d64b6baeba7aebeb6d0fd", offset: "0.24", "stop-color": "#0958F4" }), r("stop", { key: "1c3fc8f5664bee790e74f27ef5946e6f64cc97dd", offset: "0.34", "stop-color": "#0A5BFC" }), r("stop", { key: "f585821ec1417732fb10803e9f3b22cbe820ba02", offset: "0.5", "stop-color": "#0B5CFF" }))));
  }
};
dr.style = lr;
export {
  ba as calendar_agenda_fill_icon,
  _a as calendar_agenda_icon,
  xa as calendar_info_icon,
  Da as calendar_patterns_icon,
  Ta as dragable_icon,
  $a as envelope_fill_icon,
  Na as envelope_icon,
  Ra as flow_icon,
  ja as google_meet_icon,
  Za as location_icon,
  qa as location_off_icon,
  Ja as microsoft_teams_icon,
  kn as nylas_additional_participants,
  En as nylas_availability_picker,
  Dn as nylas_booking_calendar_picker,
  zn as nylas_booking_form_config,
  jn as nylas_buffer_time,
  Bn as nylas_calendar_picker,
  Wn as nylas_cancellation_policy,
  Zn as nylas_confirmation_email,
  Un as nylas_connected_calendars,
  Vn as nylas_customize_booking_settings,
  qn as nylas_event_description,
  Gn as nylas_event_duration,
  Yn as nylas_event_info,
  Jn as nylas_event_limits,
  Xn as nylas_event_location,
  Kn as nylas_event_title,
  Qn as nylas_limit_future_bookings,
  ea as nylas_min_booking_notice,
  ta as nylas_min_cancellation_notice,
  na as nylas_participant_booking_calendars,
  aa as nylas_participants_custom_availability,
  ia as nylas_reminder_emails,
  oa as nylas_reminder_time,
  ra as nylas_timeslot_interval,
  er as people_icon,
  ar as toggle_switch,
  rr as trash_icon,
  dr as zoom_icon
};
